/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

// Global Rebuy Api Key
var storeUrl = Shopify.shop;
var REBUY_API_KEY;
let currentPage = location.href;
let collectionPage = currentPage.includes("collections");
let productPage = currentPage.includes("/product");
let isSearch = currentPage.includes("search-results");
if (storeUrl === "japancratestore.myshopify.com") {
  REBUY_API_KEY = "4318b26cda0fd959661ab467254d6519576c326b";
} else if (storeUrl === "bokksugrocery.myshopify.com") {
  REBUY_API_KEY = "8000c29e79ae4b4a117228c4bcaf89e80ce175af";
} else if (
  storeUrl === "bokksu.myshopify.com" ||
  storeUrl === "bokksuboutique.myshopify.com"
) {
  REBUY_API_KEY = "544602285c99b524bbea03795786138a9f7a2097";
} else if (storeUrl === "b-grocery-staging.myshopify.com") {
  REBUY_API_KEY = "edb7783ba066f34661d0b9674e8187e9518c0c61";
}

// Make a GET request to the cart JSON endpoint
$.ajax({
  type: "GET",
  url: "/cart.js",
  dataType: "json",
  success: function (cart) {
    // Access the cart items
    let items = cart.items;

    for (var i = 0; i < items.length; i++) {
      let item = items[i];
      console.log("cart items here", item);

      if (
        item.variant_id === 41663894126787 &&
        item.product_title === "Japanese Kit Kat: Variety Pack (3-pack)"
      ) {
        $(".vertical-line--right.product-weight").addClass("kitItem");
      }
    }
  },
  error: function (XMLHttpRequest, textStatus, errorThrown) {
    console.log("Error: " + errorThrown);
  },
});

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: "screen and (max-width: " + 769 + "px)",
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch:
    "ontouchstart" in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
      ? true
      : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute("dir") == "rtl" ? true : false,
};
theme.recentlyViewedIds = [];

if (theme.config.isTouch) {
  document.documentElement.className += " supports-touch";
}

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

// Free Gift Customization
let freeGiftOneVariantId = null;
let freeGiftTwoVariantId = null;
let freeGiftOneExistInCart = false;
let freeGiftTwoExistInCart = false;
let hostname = window.location.hostname;

var waitForEl = function (selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function () {
      waitForEl(selector, callback);
    }, 100);
  }
};

(function () {
  "use strict";
  if (
    window.location.pathname === "/collections/all" ||
    window.location.pathname === "/collections"
  ) {
    window.location.href = "/collections/all-products";
  }

  function watchOpacity(selector, targetOpacity, interval, callback) {
    var previousOpacity = null;
    var checkInterval = setInterval(function () {
      var element = $(selector);
      var currentOpacity = parseFloat(element.css("opacity"));

      if (previousOpacity !== currentOpacity) {
        if (typeof callback === "function") {
          callback(currentOpacity);
        }
        previousOpacity = currentOpacity;
      }
    }, interval);
  }

  function isMobile() {
    const regex =
      /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
  }

  document.addEventListener("userway:render_completed", function (event) {
    setTimeout(function () {
      let uwOpacity = $(".uwy.uen .uai .check_on").css("opacity");

      if (uwOpacity == "1") {
        // if (!isMobile()) {
        //   $(".site-header__logo-link").focus();
        // }
        // $('#isp_filter_menu').hide();
        // $('.customer-loved, .rebuy-widget-container .widget-display-embed .is-visible, .yotpo-main-widget, .index-section--sub-product, #isp_refine_nevigation, #isp_sorting_drop_container, #isp_filter_menu,.rebuy-widget').hide();
      } else {
        // $(".site-header__logo-link").blur();
        // $('#isp_filter_menu').show();
        //  $('.customer-loved, .rebuy-widget-container .widget-display-embed .is-visible, .yotpo-main-widget, .index-section--sub-product, #isp_refine_nevigation, #isp_sorting_drop_container, #isp_filter_menu,.rebuy-widget').show();
      }
    }, 500);

    $("#userwayAccessibilityIcon").on("touchstart click", function () {
      watchOpacity(".uwy .uai .check_on", 1, 100, function (opacity) {
        // $(".site-header__logo-link").focus();
        // $('#isp_filter_menu').hide();
        // $('.customer-loved, .rebuy-widget-container .widget-display-embed .is-visible, .yotpo-main-widget, .index-section--sub-product, #isp_refine_nevigation, #isp_sorting_drop_container, #isp_filter_menu,.rebuy-widget').hide()
      });

      watchOpacity(".uwy .uai .check_on", 0, 100, function (opacity) {
        // $(".site-header__logo-link").blur();
        // $('.customer-loved, .rebuy-widget-container .widget-display-embed .is-visible, .yotpo-main-widget, .index-section--sub-product, #isp_refine_nevigation, #isp_sorting_drop_container, #isp_filter_menu,.rebuy-widget').show()
        // Do something whenever the opacity changes to 0
      });
    });
  });

  waitForEl("#myFrame", function () {
    // work the magic
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutationRecord) {
        const el = $("#myFrame").attr("style");
        console.log("el", el);
        if (el.includes("none")) {
          let cartCookie = localStorage.getItem("cartCookie");
          document.cookie =
            "cart=" +
            cartCookie +
            "; expires=Thu, 18 Dec 3030 12:00:00 UTC; path=/";
          $("#websiteOverlay").attr("style", "display: none !important");
        }
      });
    });

    var target = document.getElementById("myFrame");
    observer.observe(target, { attributes: true, attributeFilter: ["style"] });
  });

  var pathname = window.location.pathname;

  if (pathname == "/cart") {
    window.location = "/";
  } else if (pathname == "/" && document.referrer.includes("/cart")) {
    const observer = new MutationObserver((mutations, obs) => {
      const HeaderCartTrigger = document.getElementById("HeaderCartTrigger");

      if (HeaderCartTrigger) {
        $("#HeaderCartTrigger")[0].click();
        obs.disconnect();
        return;
      }
    });
    observer.observe(document, {
      childList: true,
      subtree: true,
    });
  }
  theme.delegate = {
    on: function (event, callback, options) {
      if (!this.namespaces)
        // save the namespaces on the DOM element itself
        this.namespaces = {};

      this.namespaces[event] = callback;
      options = options || false;

      this.addEventListener(event.split(".")[0], callback, options);
      return this;
    },
    off: function (event) {
      if (!this.namespaces) {
        return;
      }
      this.removeEventListener(event.split(".")[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    },
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    defaultTo: function (value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    },

    wrap: function (el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },

    debounce: function (wait, callback, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      };
    },

    throttle: function (limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      };
    },

    prepareTransition: function (el, callback) {
      el.addEventListener("transitionend", removeClass);

      function removeClass(evt) {
        el.classList.remove("is-transitioning");
        el.removeEventListener("transitionend", removeClass);
      }

      el.classList.add("is-transitioning");
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === "function") {
        callback();
      }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function (array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    serialize: function (form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ["file", "reset", "submit", "button"].indexOf(field.type) > -1
        )
          return;
        if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                "=" +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
        );
      });
      return arr.join("&");
    },
  };

  theme.a11y = {
    trapFocus: function (options) {
      var eventsName = {
        focusin: options.namespace ? "focusin." + options.namespace : "focusin",
        focusout: options.namespace
          ? "focusout." + options.namespace
          : "focusout",
        keydown: options.namespace
          ? "keydown." + options.namespace
          : "keydown.handleFocus",
      };

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      );
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter((el) => el.offsetParent !== null);

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute("tabindex", "-1");
      options.elementToFocus.focus();

      document.documentElement.off("focusin");
      document.documentElement.on(eventsName.focusout, function () {
        document.documentElement.off(eventsName.keydown);
      });

      document.documentElement.on(eventsName.focusin, function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable)
          return;

        document.documentElement.on(eventsName.keydown, function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? "focusin." + options.namespace
        : "focusin";

      if (options.container) {
        options.container.removeAttribute("tabindex");
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add("lock-scroll");
      el.on("touchmove" + namespace, function () {
        return true;
      });
    },

    unlockMobileScrolling: function (namespace, element) {
      document.documentElement.classList.remove("lock-scroll");
      var el = element ? element : document.documentElement;
      el.off("touchmove" + namespace);
    },
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on("keyup.tab", function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add("tab-outline");
      document.documentElement.off("keyup.tab");
    }
  });
  const trapFocusHandlers = {};
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = (function () {
    var moneyFormat = "${{amount}}";
    var superScript =
      theme && theme.settings && theme.settings.superScriptPrice;

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }

      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ",");
        decimal = theme.utils.defaultTo(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);

          if (superScript && value && value.includes(".")) {
            value = value.replace(".", "<sup>") + "</sup>";
          }

          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");

          if (superScript && value && value.includes(".")) {
            value = value.replace(",", "<sup>") + "</sup>";
          }

          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (
        !variant.unit_price_measurement ||
        !variant.unit_price_measurement.reference_value
      ) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  theme.Images = (function () {
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return "620x"; // default based on theme
      }

      var match = src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }

      if (size == null) {
        return src;
      }

      if (size === "master") {
        return this.removeProtocol(src);
      }

      var match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
      );

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + "_" + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, "");
    }

    function buildImagePath(string, widths) {
      if (string == null) return [];

      if (widths) {
        const imageUrls = [];

        widths.forEach((width) => {
          let url = `${string}?width=${width}`;
          if (width === widths[widths.length - 1]) {
            url += ` ${width}w`;
          } else {
            url += ` ${width}w,`;
          }
          imageUrls.push(url);
        });
        return imageUrls;
      } else {
        return [string];
      }
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      buildImagePath: buildImagePath,
    };
  })();

  document.addEventListener('DOMContentLoaded', function () {
    const swipers = document.querySelectorAll('.main-grid-swiper');
    
    swipers.forEach(swiperContainer => {
      const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;
      const slidesPerView = slideCount > 5 ? 5.3 : slideCount;
  
      const swiper = new Swiper(swiperContainer, {
        slidesPerView: 1.6,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        loop: false,
        breakpoints: {
          450: {
            slidesPerView: 2.2,
            spaceBetween: 10,
            loop: false,
          },
          640: {
            slidesPerView: 2.4,
            spaceBetween: 10,
            loop: false,
          },
          768: {
            slidesPerView: 3.2,
            loop: false,
            spaceBetween: 10,
          },
          1100: {
            slidesPerView: slidesPerView,
            loop: slideCount > 5,
            spaceBetween: 10,
          },
        },
      });
    });
  });
  $(document).ready(function () {
    
    $(document).on(
      "click",
      ".disclaimer-main p span, .overlay-popup , .close",
      function (event) {
        $("body").toggleClass("show-overlay no-scroll-enable-disclaimer");
        $(".main-popup").toggleClass("show");
      }
    );
    $(".popup_btn_check , .popup_close").click(function () {
      $("body , #main_popup").toggleClass("active-modal-footer");
      $("body").removeClass("unloading");
    });
    $(".hero__animation-contents").css("display", "none");
    // $(".new-plus-design").hasClass("d-none")
    //   ? $(".grid-item__meta").css("margin", "66px 20px 20px")
    //   : $(".grid-item__meta").css("margin", "20px 20px 20px");
    // $(".new-plus-design").hasClass("d-none")
    //   ? $(".plus-minus-icon").removeClass("new-plus-design")
    //   : $(".plus-minus-icon").addClass("new-plus-design");
    //   setTimeout(()=>{
    // let variantIds = $('.grid-item.grid-product').map((item)=>);
    //   console.log("variantIds theme js",variantIds)
    //   },1000)
  });

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0;

    var observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof options.callback === "function") {
              options.callback();
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: "0px 0px " + threshold + "px 0px" }
    );

    observer.observe(options.element);
  };

  theme.LibraryLoader = (function () {
    var types = {
      link: "link",
      script: "script",
    };

    var status = {
      requested: "requested",
      loaded: "loaded",
    };

    var cloudCdn = "https://cdn.shopify.com/shopifycloud/";

    var libraries = {
      youtubeSdk: {
        tagId: "youtube-sdk",
        src: "https://www.youtube.com/iframe_api",
        type: types.script,
      },
      vimeo: {
        tagId: "vimeo-api",
        src: "https://player.vimeo.com/api/player.js",
        type: types.script,
      },
      shopifyXr: {
        tagId: "shopify-model-viewer-xr",
        src: cloudCdn + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
        type: types.script,
      },
      modelViewerUi: {
        tagId: "shopify-model-viewer-ui",
        src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
        type: types.script,
      },
      modelViewerUiStyles: {
        tagId: "shopify-model-viewer-ui-styles",
        src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
        type: types.link,
      },
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function () {};
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement("script");
      tag.src = library.src;
      tag.addEventListener("load", function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement("link");
      tag.href = library.src;
      tag.rel = "stylesheet";
      tag.type = "text/css";
      tag.addEventListener("load", function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load,
    };
  })();

  theme.rteInit = function () {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll(".rte table").forEach((table) => {
      var wrapWith = document.createElement("div");
      wrapWith.classList.add("table-wrapper");
      theme.utils.wrap(table, wrapWith);
    });

    // Wrap video iframe embeds so they are responsive
    document
      .querySelectorAll('.rte iframe[src*="youtube.com/embed"]')
      .forEach((iframe) => {
        wrapVideo(iframe);
      });
    document
      .querySelectorAll('.rte iframe[src*="player.vimeo"]')
      .forEach((iframe) => {
        wrapVideo(iframe);
      });

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement("div");
      wrapWith.classList.add("video-wrapper");
      theme.utils.wrap(iframe, wrapWith);
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll(".rte a img").forEach((img) => {
      img.parentNode.classList.add("rte__image");
    });
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener(
      "shopify:section:load",
      this._onSectionLoad.bind(this)
    );
    document.addEventListener(
      "shopify:section:unload",
      this._onSectionUnload.bind(this)
    );
    document.addEventListener(
      "shopify:section:select",
      this._onSelect.bind(this)
    );
    document.addEventListener(
      "shopify:section:deselect",
      this._onDeselect.bind(this)
    );
    document.addEventListener(
      "shopify:block:select",
      this._onBlockSelect.bind(this)
    );
    document.addEventListener(
      "shopify:block:deselect",
      this._onBlockDeselect.bind(this)
    );
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute("data-section-id");
      var type = container.getAttribute("data-section-type");

      constructor = constructor || this.constructors[type];

      if (typeof constructor === "undefined") {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container,
        });
        this.instances.push(instance);
      } catch (e) {
        // console.error(e);
      }
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (window.AOS) {
        AOS.refreshHard();
      }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }

      var container = subSection ? subSection : evt.target;
      var section = subSection
        ? subSection
        : evt.target.querySelector("[data-section-id]");

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection
        ? subSectionId
        : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll("[data-subsection]");
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === "function") {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event("scroll"));
      }, 200);
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === "function") {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function (scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll("[data-section-id]");

      sections.forEach((el) => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onSelect === "function"
      ) {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onDeselect === "function"
      ) {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockSelect === "function"
      ) {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockDeselect === "function"
      ) {
        instance.onBlockDeselect(evt);
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll(
        '[data-section-type="' + type + '"]'
      );

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function (section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance["type"] === section) {
          if (typeof instance.forceReload === "function") {
            instance.forceReload();
          }
        }
      }
    },
  });

  /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
  theme.Variants = (function () {
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
      this.currentlySelectedValues = this._getCurrentOptions();
      this.currentVariant = this._getVariantFromOptions();

      this.container
        .querySelectorAll(this.singleOptionSelector)
        .forEach((el) => {
          el.addEventListener("change", this._onSelectChange.bind(this));
        });
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {
      _getCurrentOptions: function () {
        var result = [];

        this.container
          .querySelectorAll(this.singleOptionSelector)
          .forEach((el) => {
            var type = el.getAttribute("type");

            if (type === "radio" || type === "checkbox") {
              if (el.checked) {
                result.push({
                  value: el.value,
                  index: el.dataset.index,
                });
              }
            } else {
              result.push({
                value: el.value,
                index: el.dataset.index,
              });
            }
          });

        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);

        return result;
      },

      // Pull the number out of the option index name, e.g. 'option1' -> 1
      _numberFromOptionKey: function (key) {
        return parseInt(key.substr(-1));
      },

      // Options should be ordered from highest to lowest priority. Make sure that priority
      // is represented using weighted values when finding best match
      _getWeightedOptionMatchCount: function (variant) {
        return this._getCurrentOptions().reduce((count, { value, index }) => {
          const optionIndex = this._numberFromOptionKey(index);
          const weightedCount = 4 - optionIndex; // The lower the index, the better the match we have
          return variant[index] === value ? count + weightedCount : count;
        }, 0);
      },

      _getFullMatch(needsToBeAvailable) {
        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        return variants.find((variant) => {
          const isMatch = currentlySelectedOptions.every(({ value, index }) => {
            return variant[index] === value;
          });

          if (needsToBeAvailable) {
            return isMatch && variant.available;
          } else {
            return isMatch;
          }
        });
      },

      // Find a variant that is available and best matches last selected option
      _getClosestAvailableMatch: function (lastSelectedOption) {
        if (!lastSelectedOption) return null;

        const currentlySelectedOptions = this._getCurrentOptions();
        const variants = this.variants;

        const potentialAvailableMatches =
          lastSelectedOption &&
          variants.filter((variant) => {
            return (
              currentlySelectedOptions
                .filter(
                  // Only match based selected options that are equal and preceeding the last selected option
                  ({ value, index }) =>
                    this._numberFromOptionKey(index) <=
                    this._numberFromOptionKey(lastSelectedOption.index)
                )
                .every(({ value, index }) => {
                  // Variant needs to have options that match the current and preceeding selection options
                  return variant[index] === value;
                }) && variant.available
            );
          });

        return potentialAvailableMatches.reduce((bestMatch, variant) => {
          // If this is the first potential match we've found, store it as the best match
          if (bestMatch === null) return variant;

          // If this is not the first potential match, compare the number of options our current best match has in common
          // compared to the next contender.
          const bestMatchCount = this._getWeightedOptionMatchCount(
            bestMatch,
            lastSelectedOption
          );
          const newCount = this._getWeightedOptionMatchCount(
            variant,
            lastSelectedOption
          );

          return newCount > bestMatchCount ? variant : bestMatch;
        }, null);
      },

      _getVariantFromOptions: function (lastSelectedOption) {
        const availableFullMatch = this._getFullMatch(true);
        const closestAvailableMatch =
          this._getClosestAvailableMatch(lastSelectedOption);
        const fullMatch = this._getFullMatch(false);

        if (this.dynamicVariantsEnabled) {
          // Add some additional smarts to variant matching if Dynamic Variants are enabled
          return (
            availableFullMatch || closestAvailableMatch || fullMatch || null
          );
        } else {
          // Only return a full match or null (variant doesn't exist) if Dynamic Variants are disabled
          return fullMatch || null;
        }
      },

      _updateInputState: function (variant, el) {
        return (input) => {
          if (variant === null) return;

          const index = input.dataset.index;
          const value = input.value;
          const type = input.getAttribute("type");

          if (type === "radio" || type === "checkbox") {
            input.checked = variant[index] === value;
          } else {
            input.value = variant[index];
          }
        };
      },

      _onSelectChange: function ({ srcElement }) {
        const optionSelectElements = this.container.querySelectorAll(
          this.singleOptionSelector
        );

        // Get the best variant based on the current selection + last selected element
        const variant = this._getVariantFromOptions({
          index: srcElement.dataset.index,
          value: srcElement.value,
        });

        // Update DOM option input states based on the variant that was found
        optionSelectElements.forEach(
          this._updateInputState(variant, srcElement)
        );

        // Make sure our currently selected values are up to date after updating state of DOM
        const currentlySelectedValues = (this.currentlySelectedValues =
          this._getCurrentOptions());

        const detail = {
          variant,
          currentlySelectedValues,
          value: srcElement.value,
          index: srcElement.parentElement.dataset.index,
        };

        this.container.dispatchEvent(
          new CustomEvent("variantChange", { detail })
        );
        document.dispatchEvent(new CustomEvent("variant:change", { detail }));

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        setTimeout(() => {
          $(".js-qty__adjust--plus").prop("disabled", false);
          $(".js-qty__adjust--minus").prop("disabled", false);
        }, 2100);

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },

      _updateImages: function (variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage =
          (this.currentVariant && this.currentVariant.featured_image) || {};

        if (
          !variant.featured_image ||
          variantImage.src === currentVariantImage.src
        ) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantImageChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updatePrice: function (variant) {
        if (
          this.currentVariant &&
          variant.price === this.currentVariant.price &&
          variant.compare_at_price === this.currentVariant.compare_at_price
        ) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantPriceChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateUnitPrice: function (variant) {
        if (
          this.currentVariant &&
          variant.unit_price === this.currentVariant.unit_price
        ) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantUnitPriceChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateSKU: function (variant) {
        if (this.currentVariant && variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantSKUChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant.id;
        window.history.replaceState({ path: newurl }, "", newurl);
      },

      _updateMasterSelect: function (variant) {
        let masterSelect = this.container.querySelector(
          this.originalSelectorId
        );
        if (!masterSelect) return;

        masterSelect.value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        masterSelect.dispatchEvent(new Event("change", { bubbles: true }));
      },
    });

    return Variants;
  })();

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent("youTubeReady"));
  };

  // Prevent vertical scroll while using flickity sliders
  (function () {
    var e = !1;
    var t;

    document.body.addEventListener("touchstart", function (i) {
      if (!i.target.closest(".flickity-slider")) {
        return (e = !1);
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY,
      };
    });

    document.body.addEventListener(
      "touchmove",
      function (i) {
        if (e && i.cancelable) {
          var n = {
            x: i.touches[0].pageX - t.x,
            y: i.touches[0].pageY - t.y,
          };
          Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault();
        }
      },
      { passive: !1 }
    );
  })();

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }
  theme.cart = {
    getCart: function () {
      var url = "".concat(theme.routes.cart, "?t=").concat(Date.now());
      return fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }).then((response) => response.json());
    },

    getCartProductMarkup: function () {
      var url = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
      url = url.indexOf("?") === -1 ? url + "?view=ajax" : url + "&view=ajax";
      return fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }).then(function (response) {
        return response.text();
      });
    },

    changeItem: function (key, qty) {
      console.log("changeItem", key);
      return this._updateCart({
        url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty,
        }),
      });
    },

    _updateCart: function (params) {
      $(".cart__checkout").attr("disabled", true);
      $(".cart__checkout").addClass("btn-disabled");
      $(".cart__checkout").removeClass("btn-orange-bg");
      return fetch(params.url, {
        method: "POST",
        body: params.data,
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
      })
        .then((response) => response.json())
        .then(function (cart) {
          window.global_popup_qty = 1;
          updateCartItems(cart);
          HideCALSection();
          // $(".cart__checkout").removeAttr("disabled");
          // $(".cart__checkout").removeClass("btn-disabled");
          // $(".cart__checkout").addClass("btn-orange-bg");
          return cart;
        });
    },

    updateAttribute: function (key, value) {
      return this._updateCart({
        url: "/cart/update.js",
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value),
          },
        }),
      });
    },

    updateNote: function (note) {
      return this._updateCart({
        url: "/cart/update.js",
        data: JSON.stringify({
          note: theme.cart.attributeToString(note),
        }),
      });
    },

    attributeToString: function (attribute) {
      if (typeof attribute !== "string") {
        attribute += "";
        if (attribute === "undefined") {
          attribute = "";
        }
      }
      return attribute.trim();
    },
    OOSAlert: function (evt) {
      theme.cart.getCart().then(function (cart) {
        let items = cart.items;
        var inStock = true;
        let itemsToRemove = {};

        items.forEach(function (item, index) {
          theme.cart._getCurrentProduct(item.handle).then(function (res) {
            if (res) {
              inStock = false;

              itemsToRemove[item.variant_id] = 0;
            }
            if (index === items.length - 1 && inStock == false) {
              alert(
                "Some of the Out of Stock items will be removed from your cart!"
              );
              theme.cart.removeOOSItems(itemsToRemove, evt);
            }

            if (index === items.length - 1 && inStock) {
              window.location = "/checkout";
            }
          });
        });
      });
    },
    removeOOSItems: function (items, evt) {
      evt.preventDefault();
      theme.cart
        ._updateCart({
          url: "/cart/update.js",
          data: JSON.stringify({ updates: items }),
        })
        .then(function (cart) {
          console.log("cart", cart);
          document.dispatchEvent(
            new CustomEvent("cart:build", {
              detail: {
                product: cart,
              },
            })
          );
          setTimeout(function () {
            if ($("#checkout_button").prop("disabled")) {
              evt.preventDefault();
            } else {
              setTimeout(function () {
                window.location = "/checkout";
              }, 1000);
            }
          }, 1000);
        });
    },
    _getCurrentProduct: async function (handle) {
      const url = `https://${
        window.location.host + "/products/" + handle
      }.json`;

      let response = await fetch(url);

      let { product } = await response.json();
      if (
        product.tags.includes("Out of Stock") &&
        !product.tags.includes("Gift Card")
      ) {
        return true;
      }
      return false;
    },
    _freeProductExistInCart: async function (handle) {
      const url = `https://${
        window.location.host + "/products/" + handle
      }.json`;
      let response = await fetch(url);
      let { product } = await response.json();
      if (
        product.tags.includes("Free Product") ||
        product.tags.includes("free product")
      ) {
        return true;
      }
      return false;
    },
  };

  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function () {
    var selectors = {
      products: "[data-products]",
      qtySelector: ".js-qty__wrapper",
      discounts: "[data-discounts]",
      savings: "[data-savings]",
      subTotal: "[data-subtotal]",

      cartBubble: ".cart-link__bubble",
      cartNote: '[name="note"]',
      termsCheckbox: ".cart__terms-checkbox",
      checkoutBtn: ".cart__checkout",
    };

    var classes = {
      btnLoading: "btn--loading",
    };

    var config = {
      requiresTerms: false,
    };

    function CartForm(form) {
      if (!form) {
        return;
      }

      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = ".cart-" + this.location;
      this.products = form.querySelector(selectors.products);
      this.submitBtn = form.querySelector(selectors.checkoutBtn);

      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);
      this.cartItemsUpdated = false;
      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }

      this.init();
    }

    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function () {
        this.initQtySelectors();
        document.addEventListener(
          "cart:quantity" + this.namespace,
          this.quantityChanged.bind(this)
        );

        this.form.on("submit", function (evt) {
          evt.preventDefault();

          if (theme.settings.localization) {
            let checkZipCode = localStorage.getItem("zipcode");
            if (checkZipCode) {
              getCartItems(evt);
            } else {
              $(".zip-code-button").click();
            }
          } else {
            theme.cart.OOSAlert(evt);
          }
        });

        if (this.noteInput) {
          this.noteInput.addEventListener("change", function () {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }

        // Dev-friendly way to build the cart
        document.addEventListener(
          "cart:build",
          function () {
            this.buildCart();
          }.bind(this)
        );
      },

      reInit: function () {
        this.initQtySelectors();
      },

      // onSubmit: function (evt) {
      //   // this.submitBtn.classList.add(classes.btnLoading);

      //   /*
      //     Checks for drawer or cart open class on body element
      //     and then stops the form from being submitted. We are also
      //     checking against a custom property, this.cartItemsUpdated = false.

      //     Error is handled in the quantityChanged method

      //     For Expanse/Fetch quick add, if an error is present it is alerted
      //     through the add to cart fetch request in quick-add.js.

      //     Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
      //     Expanse/Fetch when using quick add
      //   */

      //   if (
      //     $("#note-trigger").is(":checked") &&
      //     checkAddGiftForm($("#note-wrap")) == false
      //   ) {
      //     evt.preventDefault();
      //     return;
      //   }
      //   if (
      //     (document.documentElement.classList.contains("js-drawer-open") &&
      //       this.cartItemsUpdated) ||
      //     (document.documentElement.classList.contains("cart-open") &&
      //       this.cartItemsUpdated)
      //   ) {
      //     this.submitBtn.classList.remove(classes.btnLoading);
      //     evt.preventDefault();
      //     return false;
      //   }

      //   if (config.requiresTerms) {
      //     if (this.termsCheckbox.checked) {
      //       window.location = "/checkout";
      //     } else {
      //       alert(theme.strings.cartTermsConfirmation);
      //       this.submitBtn.classList.remove(classes.btnLoading);
      //       evt.preventDefault();
      //       return false;
      //     }
      //   }
      // },

      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function (text) {
        const html = document.createElement("div");
        html.innerHTML = text;
        return {
          items: html.querySelector(".cart__items"),
          discounts: html.querySelector(".cart__discounts"),
        };
      },

      buildCart: function () {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },

      cartMarkup: function (text) {
        let minCheckoutPrice = $("body").attr("data-min-checkout") * 100;
        let freeShippingText = $("#free-shipping-text-msg").html();
        let self = this;

        var markup = this._parseProductHTML(text);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;
        var barColor = getComputedStyle(
          document.documentElement
        ).getPropertyValue("--brand_color_1");

        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);

        if (count > 0) {
          this.wrapper.classList.remove("is-empty");
          $(".align-main-cart-customer").removeClass("is-empty");
          $(".cart__scrollable").removeClass("is-empty");
          $(".customer-loved").removeClass("is-empty");
          $(".mob-cart-align").removeClass("bg-color");
        } else {
          this.wrapper.classList.add("is-empty");
          $(".align-main-cart-customer").addClass("is-empty");
          $(".customer-loved").removeClass("is-empty");
          $(".cart__scrollable").addClass("is-empty");
          $(".mob-cart-align").addClass("bg-color");
        }

        this.updateCount(count);

        //add_remove_free_gift(); //commented out by DJ 5/3/23

        //TEMP CODE TO REMOVE ITEMS IN CART -- Needed for old carts or abandon carts

        theme.cart.getCart().then(function (cartItem) {
          let cartItems = cartItem.items;
          let cartItemsPromises = [];
          let freeProductExistInCart = [];

          cartItems.forEach(function (cartItem) {
            let freeProductCheck = theme.cart
              ._freeProductExistInCart(cartItem.handle)
              .then(function (freeProductTagExist) {
                freeProductExistInCart.push(freeProductTagExist);
              });
            cartItemsPromises.push(freeProductCheck);
          });

          Promise.all(cartItemsPromises).then(function () {
            theme.cart.getCart().then(function (cart) {
              let items = cart.items;
              let giftCardsAmount = 0;

              items.forEach(function (item) {
                // Add _free_gift property to the cart line item - case when discounts apply from shopify functions app
                if (item.discounts && item.discounts.length > 0) {
                  item.discounts.forEach(function (discount) {
                    if (
                      discount.title === "Free Gift" &&
                      discount.amount === item.original_price
                    ) {
                      item.properties = item.properties || {};
                      item.properties._free_gift = "1";
                    }
                  });
                }

                // Remove _free_gift property from the cart line item - case when no discounts from shopify functions app
                if (item.properties && item.properties._free_gift === "1") {
                  if (item.discounts && item.discounts.length > 0) {
                    const hasFreeGiftDiscount = item.discounts.some(function (
                      discount
                    ) {
                      return (
                        discount.title === "Free Gift" &&
                        discount.amount === item.original_price
                      );
                    });

                    if (!hasFreeGiftDiscount) {
                      delete item.properties._free_gift;
                    }
                  } else {
                    delete item.properties._free_gift;
                  }
                }

                // Gift Cards Not count for GWP or Free Shipping (Gift Card Ids for Bokksu Market, Sugoi Mart & Bokksu Boutique)
                let giftCardVariantIds = [
                  42232998396099, 42232998428867, 42232998461635,
                  42232998494403, 41089417379939, 41089417412707,
                  41257333489862, 31963795554409, 37660558459078,
                  37660558524614,
                ];

                if (giftCardVariantIds.includes(item.variant_id)) {
                  giftCardsAmount += item.final_line_price;
                }
              });

              if (giftCardsAmount > 0) {
                giftCardsAmount = (giftCardsAmount / 100).toFixed(2);
              }

              console.log(freeProductExistInCart, "freeProductExistInCart");
              console.log(giftCardsAmount, "giftCardsAmount");
              console.log(items, "items");

              // Check for bundle items in cart with min quantity of 3
              checkMinBundleInCart();

              let isFrozen = items.filter((item) => item.sku.startsWith("FZ"));
              let isMarket = items.filter((item) => !item.sku.startsWith("FZ"));
              let isGift = items.filter((item) => item.sku.startsWith("GC"));

              if (items.length > 0) {
                $(".cart__footer").show();
              } else {
                $(".cart__footer").hide();
              }

              let marketSubTotal = 0;
              // items.forEach(function (item) {
              //   if (item.product_type == "Market") {
              //     marketSubTotal += item.final_line_price;
              //   }

              // if (item.sku == "SML10334") {
              //   remove_free_gift("42637888291014");
              // }
              // if (item.sku == "SMU30019") {
              //   remove_free_gift("42604621496518");
              // }
              // if (item.sku == "SML10333") {
              //   remove_free_gift("42637885046982");
              // }
              // });

              // Market Items Progress Bar
              let marketQty = 0;
              let marketItems =
                items.length > 0 &&
                items.filter((item) => !item.sku.startsWith("FZ"));
              let cartItems = [];

              for (let i = 0; i < marketItems.length; i++) {
                let freeGift = 0;
                let marketItemsubTotal =
                  marketItems[i].final_price * marketItems[i].quantity;
                marketSubTotal += marketItemsubTotal;
                marketQty = marketQty + marketItems[i].quantity;

                if (
                  marketItems[i].properties &&
                  marketItems[i].properties._free_gift
                ) {
                  freeGift = 1;
                }

                let cartItemsObj = {
                  id: marketItems[i].id,
                  _free_gift: freeGift,
                };
                cartItems.push(cartItemsObj);
              }

              if (marketQty > 0) {
                $(".boutique-container").show();
                $(".mini-cart-market-items-count").text(marketQty);
                $(".mini-cart-market-items-count").attr(
                  "aria-label",
                  marketQty
                );
                $(".market-items-final-price").text(
                  "$" + (marketSubTotal / 100).toFixed(2)
                );
                $(".market-items-final-price").attr(
                  "aria-label",
                  "total price $" + (marketSubTotal / 100).toFixed(2)
                );
              } else {
                $(".boutique-container").hide();
              }

              let marketItemsMinFreeShipping =
                $("body").attr("data-min-shipping") * 100;

              var marketItemsBarPercent = 0;
              if (giftCardsAmount > 0) {
                marketItemsBarPercent =
                  ((parseFloat(marketSubTotal) -
                    parseFloat(giftCardsAmount * 100)) /
                    marketItemsMinFreeShipping) *
                  100;
              } else {
                marketItemsBarPercent =
                  (marketSubTotal / marketItemsMinFreeShipping) * 100;
              }

              // Free Gift Customizations
              let freeGift1Value = parseFloat($("#free-gift-1-amount").text());
              let freeGift2Value = parseFloat($("#free-gift-2-amount").text());
              freeGift1Value = parseFloat(freeGift1Value);
              freeGift2Value = parseFloat(freeGift2Value);
              let freeGift1InventoryQuantity = $(
                "#selected-gift-1-product-inventory-quantity"
              ).text();
              let freeGift2InventoryQuantity = $(
                "#selected-gift-2-product-inventory-quantity"
              ).text();
              freeGift1InventoryQuantity = parseInt(freeGift1InventoryQuantity);
              freeGift2InventoryQuantity = parseInt(freeGift2InventoryQuantity);
              let gift1Handle = $("#selected-gift-1-product").text();
              let freeGiftCollectionName = $(
                ".selected_gift_collection_name"
              ).text();

              let marketGiftIcon =
                location.href.includes("grocery") ||
                location.href.includes("market")
                  ? "https://cdn.shopify.com/s/files/1/0557/4269/3571/files/gift-icon.svg?v=1688554567"
                  : "https://cdn.shopify.com/s/files/1/1426/3142/files/gift-icon-sgm.png?v=1715069714";

              let marketTruckIcon =
                location.href.includes("grocery") ||
                location.href.includes("market")
                  ? "https://cdn.shopify.com/s/files/1/0557/4269/3571/files/truck.svg?v=1688554453"
                  : "https://cdn.shopify.com/s/files/1/0557/4269/3571/files/delivery.svg?v=1710318546";

              if (
                freeGift1Value &&
                gift1Handle &&
                freeGiftCollectionName &&
                freeGift1InventoryQuantity > 0
              ) {
                // let freeGiftCollectionProductVariantIds = String($(".selected_gift_collection_product_variant_ids").html());
                // freeGiftCollectionProductVariantIds = freeGiftCollectionProductVariantIds.split(",");
                // freeGiftCollectionProductVariantIds = freeGiftCollectionProductVariantIds.filter(function (element) {
                //     return element != "";
                // });

                // freeGiftCollectionProductVariantIds = freeGiftCollectionProductVariantIds.map(Number);

                // let existingInCollectionCartItemsIds = [];
                if (localStorage.getItem("freeGiftOneVariantId")) {
                  freeGiftOneVariantId = parseInt(
                    localStorage.getItem("freeGiftOneVariantId")
                  );
                }

                if (
                  freeGift2Value &&
                  freeGift2Value > 0 &&
                  freeGift2InventoryQuantity > 0
                ) {
                  if (localStorage.getItem("freeGiftTwoVariantId")) {
                    freeGiftTwoVariantId = parseInt(
                      localStorage.getItem("freeGiftTwoVariantId")
                    );
                  }
                }

                cartItems.forEach(function (item) {
                  if (
                    item.id === freeGiftOneVariantId &&
                    item._free_gift === 1
                  ) {
                    freeGiftOneExistInCart = true;
                  }
                  if (
                    freeGift2Value &&
                    freeGift2Value > 0 &&
                    freeGift2InventoryQuantity > 0
                  ) {
                    if (
                      item.id === freeGiftTwoVariantId &&
                      item._free_gift === 1
                    ) {
                      freeGiftTwoExistInCart = true;
                    }
                  }
                  // if (freeGiftCollectionProductVariantIds.includes(item.id)) {
                  //   existingInCollectionCartItemsIds.push(item.id);
                  // }
                });

                // let existingInCollectionCartItems = [];
                // let prevItemId = null;
                // existingInCollectionCartItemsIds.forEach(function (itemId) {
                //   if (prevItemId !== itemId) {
                //     let cartItem = items.filter((item) => item.id === itemId);
                //     existingInCollectionCartItems.push(cartItem);
                //     prevItemId = itemId;
                //   }
                // });

                // Convert 2D Array to 1D
                // existingInCollectionCartItems = [].concat(...existingInCollectionCartItems);

                // console.log('existingInCollectionCartItems', existingInCollectionCartItems);

                // let existingCollectionCartItemsSubTotal = 0;
                // for (let i = 0; i < existingInCollectionCartItems.length; i++) {
                //   if (existingInCollectionCartItems[i].properties?._free_gift != 1) {
                //     let existingInCollectionCartItemsSubTotal = existingInCollectionCartItems[i].final_price * existingInCollectionCartItems[i].quantity;
                //     existingCollectionCartItemsSubTotal += existingInCollectionCartItemsSubTotal;
                //   }
                // }
                // existingCollectionCartItemsSubTotal = existingCollectionCartItemsSubTotal / 100;
                // console.log("existingCollectionCartItemsSubTotal", existingCollectionCartItemsSubTotal);

                let existingCollectionCartItemsSubTotal = (
                  marketSubTotal / 100
                ).toFixed(2);
                if (giftCardsAmount > 0) {
                  existingCollectionCartItemsSubTotal =
                    parseFloat(existingCollectionCartItemsSubTotal) -
                    parseFloat(giftCardsAmount);
                  existingCollectionCartItemsSubTotal =
                    existingCollectionCartItemsSubTotal.toFixed(2);
                }

                console.log(
                  "existingCollectionCartItemsSubTotal",
                  existingCollectionCartItemsSubTotal
                );
                console.log(
                  "existingCollectionCartItemsSubTotal",
                  existingCollectionCartItemsSubTotal
                );

                existingCollectionCartItemsSubTotal = parseFloat(
                  existingCollectionCartItemsSubTotal
                );
                let freeGift1RemainingAmount =
                  freeGift1Value - existingCollectionCartItemsSubTotal;
                let freeGift2RemainingAmount = 0;

                if (
                  freeGift2Value &&
                  freeGift2Value > 0 &&
                  freeGift2InventoryQuantity > 0
                ) {
                  freeGift2RemainingAmount =
                    freeGift2Value - existingCollectionCartItemsSubTotal;
                }

                // if (marketSubTotal < marketItemsMinFreeShipping) {
                //   let remainingAmount = marketItemsMinFreeShipping - marketSubTotal;
                //   remainingAmount = remainingAmount / 100;
                //   let progressBarText = "Add $" + remainingAmount + " for Free Shipping";
                //   $(".free-shipping-text").html(progressBarText);
                //   $(".free-shipping-progress").css("width", marketItemsBarPercent + "%");
                // } else {
                //   let progressBarText = "Your Market Items Qualify for Free Shipping!";
                //   $(".free-shipping-text").html(progressBarText);
                //   $(".free-shipping-progress").css("width", "100%");
                // }

                let marketItemsGift1BarPercent = 0;
                let marketItemsGift2BarPercent = 0;
                let marketMessage = "";
                let marketHeading = "";
                let marketHeadingTwo = "";

                if (
                  freeGift1RemainingAmount === freeGift1Value &&
                  existingCollectionCartItemsSubTotal === 0
                ) {
                  console.log("here 3 in check");
                  removeFreeGiftOne(freeGiftOneExistInCart);
                  removeFreeGiftTwo(freeGiftTwoExistInCart, false);
                } else if (
                  freeGift1RemainingAmount === 0 &&
                  freeGift1RemainingAmount < freeGift1Value &&
                  existingCollectionCartItemsSubTotal <= freeGift1Value
                ) {
                  console.log("here 4 in check");
                  addFreeGiftOne();
                  removeFreeGiftTwo(freeGiftTwoExistInCart, false);
                  marketItemsGift1BarPercent =
                    (existingCollectionCartItemsSubTotal / freeGift1Value) *
                    100;
                  marketMessage = "You've unlocked your Free Gift!";
                  marketHeading = "Congrats!";
                  marketHeadingTwo = "Congrats!";
                } else if (
                  freeGift1RemainingAmount > 0 &&
                  freeGift1RemainingAmount < freeGift1Value &&
                  existingCollectionCartItemsSubTotal <= freeGift1Value
                ) {
                  console.log("here 5 in check");
                  removeFreeGiftOne(freeGiftOneExistInCart);
                  removeFreeGiftTwo(freeGiftTwoExistInCart, false);
                  marketItemsGift1BarPercent =
                    (existingCollectionCartItemsSubTotal / freeGift1Value) *
                    100;
                  marketMessage =
                    "You're <span class='amount-text-color'> $" +
                    freeGift1RemainingAmount.toFixed(2) +
                    " </span> away from Free Gift";
                  marketHeading = "Get to Free Gift";
                  marketHeadingTwo = "Unlock Free Gift";
                } else if (
                  !freeGift2Value &&
                  existingCollectionCartItemsSubTotal > freeGift1Value
                ) {
                  addFreeGiftOne();
                  removeFreeGiftOne(false);
                  marketItemsGift1BarPercent = 100;
                  console.log("here 6 in check");
                  marketMessage = "You've unlocked your Free Gift!";
                  marketHeading = "Congrats";
                  marketHeadingTwo = "Congrats";
                } else if (
                  freeGift2Value &&
                  freeGift2Value > 0 &&
                  freeGift2InventoryQuantity > 0 &&
                  existingCollectionCartItemsSubTotal === freeGift2Value
                ) {
                  console.log("here 7 in check");
                  removeFreeGiftOne(false);
                  addFreeGiftTwo();
                  marketItemsGift2BarPercent =
                    (existingCollectionCartItemsSubTotal / freeGift2Value) *
                    100;
                  marketMessage = "You've unlocked your Free Gift!";
                  marketHeading = "Congrats";
                  marketHeadingTwo = "Congrats";
                } else if (
                  freeGift2Value &&
                  freeGift2Value > 0 &&
                  freeGift2InventoryQuantity > 0 &&
                  existingCollectionCartItemsSubTotal > freeGift1Value &&
                  existingCollectionCartItemsSubTotal < freeGift2Value
                ) {
                  addFreeGiftOne();
                  removeFreeGiftTwo(freeGiftTwoExistInCart, false);
                  console.log("here 8 in check");
                  marketItemsGift2BarPercent =
                    (existingCollectionCartItemsSubTotal / freeGift2Value) *
                    100;
                  marketMessage =
                    "You're <span class='amount-text-color'> $" +
                    freeGift2RemainingAmount.toFixed(2) +
                    " </span> away from another Free Gift";
                  marketHeading = "Get to Free Gift";
                  marketHeadingTwo = "Unlock Free Gift";
                } else if (
                  freeGift2Value &&
                  freeGift2Value > 0 &&
                  freeGift2InventoryQuantity > 0 &&
                  existingCollectionCartItemsSubTotal >= freeGift2Value
                ) {
                  removeFreeGiftOne(false);
                  addFreeGiftTwo();
                  console.log("here 9 in check");
                }

                // Text & Progress Bar For Gift 1, case when only gift one is active
                if (
                  (!freeGift2Value &&
                    marketItemsMinFreeShipping / 100 > freeGift1Value &&
                    existingCollectionCartItemsSubTotal <= freeGift1Value) ||
                  (!freeGift2Value &&
                    marketItemsMinFreeShipping / 100 < freeGift1Value &&
                    existingCollectionCartItemsSubTotal >
                      marketItemsMinFreeShipping / 100 &&
                    existingCollectionCartItemsSubTotal <= freeGift1Value) ||
                  (!freeGift2Value &&
                    marketItemsMinFreeShipping / 100 < freeGift1Value &&
                    existingCollectionCartItemsSubTotal >
                      marketItemsMinFreeShipping / 100 &&
                    existingCollectionCartItemsSubTotal >= freeGift1Value)
                ) {
                  console.log("here check 11");
                  $(".free-shipping-text").hide();
                  $(".free-shipping-text-for-gift").show();
                  $(".market-icon").attr("src", marketGiftIcon);
                  $(".bar-heading").html(marketHeading);
                  $(".bar-heading-2").html(marketHeadingTwo);
                  $(".free-shipping-text-for-gift").html(marketMessage);
                  $(".free-shipping-progress").css("width", "0");
                  $(".free-shipping-progress").css("background", barColor);
                  $(".free-shipping-progress").css(
                    "width",
                    marketItemsGift1BarPercent + "%"
                  );
                  $("#floating-shipping-text").html(marketMessage);

                  // Text & Progress Bar For Market Free Shipping, case when only gift one is active
                } else if (
                  !freeGift2Value &&
                  existingCollectionCartItemsSubTotal >=
                    marketItemsMinFreeShipping / 100 &&
                  existingCollectionCartItemsSubTotal > freeGift1Value &&
                  freeGift1Value < marketItemsMinFreeShipping / 100
                ) {
                  console.log("here check 22");
                  marketMessage = "You've unlocked your Free Shipping!";
                  $(".free-shipping-text-for-gift").hide();
                  marketHeading = "Congrats!";
                  marketHeadingTwo = "Congrats!";
                  $(".free-shipping-text").show();
                  $(".market-icon").attr("src", marketTruckIcon);
                  $(".bar-heading").html(marketHeading);
                  $(".bar-heading-2").html(marketHeadingTwo);
                  $(".free-shipping-text").html(marketMessage);
                  $("#floating-shipping-text").html(marketMessage);
                  $(".free-shipping-progress").css("width", "0");
                  $(".free-shipping-progress").css("background", barColor);
                  $(".free-shipping-progress").css("width", "100%");

                  // Text & Progress Bar For Gift 1, case when gift one and gift two both are active
                } else if (
                  (freeGift2Value &&
                    freeGift2Value > 0 &&
                    freeGift2InventoryQuantity > 0 &&
                    marketItemsMinFreeShipping / 100 > freeGift1Value &&
                    existingCollectionCartItemsSubTotal <= freeGift1Value) ||
                  (freeGift2Value &&
                    freeGift2Value > 0 &&
                    freeGift2InventoryQuantity > 0 &&
                    marketItemsMinFreeShipping / 100 < freeGift1Value &&
                    existingCollectionCartItemsSubTotal >
                      marketItemsMinFreeShipping / 100 &&
                    existingCollectionCartItemsSubTotal <= freeGift1Value)
                ) {
                  console.log("here check 33");
                  $(".free-shipping-text").hide();
                  $(".free-shipping-text-for-gift").show();
                  $(".market-icon").attr("src", marketGiftIcon);
                  $(".bar-heading").html(marketHeading);
                  $(".bar-heading-2").html(marketHeadingTwo);
                  $(".free-shipping-text-for-gift").html(marketMessage);
                  $(".free-shipping-progress").css("width", "0");
                  $(".free-shipping-progress").css("background", barColor);
                  $(".free-shipping-progress").css(
                    "width",
                    marketItemsGift1BarPercent + "%"
                  );
                  $("#floating-shipping-text").html(marketMessage);

                  // Text & Progress Bar For Market Free Shipping, case when gift one and gift two both are active
                } else if (
                  (existingCollectionCartItemsSubTotal <
                    marketItemsMinFreeShipping / 100 &&
                    existingCollectionCartItemsSubTotal > freeGift1Value &&
                    existingCollectionCartItemsSubTotal < freeGift1Value) ||
                  (freeGift2Value &&
                    freeGift2Value > 0 &&
                    freeGift2InventoryQuantity > 0 &&
                    existingCollectionCartItemsSubTotal >= freeGift1Value &&
                    existingCollectionCartItemsSubTotal < freeGift2Value &&
                    existingCollectionCartItemsSubTotal <
                      marketItemsMinFreeShipping / 100 &&
                    marketItemsMinFreeShipping / 100 < freeGift2Value) ||
                  (marketItemsMinFreeShipping / 100 < freeGift1Value &&
                    existingCollectionCartItemsSubTotal <
                      marketItemsMinFreeShipping / 100 &&
                    existingCollectionCartItemsSubTotal < freeGift1Value) ||
                  (freeGift2Value &&
                    freeGift2Value > 0 &&
                    freeGift2InventoryQuantity > 0 &&
                    existingCollectionCartItemsSubTotal > freeGift1Value &&
                    existingCollectionCartItemsSubTotal > freeGift2Value &&
                    existingCollectionCartItemsSubTotal <
                      marketItemsMinFreeShipping / 100) ||
                  (!freeGift2Value &&
                    existingCollectionCartItemsSubTotal < freeGift1Value &&
                    existingCollectionCartItemsSubTotal <
                      marketItemsMinFreeShipping / 100) ||
                  (!freeGift2Value &&
                    existingCollectionCartItemsSubTotal > freeGift1Value &&
                    existingCollectionCartItemsSubTotal <
                      marketItemsMinFreeShipping / 100)
                ) {
                  console.log("here check 44");
                  $(".free-shipping-text").show();
                  $(".free-shipping-text-for-gift").hide();
                  let amount = marketItemsMinFreeShipping - marketSubTotal;
                  amount = amount / 100;
                  if (giftCardsAmount > 0) {
                    amount = parseFloat(amount) + parseFloat(giftCardsAmount);
                    amount = amount.toFixed(2);
                  }
                  let marketMsg =
                    "You're <span class='amount-text-color'> $" +
                    amount +
                    " </span> away from Free Shipping";
                  let marketHead = freeShippingText;
                  let marketHeadTwo = freeShippingText;
                  $(".market-icon").attr("src", marketTruckIcon);
                  $(".bar-heading").html(marketHead);
                  $(".bar-heading-2").html(marketHeadTwo);
                  $(".free-shipping-text").html(marketMsg);
                  $(".free-shipping-progress").css("background", barColor);
                  $(".free-shipping-progress").css(
                    "width",
                    marketItemsBarPercent + "%"
                  );
                  $("#floating-shipping-text").html(marketMsg);

                  // Text & Progress Bar For Gift 2
                } else if (
                  (freeGift2Value &&
                    freeGift2Value > 0 &&
                    freeGift2InventoryQuantity > 0 &&
                    existingCollectionCartItemsSubTotal >
                      marketItemsMinFreeShipping / 100 &&
                    existingCollectionCartItemsSubTotal > freeGift1Value &&
                    existingCollectionCartItemsSubTotal <= freeGift2Value) ||
                  (freeGift2Value &&
                    freeGift2Value > 0 &&
                    freeGift2InventoryQuantity > 0 &&
                    marketItemsMinFreeShipping / 100 > freeGift2Value &&
                    existingCollectionCartItemsSubTotal <
                      marketItemsMinFreeShipping / 100 &&
                    existingCollectionCartItemsSubTotal <= freeGift2Value)
                ) {
                  console.log("here check 55");
                  if (existingCollectionCartItemsSubTotal === freeGift1Value) {
                    marketItemsGift2BarPercent =
                      (existingCollectionCartItemsSubTotal / freeGift2Value) *
                      100;
                    marketMessage =
                      "You're <span class='amount-text-color'> $" +
                      freeGift2RemainingAmount.toFixed(2) +
                      " </span> away from Free Gift";
                  }
                  $(".free-shipping-text").hide();
                  $(".free-shipping-text-for-gift").show();
                  $(".market-icon").attr("src", marketGiftIcon);
                  $(".bar-heading").html(marketHeading);
                  $(".bar-heading-2").html(marketHeadingTwo);
                  $(".free-shipping-text-for-gift").html(marketMessage);
                  $(".free-shipping-progress").css("width", "0");
                  $(".free-shipping-progress").css("background", barColor);
                  $(".free-shipping-progress").css(
                    "width",
                    marketItemsGift2BarPercent + "%"
                  );
                  $("#floating-shipping-text").html(
                    "Click your cart to redeem your free gift!"
                  );
                  $(".free-shipping-progress-floating").css("width", "100%");
                }

                // Text & Progress Bar When All Acheived, case when gift one and gift two both are active
                else if (
                  freeGift2Value &&
                  freeGift2Value > 0 &&
                  freeGift2InventoryQuantity > 0 &&
                  existingCollectionCartItemsSubTotal >
                    marketItemsMinFreeShipping / 100 &&
                  existingCollectionCartItemsSubTotal >= freeGift2Value
                ) {
                  console.log("here check 66");
                  if (
                    (existingCollectionCartItemsSubTotal >
                      marketItemsMinFreeShipping / 100 &&
                      existingCollectionCartItemsSubTotal < freeGift2Value) ||
                    (existingCollectionCartItemsSubTotal >
                      marketItemsMinFreeShipping / 100 &&
                      marketItemsMinFreeShipping / 100 > freeGift1Value &&
                      marketItemsMinFreeShipping / 100 > freeGift2Value)
                  ) {
                    marketMessage = "You've unlocked your Free Shipping!";
                    $(".free-shipping-text-for-gift").hide();
                    marketHeading = "Congrats!";
                    marketHeadingTwo = "Congrats!";
                    $(".free-shipping-text").show();
                    $(".market-icon").attr("src", marketTruckIcon);
                    $(".bar-heading").html(marketHeading);
                    $(".bar-heading-2").html(marketHeadingTwo);
                    $(".free-shipping-text").html(marketMessage);
                    $("#floating-shipping-text").html(marketMessage);
                  } else if (
                    existingCollectionCartItemsSubTotal >= freeGift2Value
                  ) {
                    marketMessage = "You've unlocked all Free Gifts";
                    marketHeading = "Congrats!";
                    marketHeadingTwo = "Congrats!";
                    $(".free-shipping-text").hide();
                    $(".market-icon").attr("src", marketGiftIcon);
                    $(".bar-heading").html(marketHeading);
                    $(".bar-heading-2").html(marketHeadingTwo);
                    $(".free-shipping-text-for-gift").show();
                    $(".free-shipping-text-for-gift").html(marketMessage);
                    $("#floating-shipping-text").html(
                      "Click your cart to redeem your free gift!"
                    );
                    $(".free-shipping-progress-floating").css("width", "100%");
                  }
                  $(".free-shipping-progress").css("width", "0");
                  $(".free-shipping-progress").css("background", barColor);
                  $(".free-shipping-progress").css("width", "100%");
                }
              } else {
                // If Free Gift Functionality is not Setup in the Theme Customization than Run this Code
                if (marketSubTotal < marketItemsMinFreeShipping) {
                  let remainingAmount =
                    marketItemsMinFreeShipping - marketSubTotal;
                  remainingAmount = remainingAmount / 100;
                  if (giftCardsAmount > 0) {
                    remainingAmount =
                      parseFloat(remainingAmount) + parseFloat(giftCardsAmount);
                    remainingAmount = remainingAmount.toFixed(2);
                  }
                  let marketMsg =
                    "You're $" + remainingAmount + " away from Free Shipping";
                  let marketHead = freeShippingText;
                  let marketHeadTwo = freeShippingText;
                  $(".market-icon").attr("src", marketTruckIcon);
                  $(".bar-heading").html(marketHead);
                  $(".bar-heading-2").html(marketHeadTwo);
                  $(".free-shipping-text").html(marketMsg);
                  $(".free-shipping-progress").css(
                    "width",
                    marketItemsBarPercent + "%"
                  );
                  $("#floating-shipping-text").html(marketMsg);
                } else {
                  let remainingAmount =
                    marketItemsMinFreeShipping - marketSubTotal;
                  remainingAmount = remainingAmount / 100;
                  if (giftCardsAmount > 0) {
                    remainingAmount =
                      parseFloat(remainingAmount) + parseFloat(giftCardsAmount);
                    remainingAmount = remainingAmount.toFixed(2);
                  }

                  if (
                    (giftCardsAmount < marketItemsMinFreeShipping / 100 ||
                      giftCardsAmount >= marketItemsMinFreeShipping / 100) &&
                    remainingAmount > 0
                  ) {
                    let marketMsg =
                      "You're $" + remainingAmount + " away from Free Shipping";
                    let marketHead = freeShippingText;
                    let marketHeadTwo = freeShippingText;
                    $(".market-icon").attr("src", marketTruckIcon);
                    $(".bar-heading").html(marketHead);
                    $(".bar-heading-2").html(marketHeadTwo);
                    $(".free-shipping-text").html(marketMsg);
                    $(".free-shipping-progress").css(
                      "width",
                      marketItemsBarPercent + "%"
                    );
                    $("#floating-shipping-text").html(marketMsg);
                  } else {
                    let marketHead = "Congrats!";
                    let marketHeadTwo = "Congrats!";
                    $(".market-icon").attr("src", marketTruckIcon);
                    $(".bar-heading").html(marketHead);
                    $(".bar-heading-2").html(marketHeadTwo);
                    $(".free-shipping-text").html(
                      "You've unlocked your Free Shipping!"
                    );
                    $(".free-shipping-progress").css("width", "100%");
                    $("#floating-shipping-text").html(
                      "You've unlocked your Free Shipping!"
                    );
                  }
                }
              }

              // Frozen Items
              let frozenTruckIcon =
                location.href.includes("grocery") ||
                location.href.includes("market")
                  ? "https://cdn.shopify.com/s/files/1/0557/4269/3571/files/truck.svg?v=1688554453"
                  : "https://cdn.shopify.com/s/files/1/0557/4269/3571/files/delivery.svg?v=1710318546";
              let frozenItemsMinFreeShipping =
                $("body").attr("data-frozen-min-shipping") * 100;
              console.log(
                "frozenItemsMinFreeShipping",
                frozenItemsMinFreeShipping
              );
              let frozenItemsFreeShipping = 25;
              let frozenSubtotal = 0;
              let frozenQty = 0;

              let frozenItems =
                items.length > 0 &&
                items.filter((item) => item.sku.startsWith("FZ"));
              for (let i = 0; i < frozenItems.length; i++) {
                let frozenItemSubtotal =
                  frozenItems[i].price * frozenItems[i].quantity;
                frozenSubtotal += frozenItemSubtotal;
                frozenQty = frozenQty + frozenItems[i].quantity;
              }
              if (frozenQty > 0) {
                $(".subscription-container").show();
                $(".mini-cart-subscription-items-count").text(frozenQty);
                $(".subscription-items-final-price").text(
                  "$" + (frozenSubtotal / 100).toFixed(2)
                );
                $(".subscription-items-final-price").attr(
                  "aria-label",
                  "price $" + (frozenSubtotal / 100).toFixed(2)
                );
              } else {
                $(".subscription-container").hide();
              }
              var frozenItemsBarPercent =
                (frozenSubtotal / frozenItemsMinFreeShipping) * 100;

              if (frozenSubtotal < frozenItemsMinFreeShipping) {
                console.log(1);
                let amount = frozenItemsMinFreeShipping - frozenSubtotal;
                amount = amount / 100;
                let ajaxText = "You're $" + amount + " away from Free Shipping";
                let shippingFrozenMsg =
                  "Frozen orders under $" +
                  frozenItemsMinFreeShipping / 100 +
                  " ship for $" +
                  frozenItemsFreeShipping;
                let frozenHeading = freeShippingText;
                $(".frozen-icon").attr("src", frozenTruckIcon);
                $(".frozen-heading").html(frozenHeading);
                $(".ajax-cart__cart-msg-frozen").html(ajaxText);
                $(".ajax-cart__cart-shipping-msg-frozen").html(
                  shippingFrozenMsg
                );
                $(".free-shipping-progress-frozen").css(
                  "width",
                  frozenItemsBarPercent + "%"
                );
              } else if (frozenSubtotal < frozenItemsMinFreeShipping) {
                let amount = frozenItemsMinFreeShipping - frozenSubtotal;
                amount = amount / 100;
                let ajaxText = "You're $" + amount + " away from Free Shipping";
                let shippingFrozenMsg =
                  "Frozen orders under $" +
                  frozenItemsMinFreeShipping / 100 +
                  " ship for $" +
                  frozenItemsFreeShipping;
                let frozenHeading = freeShippingText;
                $(".frozen-icon").attr("src", frozenTruckIcon);
                $(".frozen-heading").html(frozenHeading);
                $(".ajax-cart__cart-msg-frozen").html(ajaxText);
                // $(".ajax-cart__cart-shipping-msg-frozen").html(shippingFrozenMsg);
                $(".free-shipping-progress-frozen").css(
                  "width",
                  frozenItemsBarPercent + "%"
                );
              } else {
                let frozenHeading = "Congrats!";
                $(".frozen-icon").attr("src", frozenTruckIcon);
                $(".frozen-heading").html(frozenHeading);

                $(".ajax-cart__cart-msg-frozen").html(
                  "You've unlocked your Free Shipping!"
                );
                $(".ajax-cart__cart-shipping-msg-frozen").html("");
                $(".free-shipping-progress-frozen").css("width", "100%");
              }
              //min frozen checkout code start
              if (
                marketSubTotal < minCheckoutPrice &&
                !isFrozen.length &&
                !freeProductExistInCart.includes(true)
              ) {
                // 3000 is actually $30
                console.log("cart 1");
                let marketDifference = minCheckoutPrice - marketSubTotal;
                let marketDifferenceFormat = theme.Currency.formatMoney(
                  marketDifference,
                  theme.settings.moneyFormat
                );
                $(".cart__checkout_enabled, .cart__checkout").attr(
                  "disabled",
                  true
                );
                $(".cart__checkout_enabled, .cart__checkout").addClass(
                  "cart-checkout-btn-disabled"
                );
                // Minicart Bottom Text to a 1 Liner
                $(".cart-checkout-btn-checkout").hide();
                $(".cart-checkout-btn-text").show();
                $(".cart__checkout").html(
                  "ADD " + marketDifferenceFormat + " TO CHECKOUT"
                );
                $(".shipping-at-checkout-text").hide();
                $(".min-order-text").show();
                $(".min-order-text").text("$30 minimum order.");
              } else if (
                frozenSubtotal < minCheckoutPrice &&
                !isMarket.length &&
                !isGift.length &&
                !freeProductExistInCart.includes(true)
              ) {
                $(".cart__checkout_enabled, .cart__checkout").attr(
                  "disabled",
                  true
                );
                $(".cart__checkout_enabled, .cart__checkout").addClass(
                  "cart-checkout-btn-disabled"
                );
                console.log("cart 2");
                let forzenDifference = minCheckoutPrice - frozenSubtotal;
                let frozenDifferenceFormat = theme.Currency.formatMoney(
                  forzenDifference,
                  theme.settings.moneyFormat
                );
                $(".cart__checkout").html(
                  "ADD " + frozenDifferenceFormat + " TO CHECKOUT"
                );
              } else if (
                ((isMarket.length || isGift.length) &&
                  marketSubTotal < minCheckoutPrice &&
                  !freeProductExistInCart.includes(true)) ||
                (isFrozen.length &&
                  frozenSubtotal < minCheckoutPrice &&
                  !freeProductExistInCart.includes(true))
              ) {
                let marketDifference = minCheckoutPrice - marketSubTotal;
                let marketDifferenceFormat = theme.Currency.formatMoney(
                  marketDifference,
                  theme.settings.moneyFormat
                );
                // $(".cart__checkout").html("ADD " + marketDifferenceFormat + " for market TO CHECKOUT");
                $(".cart__checkout").html(
                  `Market Cart: Add ${marketDifferenceFormat} to Checkout`
                );
                if (marketSubTotal >= minCheckoutPrice) {
                  let forzenDifference = minCheckoutPrice - frozenSubtotal;

                  let frozenDifferenceFormat = theme.Currency.formatMoney(
                    forzenDifference,
                    theme.settings.moneyFormat
                  );
                  // $(".cart__checkout").html("ADD " + frozenDifferenceFormat + " for frozen TO CHECKOUT");
                  $(".cart__checkout").html(
                    `Frozen Cart: Add ${frozenDifferenceFormat} to Checkout`
                  );
                }
                // $('#market-frozen-checkout').show()
                // $('#market-frozen-checkout').html('Add $30 each for Frozen and market items to checkout')
                $(".cart__checkout_enabled, .cart__checkout").attr(
                  "disabled",
                  true
                );
                $(".cart__checkout_enabled, .cart__checkout").addClass(
                  "cart-checkout-btn-disabled"
                );
              } else {
                $(".cart__checkout_enabled, .cart__checkout").attr(
                  "disabled",
                  false
                );
                $(".cart__checkout_enabled, .cart__checkout").removeClass(
                  "cart-checkout-btn-disabled"
                );
                let lockimg = $("<img>", {
                  src: "https://cdn.shopify.com/s/files/1/0557/4269/3571/files/lock-icon.png?v=1696586868",
                  alt: "lock Image",
                  class: "lock-img",
                });
                let checkoutTxt = $("<p>", {
                  text: "CHECKOUT",
                  class: "checkout-txt",
                });
                $(".cart__checkout_enabled, .cart__checkout").html([
                  lockimg,
                  checkoutTxt,
                ]);
                // $('#market-frozen-checkout').hide()
                // Minicart Bottom Text to a 1 Liner
                $(".cart-checkout-btn-text").hide();
                $(".cart-checkout-btn-checkout").show();
                $(".min-order-text").hide();
                $(".shipping-at-checkout-text").show();
              }
              //min frozen checkout code ends
            });
            //END TEMP CODE TO REMOVE ITEMS IN CART

            // Append item markup
            const frozenItems = $(items).find(".frozen-cart");
            const marketItems = $(items).find(".market-cart");
            console.log("markett", marketItems);
            if ($(".frozen-cart").length) {
              $(".frozen-cart").html("");
              $(".market-cart").html("");

              $(".frozen-cart").append(frozenItems);
              $(".market-cart").append(marketItems);
            } else {
              $("div[data-products] > div").replaceWith(items);
            }

            // Update subtotal
            self.subtotal.innerHTML = theme.Currency.formatMoney(
              subtotal,
              theme.settings.moneyFormat
            );
            $("#price-text").attr(
              "aria-label",
              "price $" + (subtotal / 100).toFixed(2)
            );

            let totalCartAmount = subtotal / 100;
            totalCartAmount = totalCartAmount.toFixed(2);
            $(".total-price").html(`$${totalCartAmount}`);

            // Check Minimum Cart Subtotal Value to $40
            if (subtotal < 4000 && !freeProductExistInCart.includes(true)) {
              // 4000 is actually $40
              let difference = 4000 - subtotal;
              let differenceFormat = theme.Currency.formatMoney(
                difference,
                theme.settings.moneyFormat
              );
              $(".cart__checkout_enabled, .cart__checkout").attr(
                "disabled",
                true
              );
              $(".cart__checkout_enabled, .cart__checkout").addClass(
                "cart-checkout-btn-disabled"
              );
              $(".checkout-btn-class button").attr("aria-hidden", true);
              $(".checkout-btn-class button").attr("id", "checkout_button");
              $(".checkout-btn-class").attr("id", "checkout-btn");

              // Check Minimum Cart Subtotal Value to $40

              $("#checkout-btn").attr(
                "aria-label",
                "to checkout minimum cart amount needs to be 40$"
              );
              $("#checkout-btn").attr("tabindex", 0);
              $("#checkout-btn").attr("role", "button");
              $("#checkout-btn").attr("aria-hidden", false);

              // Minicart Bottom Text to a 1 Liner
              $(".cart-checkout-btn-checkout").hide();
              $(".cart-checkout-btn-text").show();
              $(".cart__checkout").html(
                "ADD " + differenceFormat + " TO CHECKOUT"
              );
              $(".shipping-at-checkout-text").hide();
              $(".min-order-text").show();
              $(".min-order-text").text("$40 minimum order.");
            } else {
              $(".checkout-btn-class").removeAttr("id");
              $(".checkout-btn-class").removeAttr("tabindex");
              $(".checkout-btn-class").removeAttr("role");
              $(".checkout-btn-class").attr("aria-label");
              $(".checkout-btn-class").attr("aria-hidden", false);
              $(".checkout-btn-class button").attr("id", "checkout-btn");
              $(".checkout-btn-class button").attr(
                "aria-label",
                "add to checkout"
              );

              $(".checkout-btn-class button").attr("aria-hidden", false);

              // $(".cart__checkout_enabled, .cart__checkout").focus();
              $(".cart__checkout_enabled, .cart__checkout").attr(
                "disabled",
                false
              );
              $(".cart__checkout_enabled, .cart__checkout").removeClass(
                "cart-checkout-btn-disabled"
              );
              $(".cart__checkout_enabled, .cart__checkout").html("CHECKOUT");

              // Minicart Bottom Text to a 1 Liner
              $(".cart-checkout-btn-text").hide();
              $(".cart-checkout-btn-checkout").show();
              $(".min-order-text").hide();
              $(".shipping-at-checkout-text").show();
            }

            $(".cart__item-title > div:not([class])").remove();

            self.reInit();

            $(".js-qty__wrapper").addClass("is-loading");

            setTimeout(function () {
              $(".js-qty__wrapper").removeClass("is-loading");
            }, 700);

            if (window.AOS) {
              AOS.refreshHard();
            }

            if (Shopify && Shopify.StorefrontExpressButtons) {
              Shopify.StorefrontExpressButtons.initialize();
            }
          });
        });
        updateCartItems(null);
      },

      updateCartDiscounts: function (markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = "";
        this.discounts.append(markup);
      },

      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function () {
        this.form.querySelectorAll(selectors.qtySelector).forEach((el) => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true,
          });
        });
      },

      quantityChanged: function (evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];
        let productIdArray = key.split(":");
        let productId = null;
        let productName = $(this).attr("data-product-name");
        let productHandle = $(this).attr("data-product-handle");
        if (productIdArray && productIdArray[0]) {
          productId = productIdArray[0];
          if (productId && qty > 0) {
            $(".pdp-product-quantity").each(function (index) {
              if ($(this).attr("data-id") == productId) {
                $(this).val(qty);
              }
            });
            $(".qty-custom-plus").each(function (index) {
              if ($(this).attr("data-prod-id") == productId) {
                $(this).attr("data-prod-qty", qty);
              }
            });

            $(".qty-custom-minus").each(function (index) {
              if ($(this).attr("data-prod-id") == productId) {
                $(this).attr("data-prod-qty", qty);
              }
            });

            $(".quick_add_to_cart").each(function (index) {
              if ($(this).attr("data-prod-id") == productId) {
                $(this).find(".custom-qty").text(qty);
              }
            });
          } else {
            $(".quick_add_to_cart").each(function (index) {
              if ($(this).attr("data-prod-id") == productId) {
                $(this).find(".add-item-to-cart").empty();
                $(this)
                  .find(".add-item-to-cart")
                  .append(
                    `
                   <div class="qty-custom-add new-add-cart-button redndered-btn-cart long-plus-btn" data-product-handle="${productHandle}" data-prod-id="${productId}">
                   <button type="button" class="qty-custom-add" data-prod-id="${productId}" data-product-handle="${productHandle}">  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                   <path d="M12.4004 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                   <path d="M5.40039 12H19.4004" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                   </svg>  <span>Add to cart</span> </button></div>
      
                    `
                  );
              }
            });

            $(".qty-custom-plus").each(function (index) {
              if ($(this).attr("data-prod-id") == productId) {
                $(this).hide();
              }
            });

            $(".qty-custom-minus").each(function (index) {
              if ($(this).attr("data-prod-id") == productId) {
                $(this).hide();
              }
            });

            $(".quick_add_to_cart").each(function (index) {
              if ($(this).attr("data-prod-id") == productId) {
                $(this).find(".custom-qty").hide();
              }
            });
          }
        }

        if (!key || !qty) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        // if (el) {
        //   el.classList.add("is-loading");
        // }

        theme.cart
          .changeItem(key, qty)
          .then(
            function (cart) {
              if (cart.item_count > 0) {
                this.wrapper.classList.remove("is-empty");
              } else {
                this.wrapper.classList.add("is-empty");
              }
              let variantId = $(".cro-pdp-updates button").data("variant-id");

              if (qty == 0 && productId == variantId) {
                $(".product_quantity").val(1);
                $(".cro-qty-wrapper").hide();
                $(".pdp-atc").show();
              }
              this.buildCart();

              document.dispatchEvent(
                new CustomEvent("cart:updated", {
                  detail: {
                    cart: cart,
                  },
                })
              );
            }.bind(this)
          )
          .catch(function (XMLHttpRequest) {});
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function (subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML =
          theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
        $("#price-text").attr("aria-label", "price " + subtotal);
      },

      updateSavings: function (savings) {
        if (!this.savings) {
          return;
        }

        if (savings > 0) {
          var amount = theme.Currency.formatMoney(
            savings,
            theme.settings.moneyFormat
          );
          this.savings.classList.remove("hide");
          this.savings.innerHTML = theme.strings.cartSavings.replace(
            "[savings]",
            amount
          );
        } else {
          this.savings.classList.add("hide");
        }
      },

      updateCount: function (count) {
        var countEls = document.querySelectorAll(".cart-link__bubble-num");
        var totalAmount = "";
        if (document.querySelectorAll(".total-price").length > 0) {
          totalAmount =
            document.querySelectorAll(".total-price")[0].textContent;
        }

        if (countEls.length) {
          countEls.forEach((el) => {
            el.innerText = count;
            $("#HeaderCartTrigger").attr(
              "aria-label",
              "Cart with " + count + " items Total Price " + totalAmount
            );
          });
        }

        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach((b) => {
              b.classList.add("cart-link__bubble--visible");
            });
          } else {
            bubbles.forEach((b) => {
              b.classList.remove("cart-link__bubble--visible");
            });
          }
        }
      },
    });

    return CartForm;
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function () {
    var selectors = {
      trigger: ".collapsible-trigger",
      module: ".collapsible-content",
      moduleInner: ".collapsible-content__inner",
      tabs: ".collapsible-trigger--tab",
    };

    var classes = {
      hide: "hide",
      open: "is-open",
      autoHeight: "collapsible--auto-height",
      tabs: "collapsible-trigger--tab",
    };

    var namespace = ".collapsible";

    var isTransitioning = false;

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach((trigger) => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute("aria-expanded", state);

        trigger.off("click" + namespace);
        trigger.on("click" + namespace, toggle);
      });
    }

    function toggle(evt) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute("aria-controls");
      var container = document.getElementById(moduleId);

      if (!moduleId) {
        moduleId = el.dataset.controls;
      }

      // No ID, bail
      if (!moduleId) {
        return;
      }

      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll(
          '[data-id="' + moduleId + '"]'
        );
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector(
            '[data-id="' + moduleId + '"]'
          );
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document
          .querySelectorAll(
            selectors.tabs + '[data-id="' + el.dataset.id + '"]'
          )
          .forEach((el) => {
            el.classList.remove(classes.open);
            newModule = document.querySelector(
              "#" + el.getAttribute("aria-controls")
            );
            setTransitionHeight(newModule, 0, true);
          });
      }

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      el.setAttribute("aria-expanded", !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }

      setTransitionHeight(container, height, isOpen, isAutoHeight);

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;

        if (isOpen && parentHeight === "auto") {
          childHeight = 0; // Set childHeight to 0 if parent is initially opened
        }

        var totalHeight = isOpen
          ? parentCollapsibleEl.offsetHeight - childHeight
          : height + parentCollapsibleEl.offsetHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }

      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector(".spr-summary-actions-newreview");
        if (!btn) {
          return;
        }
        btn.off("click" + namespace);
        btn.on("click" + namespace, function () {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function () {
        container.style.height = height + "px";
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });

      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function () {
          o.css("height", "auto");
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init,
    };
  })();

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureForm: "[data-disclosure-form]",
      disclosureList: "[data-disclosure-list]",
      disclosureToggle: "[data-disclosure-toggle]",
      disclosureInput: "[data-disclosure-input]",
      disclosureOptions: "[data-disclosure-option]",
    };

    var classes = {
      listVisible: "disclosure-list--visible",
    };

    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(
            selectors.disclosureList
          ),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          ),
        };
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.disclosureToggle.addEventListener(
          "click",
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.addEventListener(
            "click",
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.addEventListener(
          "keyup",
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.addEventListener(
          "focusout",
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.addEventListener(
          "focusout",
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.addEventListener("click", this.eventHandlers.onBodyClick);
      },

      _setupEventHandlers: function () {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut:
            this._onDisclosureToggleFocusOut.bind(this),
        };
      },

      _connectOptions: function (event) {
        event.preventDefault();

        this._submitForm(event.currentTarget.dataset.value);
      },

      _onDisclosureToggleFocusOut: function (event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;

        if (disclosureLostFocus) {
          this._hideList();
        }
      },

      _onDisclosureListFocusOut: function (event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);

        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },

      _onDisclosureKeyUp: function (event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },

      _onBodyClick: function (event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this._hideList();
        }
      },

      _submitForm: function (value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },

      _hideList: function () {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute("aria-expanded", false);
      },

      _toggleList: function () {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute("aria-expanded") === "true";
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute(
          "aria-expanded",
          !ariaExpanded
        );
      },

      destroy: function () {
        this.cache.disclosureToggle.removeEventListener(
          "click",
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.removeEventListener(
            "click",
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.removeEventListener(
          "keyup",
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.removeEventListener(
          "focusout",
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.removeEventListener(
          "focusout",
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.removeEventListener(
          "click",
          this.eventHandlers.onBodyClick
        );
      },
    });

    return Disclosure;
  })();

  theme.Modals = (function () {
    function Modal(id, name, options) {
      var defaults = {
        close: ".js-modal-close",
        open: ".js-modal-open-" + name,
        openClass: "modal--is-active",
        closingClass: "modal--is-closing",
        bodyOpenClass: ["modal-open"],
        bodyOpenSolidClass: "modal-open--solid",
        bodyClosingClass: "modal-closing",
        closeOffContentClick: true,
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector(".modal__inner");

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen
        ? document.getElementById(this.config.focusIdOnOpen)
        : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function () {
      document.querySelectorAll(this.config.open).forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
        btn.addEventListener("click", this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach((btn) => {
        btn.addEventListener("click", this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener(
        "drawerOpen",
        function () {
          this.close();
        }.bind(this)
      );
    };

    Modal.prototype.open = function (evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute(
          "aria-expanded",
          "true"
        );
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;
      // Delay trap focus to ensure elements are seen by screen readers
      // Delay trap focus to ensure elements are seen by screen readers
      setTimeout(() => {
        theme.a11y.trapFocus({
          container: this.modal,
          elementToFocus: this.focusOnOpen,
          namespace: "modal_focus",
        });
      }, 500);

      // unavailable products in zip code of user

      var unavailableProducts =
        JSON.parse(localStorage.getItem("unavailableProducts")) || [];
      var availableProducts =
        JSON.parse(localStorage.getItem("availableProducts")) || [];

      function isVariantUnavailable(variantId) {
        return unavailableProducts.includes(variantId);
      }
      function isVariantAvailable(variantId) {
        return availableProducts.filter((item) => {
          return item.variantId == variantId;
        });
      }

      async function checkElement() {
        let warehouseLocation = localStorage.getItem("locationName");
        if ($(".modal--is-active .product-form-holder--loaded").length > 0) {
          clearInterval(interval);
          let _variantId = $(".modal--is-active  .js-qty__adjust").attr(
            "data-variant-id"
          );
          warehouseLocation != null &&
            $(".icon--inventory").parent().removeClass("d-none");
          let stockMessage = "In stock, ready to ship";
          let availalebleProducts = isVariantAvailable(_variantId);
          $(".sales-point .icon-and-text").removeClass("inventory--low");
          $(".sales-point .icon-and-text").removeClass("inventory--zero");
          if (isVariantUnavailable(_variantId)) {
            $(".modal--is-active .cro-pdp-updates").hide();
            stockMessage = "Item is out of stock";
            $(".icon--inventory").parent().addClass("inventory--zero");
            if ($(".modal--is-active .sold-out-modal").length == 0) {
              $(".modal--is-active .cro-pdp-updates")
                .before(`<button style="pointer-events:none;" disabled class="soldout-btn btn btn-custom btn--full add-to-cart  sold-out-modal">
                    <span data-add-to-cart-text="" data-default-text="Sold Out">
                   Sold Out 
                </span>
                  </button>`);
            }
          } else if (availalebleProducts.length > 0) {
            let availableQuantity = availalebleProducts[0].quantity;
            if (availableQuantity > 0 && availableQuantity < 10) {
              stockMessage = "Low Stock - " + availableQuantity + " items left";
              $(".icon--inventory").parent().addClass("inventory--low");
            }
          } else {
            stockMessage = "In stock, ready to ship";
            $(".modal--is-active .sold-out-modal").hide();
            $(".modal--is-active .cro-pdp-updates").show();
          }
          $(".text-product-inventory").text(stockMessage);

          theme.cart.getCart().then(function (cart) {
            let items = cart.items;
            let result;
            if (items.length > 0) {
              result = items.find(function (item) {
                return (
                  item.variant_id ==
                  $(".modal--is-active  .js-qty__adjust").attr(
                    "data-variant-id"
                  )
                );
              });
              if (result == undefined) {
                $(`.modal--is-active #product_quantity-modal`).val(1);
                $(`.modal--is-active .cro-pdp-updates button`).removeAttr(
                  "style"
                );
                $(`.modal--is-active .cro-pdp-updates .cro-qty-wrapper`).attr(
                  "style",
                  "display:none"
                );
              } else {
                $(
                  `.modal--is-active .cro-pdp-updates .cro-qty-wrapper`
                ).removeAttr("style");
                $(
                  `.modal--is-active .cro-pdp-updates .cro-qty-wrapper input`
                ).val(result.quantity);
                $(`.modal--is-active .cro-pdp-updates button:first`).attr(
                  "style",
                  "display:none"
                );

                $(`.modal--is-active #product_quantity-modal`).val(
                  result.quantity
                );
              }
            } else {
              $(`.modal--is-active #product_quantity-modal`).val(1);
              $(`.modal--is-active .cro-pdp-updates button`).removeAttr(
                "style"
              );
              $(`.modal--is-active .cro-pdp-updates .cro-qty-wrapper`).attr(
                "style",
                "display:none"
              );
            }
          });
        }
      }

      // Check every 500 milliseconds
      let interval = setInterval(checkElement, 500);

      document.dispatchEvent(new CustomEvent("modalOpen"));
      document.dispatchEvent(new CustomEvent("modalOpen." + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest(".js-modal-close")) {
          // Do not close if using the modal close button
        } else if (evt.target.closest(".modal__inner")) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(
        function () {
          document.documentElement.classList.remove(
            this.config.bodyClosingClass
          );
          // alert('popoopop');
          $("body").removeClass("show-overlay no-scroll-enable-disclaimer");
          $(".main-popup").removeClass("show");
          this.modal.classList.remove(this.config.closingClass);
          if (
            this.activeSource &&
            this.activeSource.getAttribute("aria-expanded")
          ) {
            this.activeSource.setAttribute("aria-expanded", "false").focus();
          }
        }.bind(this),
        500
      ); // modal close css transition

      if (this.isSolid) {
        document.documentElement.classList.remove(
          this.config.bodyOpenSolidClass
        );
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: "modal_focus",
      });

      document.dispatchEvent(new CustomEvent("modalClose." + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
      window.on(
        "keyup.modal",
        function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this)
      );

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on("click.modal", this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function () {
      document.documentElement.off(".modal");

      if (this.config.closeOffContentClick) {
        this.modal.off(".modal");
      }
    };

    return Modal;
  })();

  window.onpageshow = function (evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove("unloading");
      document.querySelectorAll(".cart__checkout").forEach((el) => {
        el.classList.remove("btn--loading");
      });
    }
  };

  // Used in Motion and Expanse to fade between pages.
  // initialize in theme.js with theme.pageTransitions();
  theme.pageTransitions = function () {
    if (document.body.dataset.transitions === "true") {
      // Hack test to fix Safari page cache issue.
      // window.onpageshow doesn't always run when navigating
      // back to the page, so the unloading class remains, leaving
      // a white page. Setting a timeout to remove that class when leaving
      // the page actually finishes running when they come back.
      if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
        document.querySelectorAll("a").forEach((a) => {
          window.setTimeout(function () {
            document.body.classList.remove("unloading");
          }, 1200);
        });
      }

      // Disable the page transition feature on some links
      // by adding class `js-no-transition`
      document
        .querySelectorAll(
          'a.rca-add-to-cart-submit, a.hero__slide-link, a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[download]'
        )
        .forEach((el) => {
          el.classList.add("js-no-transition");
        });

      // Add class `unloading` to body for page transition on all
      // anchor tags, unless they have `js-no-transition` class
      document.querySelectorAll("a:not(.js-no-transition)").forEach((el) => {
        el.addEventListener("click", function (evt) {
          if (evt.metaKey) return true;
          evt.preventDefault();
          document.body.classList.add("unloading");
          var src = el.getAttribute("href");
          window.setTimeout(function () {
            location.href = src;
          }, 50);
        });
      });

      // Close the mobile nav drawer after clicking on a nav link
      document.querySelectorAll("a.mobile-nav__link").forEach((el) => {
        el.addEventListener("click", function () {
          theme.NavDrawer.close();
        });
      });
    }
  };

  if (typeof window.noUiSlider === "undefined") {
    throw new Error(
      "theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js"
    );
  }

  function getCookie(cookieName) {
    let cookie = {};
    document.cookie.split(";").forEach(function (el) {
      let [key, value] = el.split("=");
      cookie[key.trim()] = value;
    });
    return cookie[cookieName];
  }

  theme.AjaxProduct = (function () {
    var status = {
      loading: false,
    };

    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : ".add-to-cart";

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener("submit", this.addItemFromForm.bind(this));
      }
    }

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: async function (evt, callback) {
        $(".cart__checkout").attr("disabled", true);
        $(".cart__checkout").addClass("btn-disabled");
        $(".cart__checkout").removeClass("btn-orange-bg");
        var btn = evt.currentTarget;
        let prodTitle = $(evt.currentTarget).attr("data-product-name");
        let prodHandle = $(evt.currentTarget).attr("data-product-handle");
        let productQty = $(".modal--quick-shop").hasClass("modal--is-active")
          ? parseInt($(".modal--is-active #product_quantity-modal").val())
          : parseInt($(".product_quantity").val());
        let qtyVal;
        if (
          storeUrl == "bokksugrocery.myshopify.com" &&
          productQty !== 0 &&
          evt.submitter.classList.contains("pdp-qty__plus")
        ) {
          qtyVal = productQty + 1;
        } else if (
          storeUrl == "bokksugrocery.myshopify.com" &&
          productQty == 0 &&
          evt.submitter.classList.contains("pdp-qty__minus")
        ) {
          qtyVal = productQty;
        } else {
          qtyVal = productQty;
        }
        productQty == 0 ? (productQty = 1) : (productQty = productQty);
        evt.preventDefault();

        if (
          evt.submitter.classList.contains("pdp-qty__minus") ||
          evt.submitter.classList.contains("pdp-qty__plus")
        ) {
          let variantId = $(".modal--quick-shop").hasClass("modal--is-active")
            ? $(".modal--is-active .pdp-qty__minus").attr("data-variant-id")
            : $(".pdp-qty__minus").attr("data-variant-id");
          let updates = {};
          updates[variantId] = qtyVal;
          theme.cart
            ._updateCart({
              url: "/cart/update.js",
              data: JSON.stringify({ updates: updates }),
              method: "POST",
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then(function (cart) {
              updateCartItems(cart);

              console.log("add from form cary updaye", qtyVal);
              if (qtyVal == 0) {
                $(".cro-qty-wrapper").hide();
                $(".pdp-atc").show();
              }

              document.dispatchEvent(
                new CustomEvent("cart:build", {
                  detail: {
                    product: cart,
                  },
                })
              );
            });
        } else {
          let variantId = $(".modal--quick-shop").hasClass("modal--is-active")
            ? $(".modal--is-active .add-to-cart").attr("data-variant-id")
            : $(".add-to-cart").attr("data-variant-id");
          if (status.loading) {
            return;
          }
          status.loading = true;

          //var data = theme.utils.serialize(this.form);
          var data = {};
          data = {
            id: variantId,
            quantity: productQty,
          };
          if (theme.settings.localization) {
            let checkZipCode = localStorage.getItem("zipcode");
            if (checkZipCode) {
              let productInventory = await availableInventory(variantId);
              if (
                (data.quantity <= productInventory.availableQuantity &&
                  productInventory.isInStock) ||
                prodHandle === "bokksu-digital-gift-card"
              ) {
                cartItemAdd(data, this, status);
              } else {
                status.loading = false;
                alert(
                  productInventory.availableQuantity
                    ? `We can ship a maximum of ${productInventory.availableQuantity} ${prodTitle} to your zip code.`
                    : `Item is out of stock at your location`
                );
              }
            } else {
              status.loading = false;
              $(".zip-code-button").click();
            }
          } else {
            cartItemAdd(data, this, status);
          }
        }
      },
      success: function (product) {
        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
              addToCartBtn: this.addToCart,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
              detail: {
                product: product,
                addToCartBtn: this.addToCart,
              },
            })
          );
        }
      },

      error: function (error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement("div");
        errorDiv.classList.add("errors", "text-center");
        errorDiv.textContent = error.description;
        this.form.append(errorDiv);

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:error", {
            detail: {
              errorMessage: error.description,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
              detail: {
                errorMessage: error.description,
              },
            })
          );
        }
      },
    });

    return ProductForm;
  })();

  function cartItemAdd(data, evt, status) {
    console.log("data,evt,status", data, evt, status);
    fetch(theme.routes.cartAdd, {
      method: "POST",
      body: JSON.stringify(data),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(
        function (data) {
          console.log("data", data);
          updateCartItems(null);

          if ($(".modal--is-active").length == 0) {
            $(
              ".pdp__qty,.pdp-product-quantity,#product_quantity,#product_quantity-modal"
            ).val(1);
          }

          if (data.status === 422) {
            evt.error(data);
          } else {
            HideCALSection();
            if ($(".modal--is-active").length == 0) {
              $(".pdp-atc").each(function () {
                if (!$(this).hasClass("gwbutton")) {
                  $(this).hide();
                }
              });

              atcAndQtyButtonSwitch(data, "add");
            } else {
              $(".modal--is-active .pdp-atc").hide();

              $(".modal--is-active .cro-qty-wrapper").show();
            }
            var product = data;
            evt.success(product);
          }

          status.loading = false;
          //evt.addToCart.classList.remove('btn--loading');
          localStorage.setItem("cartCookie", getCookie("cart"));

          // Reload page if adding product from a section on the cart page
          if (document.body.classList.contains("template-cart")) {
            window.scrollTo(0, 0);
            location.reload();
          }
        }.bind(evt)
      );
  }

  theme.ProductMedia = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
      mediaGroup: "[data-product-single-media-group]",
      xrButton: "[data-shopify-xr]",
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false,
      };

      modelViewerContainers.forEach(function (container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector("model-viewer");
        var modelId = modelViewerElement.dataset.modelId;

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId,
          };
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement,
        };
      });

      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: setupShopifyXr,
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: setupModelViewerUi,
        },
      ]);

      theme.LibraryLoader.load("modelViewerUiStyles");
    }

    function setupShopifyXr(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener("shopify_xr_initialized", function () {
          setupShopifyXr();
        });
        return;
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];

          if (modelSection.loaded) continue;

          var modelJson = document.querySelector("#ModelJson-" + sectionId);

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];

      model.container.addEventListener("mediaVisible", function () {
        xrButton.element.setAttribute("data-shopify-model3d-id", model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });

      model.container.addEventListener("mediaHidden", function () {
        xrButton.element.setAttribute(
          "data-shopify-model3d-id",
          xrButton.defaultId
        );
        model.modelViewerUi.pause();
      });

      model.container.addEventListener("xrLaunch", function () {
        model.modelViewerUi.pause();
      });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels,
    };
  })();

  theme.QtySelector = (function () {
    var selectors = {
      input: ".js-qty__num",
      plus: ".js-qty__adjust--plus",
      minus: ".js-qty__adjust--minus",
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute("min") || 1;

      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id,
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function () {
        this.plus.addEventListener(
          "click",
          async function (e) {
            // e.stopImmediatePropagation();

            var qty = this._getQty();
            window.global_popup_qty = Number(qty + 1);
            let prodHandle = $(e.currentTarget).attr("data-product-handle");
            if (theme.settings.localization) {
              let prodTitle = $(e.currentTarget).attr("data-product-name");
              let checkZipCode = localStorage.getItem("zipcode");
              if (checkZipCode) {
                let variantId = $(e.currentTarget).attr("data-variant-id");
                let productInventory =
                  variantId && (await availableInventory(variantId));
                let checkIsModal = $(
                  ".modal__inner .product-single__title"
                ).hasClass("product-temp");
                let quantity = qty + 1;
                if (variantId) {
                  if (
                    (quantity <= productInventory.availableQuantity &&
                      productInventory.isInStock) ||
                    prodHandle === "bokksu-digital-gift-card"
                  ) {
                    this._change(qty + 1);
                  } else {
                    this._change(productInventory.availableQuantity ?? 0);
                    alert(
                      productInventory.availableQuantity
                        ? `We can ship a maximum of ${productInventory.availableQuantity} ${prodTitle} to your zip code.`
                        : `Item is out of stock at your location`
                    );
                  }
                } else {
                  this._change(qty + 1);
                }
              } else {
                $(".zip-code-button").click();
              }
            } else {
              this._change(qty + 1);
            }
          }.bind(this)
          // { once: true }
        );

        this.minus.addEventListener(
          "click",
          function (e) {
            // e.stopImmediatePropagation();

            var qty = this._getQty();
            console.log("qty", qty);
            window.global_popup_qty = Number(qty - 1);
            console.log("minus:", window.global_popup_qty);

            this._change(qty - 1);
          }.bind(this)
          // { once: true }
        );

        this.input.addEventListener(
          "change",
          async function (evt) {
            if (theme.settings.localization) {
              evt.stopImmediatePropagation();
              console.log("change listener");
              let quantity = this._getQty();
              let variantId = $(evt.currentTarget).attr("data-variant-id")
                ? $(evt.currentTarget).attr("data-variant-id")
                : $(evt.currentTarget).attr("data-id");
              let prodTitle = $(evt.currentTarget).attr("data-product-name");
              let prodHandle = $(evt.currentTarget).attr("data-product-handle");

              let productInventory = await availableInventory(variantId);

              if (
                (quantity <= productInventory.availableQuantity &&
                  productInventory.isInStock) ||
                prodHandle === "bokksu-digital-gift-card"
              ) {
                this._change(this._getQty());
              } else {
                this._change(productInventory.availableQuantity);
                alert(
                  productInventory.availableQuantity
                    ? `We can ship a maximum of ${productInventory.availableQuantity} ${prodTitle} to your zip code.`
                    : `Item is out of stock at your location`
                );
              }
            } else {
              evt.stopImmediatePropagation();
              console.log("change listener");
              this._change(this._getQty());
            }
          }.bind(this)
          // ,
          // { once: true }
        );
      },

      _getQty: function () {
        var qty = this.input.value;
        if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function (qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
        this.input.value = qty;

        if (this.options.isCart == false) {
          if (
            $(".modal--is-active").length &&
            $(".modal--is-active .pdp-qty").attr("data-variant-id") !==
              $(".pdp-qty").attr("data-variant-id")
          ) {
            $(".modal--is-active .pdp-product-quantity").val(this.input.value);
            $(".modal--is-active .product_quantity").val(this.input.value);
          } else {
            $(".pdp-product-quantity").val(this.input.value);
            $(".product_quantity").val(this.input.value);
          }
          document.dispatchEvent(
            new CustomEvent("cart:quantity" + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper],
            })
          );

          let updates = {};
          updates[this.options.key] = qty;

          // theme.cart
          //   ._updateCart({
          //     url: "/cart/update.js",
          //     data: JSON.stringify({ updates: updates }),
          //     method: "POST",
          //     credentials: "same-origin",
          //     headers: {
          //       "Content-Type": "application/json",
          //     },
          //   })
          //   .then(function (cart) {
          //     console.log("change cart", qty);
          //     document.dispatchEvent(
          //       new CustomEvent("cart:build", {
          //         detail: {
          //           product: cart,
          //         },
          //       })
          //     );
          //   });
        }
        console.log("pQty", $(".product_quantity").val());
        if (this.options.isCart) {
          document.dispatchEvent(
            new CustomEvent("cart:quantity" + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper],
            })
          );
        }
      },
    });

    return QtySelector;
  })();

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function () {
    var classes = {
      animateOut: "animate-out",
      isPaused: "is-paused",
      isActive: "is-active",
    };

    var selectors = {
      allSlides: ".slideshow__slide",
      currentSlide: ".is-selected",
      wrapper: ".slideshow-wrapper",
      pauseButton: ".slideshow__pause",
    };

    var productSelectors = {
      thumb: ".product__thumb-item:not(.hide)",
      links: ".product__thumb-item:not(.hide) a",
      arrow: ".product__thumb-arrow",
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true,
    };

    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this),
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(
          productSelectors.thumb
        );
        this.childNavLinks = this.args.childNav.querySelectorAll(
          productSelectors.links
        );
        this.arrows = this.args.childNav.querySelectorAll(
          productSelectors.arrow
        );
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el);
      }

      this.slideshow = new Flickity(el, this.args);
      // Prevent dragging on the product slider from triggering a zoom on product images
      if (el.dataset.zoom && el.dataset.zoom === "true") {
        this.slideshow.on("dragStart", () => {
          this.slideshow.slider.style.pointerEvents = "none";

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector(
              ".is-selected"
            ).style.pointerEvents = "none";
          }
        });
        this.slideshow.on("dragEnd", () => {
          this.slideshow.slider.style.pointerEvents = "auto";

          // With fade enabled, we also need to adjust the pointerEvents on the selected slide
          if (this.slideshow.options.fade) {
            this.slideshow.slider.querySelector(
              ".is-selected"
            ).style.pointerEvents = "auto";
          }
        });
      }

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener("click", this._togglePause.bind(this));
        }
      }

      // Reset dimensions on resize
      window.on(
        "resize",
        theme.utils.debounce(
          300,
          function () {
            this.resize();
          }.bind(this)
        )
      );

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while (firstChild != null && firstChild.nodeType == 3) {
          // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement("style");
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function (el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === "function") {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }

        if (window.AOS) {
          AOS.refresh();
        }
      },

      slideChange: function (index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener(
            "transitionend",
            function () {
              this.currentSlide.classList.remove(classes.animateOut);
            }.bind(this)
          );
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === "function") {
            this.args.callbacks.onChange(index);
          }
        }

        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle("hide", index === 0);
          this.arrows[1].classList.toggle(
            "hide",
            index === this.childNavLinks.length - 1
          );
        }
      },
      afterChange: function (index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach((slide) => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function () {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach((a) => {
            a.classList.remove(classes.isActive);
          });
        }
        this.slideshow.destroy();
      },
      reposition: function () {
        this.slideshow.reposition();
      },
      _togglePause: function () {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function () {
        this.slideshow.resize();
      },
      play: function () {
        this.slideshow.playPlayer();
      },
      pause: function () {
        this.slideshow.pausePlayer();
      },
      goToSlide: function (i) {
        this.slideshow.select(i);
      },
      setDraggable: function (enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },

      initChildNav: function () {
        this.childNavLinks[this.args.initialIndex].classList.add("is-active");

        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute("data-index", i);

          link.addEventListener(
            "click",
            function (evt) {
              evt.preventDefault();
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            "focus",
            function (evt) {
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            "keydown",
            function (evt) {
              if (evt.keyCode === 13) {
                this.goToSlide(this.getChildIndex(evt.currentTarget));
              }
            }.bind(this)
          );
        });

        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach((arrow) => {
            arrow.addEventListener("click", this.arrowClick.bind(this));
          });
        }
      },

      getChildIndex: function (target) {
        return parseInt(target.dataset.index);
      },

      childNavGoTo: function (index) {
        this.childNavLinks.forEach((a) => {
          a.blur();
          a.classList.remove(classes.isActive);
        });

        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);

        if (!this.args.childNavScroller) {
          return;
        }

        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },

      arrowClick: function (evt) {
        if (
          evt.currentTarget.classList.contains("product__thumb-arrow--prev")
        ) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      },
    });

    return slideshow;
  })();

  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, set dynamicVariantsEnable to false in theme.liquid
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/

  theme.VariantAvailability = (function () {
    var classes = {
      disabled: "disabled",
    };

    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;

      this.init();
    }

    availability.prototype = Object.assign({}, availability.prototype, {
      init: function () {
        this.container.on(
          "variantChange" + this.namespace,
          this.setAvailability.bind(this)
        );

        // Set default state based on current selected variant
        this.setInitialAvailability();
      },

      // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
      createAvailableOptionsTree(variants, currentlySelectedValues) {
        // Reduce variant array into option availability tree
        return variants.reduce(
          (options, variant) => {
            // Check each option group (e.g. option1, option2, option3) of the variant
            Object.keys(options).forEach((index) => {
              if (variant[index] === null) return;

              let entry = options[index].find(
                (option) => option.value === variant[index]
              );

              if (typeof entry === "undefined") {
                // If option has yet to be added to the options tree, add it
                entry = { value: variant[index], soldOut: true };
                options[index].push(entry);
              }

              const currentOption1 = currentlySelectedValues.find(
                ({ value, index }) => index === "option1"
              );
              const currentOption2 = currentlySelectedValues.find(
                ({ value, index }) => index === "option2"
              );

              switch (index) {
                case "option1":
                  // Option1 inputs should always remain enabled based on all available variants
                  entry.soldOut =
                    entry.soldOut && variant.available ? false : entry.soldOut;
                  break;
                case "option2":
                  // Option2 inputs should remain enabled based on available variants that match first option group
                  if (
                    currentOption1 &&
                    variant["option1"] === currentOption1.value
                  ) {
                    entry.soldOut =
                      entry.soldOut && variant.available
                        ? false
                        : entry.soldOut;
                  }
                case "option3":
                  // Option 3 inputs should remain enabled based on available variants that match first and second option group
                  if (
                    currentOption1 &&
                    variant["option1"] === currentOption1.value &&
                    currentOption2 &&
                    variant["option2"] === currentOption2.value
                  ) {
                    entry.soldOut =
                      entry.soldOut && variant.available
                        ? false
                        : entry.soldOut;
                  }
              }
            });

            return options;
          },
          { option1: [], option2: [], option3: [] }
        );
      },

      setInitialAvailability: function () {
        this.container
          .querySelectorAll(".variant-input-wrap")
          .forEach((group) => {
            this.disableVariantGroup(group);
          });

        const currentlySelectedValues = this.currentVariantObject.options.map(
          (value, index) => {
            return { value, index: `option${index + 1}` };
          }
        );
        const initialOptions = this.createAvailableOptionsTree(
          this.variantsObject,
          currentlySelectedValues,
          this.currentVariantObject
        );

        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      },

      setAvailability: function (evt) {
        const {
          value: lastSelectedValue,
          index: lastSelectedIndex,
          currentlySelectedValues,
          variant,
        } = evt.detail;

        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        const valuesToManage = this.createAvailableOptionsTree(
          this.variantsObject,
          currentlySelectedValues,
          variant,
          lastSelectedIndex,
          lastSelectedValue
        );

        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values, lastSelectedValue);
        }
      },

      manageOptionState: function (option, values) {
        var group = this.container.querySelector(
          '.variant-input-wrap[data-index="' + option + '"]'
        );

        // Loop through each option value
        values.forEach((obj) => {
          this.enableVariantOption(group, obj);
        });
      },

      enableVariantOption: function (group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(
          /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
          "\\$1"
        );

        if (this.type === "dropdown") {
          group.querySelector('option[value="' + value + '"]').disabled = false;
        } else {
          var buttonGroup = group.querySelector(
            '.variant-input[data-value="' + value + '"]'
          );
          var input = buttonGroup.querySelector("input");
          var label = buttonGroup.querySelector("label");

          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);

          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }
      },

      disableVariantGroup: function (group) {
        if (this.type === "dropdown") {
          group.querySelectorAll("option").forEach((option) => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll("input").forEach((input) => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll("label").forEach((label) => {
            label.classList.add(classes.disabled);
          });
        }
      },
    });

    return availability;
  })();

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer;
    var vimeoPlayer;
    var videoHolderId = "VideoHolder";
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
      mp4Trigger: ".product-video-trigger--mp4",
      mp4Player: ".product-video-mp4-sound",
    };

    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var vimeoTriggers = document.querySelectorAll(selectors.vimeo);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (
      !youtubeTriggers.length &&
      !vimeoTriggers.length &&
      !mp4Triggers.length
    ) {
      return;
    }

    var videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load("youtubeSdk");
    }
    if (vimeoTriggers.length) {
      theme.LibraryLoader.load("vimeo", window.vimeoApiReady);
    }
    var modal = new theme.Modals("VideoModal", "video-modal", {
      closeOffContentClick: true,
      bodyOpenClass: ["modal-open", "video-modal-open"],
      solid: true,
    });

    youtubeTriggers.forEach((btn) => {
      btn.addEventListener("click", triggerYouTubeModal);
    });

    mp4Triggers.forEach((btn) => {
      btn.addEventListener("click", triggerMp4Modal);
    });
    vimeoTriggers.forEach((btn) => {
      btn.addEventListener("click", triggerVimeoModal);
    });
    document.addEventListener("modalClose.VideoModal", closeVideoModal);

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute("href"));
      youtubePlayer = new theme.YouTube(videoHolderId, {
        videoId: videoId,
        style: "sound",
        events: {
          onReady: onYoutubeReady,
        },
      });
    }
    function triggerVimeoModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.vimeoReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = evt.currentTarget.dataset.videoId;
      var videoLoop = evt.currentTarget.dataset.videoLoop;
      vimeoPlayer = new theme.VimeoPlayer(videoHolderId, videoId, {
        style: "sound",
        loop: videoLoop,
      });
    }
    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove("hide");

      videoHolderDiv.append(playerClone);
      modal.open(evt);

      // Play new video element
      videoHolderDiv.querySelector("video").play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = "";
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === "function") {
        youtubePlayer.destroy();
      } else if (vimeoPlayer && typeof vimeoPlayer.destroy === "function") {
        vimeoPlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };
  /*============================================================================
    PredictiveSearch
  ==============================================================================*/

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.enabled = this.getAttribute("data-enabled");
      this.context = this.getAttribute("data-context");
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector("#predictive-search");
      this.closeBtn = this.querySelector(".btn--close-search");
      this.closeBtn1 = this.querySelector(".btn--close-search1");

      this.screen = this.querySelector("[data-screen]");
      this.SearchModal = this.closest("#SearchModal") || null;

      // Open events
      document.addEventListener("predictive-search:open", (e) => {
        if (e.detail.context !== this.context) return;
        this.classList.add("is-active");

        // Wait for opening events to finish then apply focus
        setTimeout(() => {
          this.input.focus();
        }, 100);
      });

      // listen for class change of 'modal--is-active on this.SearchModal
      if (this.SearchModal) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === "class") {
              const modalClass = mutation.target.className;
              if (modalClass.indexOf("modal--is-active") > -1) {
                setTimeout(() => {
                  this.input.focus();
                }, 100);
              }
            }
          });
        });

        observer.observe(this.SearchModal, {
          attributes: true,
        });
      }

      if (this.enabled === "false") return;

      // On typing
      this.input.addEventListener("keydown", () => {
        this.classList.add("is-active");
      });

      this.input.addEventListener(
        "input",
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      // Close events
      document.addEventListener("predictive-search:close", () => {
        this.close();
      });
      document.addEventListener("keydown", (event) => {
        if (event.keyCode === 27) this.close();
      });
      this.closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.close();
      });
      this.screen.addEventListener("click", () => {
        this.close();
      });
    }

    onChange() {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      const searchObj = {
        q: searchTerm,
        "resources[limit]": 3,
        "resources[limit_scope]": "each",
        "resources[options][unavailable_products]": "last",
      };

      const params = this.paramUrl(searchObj);

      fetch(
        `${theme.routes.predictiveSearch}?${params}&section_id=search-results`
      )
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-search-results").innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();

          AOS.refreshHard();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    open() {
      this.predictiveSearchResults.style.display = "block";
      document.body.classList.add("predictive-overflow-hidden");
    }

    close() {
      this.predictiveSearchResults.style.display = "none";
      this.predictiveSearchResults.innerHTML = "";
      this.classList.remove("is-active");
      document.body.classList.remove("predictive-overflow-hidden");

      document.dispatchEvent(new CustomEvent("predictive-search:close-all"));
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    paramUrl(obj) {
      return Object.keys(obj)
        .map(function (key) {
          return key + "=" + encodeURIComponent(obj[key]);
        })
        .join("&");
    }
  }

  customElements.define("predictive-search", PredictiveSearch);
  /*============================================================================
    ImageElement
  ==============================================================================*/

  class ImageElement extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    init() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        this.removeAnimations();

        observer.unobserve(this);
      };

      // Set an IntersectionObserver to check if the image is nearly in the viewport
      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }

    removeAnimations() {
      // Find the closest image-wrap and remove the animation (fix for streamline image-wrap shimmer)
      const imageWrap = this.closest(".image-wrap");
      const skrimWrap = this.closest(".skrim__link");

      if (imageWrap) {
        imageWrap.classList.add("loaded");
      }

      if (skrimWrap) {
        skrimWrap.classList.add("loaded");
      }
    }
  }

  customElements.define("image-element", ImageElement);

  theme.announcementBar = (function () {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? "right" : "left",
      fade: true,
    };
    var bar;
    var flickity;

    function init() {
      bar = document.getElementById("AnnouncementSlider");
      if (!bar) {
        return;
      }

      unload();

      if (bar.dataset.blockCount === 1) {
        return;
      }

      flickity = new theme.Slideshow(bar, args);
    }

    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector("#AnnouncementSlide-" + id);
      var index = parseInt(slide.dataset.index);

      if (flickity && typeof flickity.pause === "function") {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }

    function onBlockDeselect() {
      if (flickity && typeof flickity.play === "function") {
        flickity.play();
      }
    }

    function unload() {
      if (flickity && typeof flickity.destroy === "function") {
        flickity.destroy();
      }
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload,
    };
  })();

  theme.headerNav = (function () {
    var selectors = {
      wrapper: "#HeaderWrapper",
      siteHeader: "#SiteHeader",
      logo: "#LogoContainer img",
      megamenu: ".megamenu",
      navigation: ".site-navigation",
      navItems: ".site-nav__item",
      navLinks: ".site-nav__link",
      navLinksWithDropdown: ".site-nav__link--has-dropdown",
      navDropdownLinks: ".site-nav__dropdown-link--second-level",
      triggerCollapsedMenu: ".site-nav__compress-menu",
      collapsedMenu: '[data-type="nav"]',
      bottomSearch: '[data-type="search"]',
      navDetails: ".site-nav__details",
    };

    var classes = {
      hasDropdownClass: "site-nav--has-dropdown",
      hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
      dropdownActive: "is-focused",
      headerCompressed: "header-wrapper--compressed",
      overlay: "header-wrapper--overlay",
      overlayStyle: "is-light",
    };

    var config = {
      namespace: ".siteNav",
      wrapperOverlayed: false,
      stickyEnabled: false,
      stickyActive: false,
      subarPositionInit: false,
      threshold: 0,
    };

    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;
    var bottomNav;
    var bottomSearch;

    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);
      bottomNav = wrapper.querySelector(selectors.collapsedMenu);
      bottomSearch = wrapper.querySelector(selectors.bottomSearch);

      // Trigger collapsed state at top of header
      config.threshold = wrapper.getBoundingClientRect().top;

      config.subarPositionInit = false;
      config.stickyEnabled = siteHeader.dataset.sticky === "true";
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(
          classes.overlayStyle
        );
        stickyHeaderCheck();
      } else {
        disableSticky();
      }

      theme.settings.overlayHeader = siteHeader.dataset.overlay === "true";
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (
          document.body.classList.contains("template-collection") &&
          !document.querySelector(".collection-hero")
        ) {
          this.disableOverlayHeader();
        }
      }

      // Position menu and search bars absolutely, offsetting their height
      // with an invisible div to prevent reflows
      setAbsoluteBottom();
      window.on(
        "resize" + config.namespace,
        theme.utils.debounce(250, setAbsoluteBottom)
      );

      var collapsedNavTrigger = wrapper.querySelector(
        selectors.triggerCollapsedMenu
      );
      if (collapsedNavTrigger) {
        collapsedNavTrigger.on("click", function () {
          collapsedNavTrigger.classList.toggle("is-active");
          theme.utils.prepareTransition(bottomNav, function () {
            bottomNav.classList.toggle("is-active");
          });
        });
      }

      menuDetailsHandler();

      var navigation = siteHeader.querySelector(selectors.navigation);
      if (navigation.querySelectorAll(".grid-product")) {
        new theme.QuickAdd(navigation);
        new theme.QuickShop(navigation);
      }
      //removed in 4.3
      // window.on("load" + config.namespace, resizeLogo);
      // window.on(
      //   "resize" + config.namespace,
      //   theme.utils.debounce(150, resizeLogo)
      // );
    }

    // Measure sub menu bar, set site header's bottom padding to it.
    // Set sub bars as absolute to avoid page jumping on collapsed state change.
    function setAbsoluteBottom() {
      if (theme.settings.overlayHeader) {
        document
          .querySelector(".header-section")
          .classList.add("header-section--overlay");
      }

      var activeSubBar = theme.config.bpSmall
        ? document.querySelector(
            '.site-header__element--sub[data-type="search"]'
          )
        : document.querySelector('.site-header__element--sub[data-type="nav"]');

      if (activeSubBar) {
        var h = activeSubBar.offsetHeight;
        // If height is 0, it was measured when hidden so ignore it.
        // Very likely it's on mobile when the address bar is being
        // hidden and triggers a resize
        if (h !== 0) {
          document.documentElement.style.setProperty(
            "--header-padding-bottom",
            h + "px"
          );
        }

        // If not setup before, set active class on wrapper so subbars become absolute
        if (!config.subarPositionInit) {
          wrapper.classList.add("header-wrapper--init");
          config.subarPositionInit = true;
        }
      }
    }

    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(
        config.overlayEnabledClass,
        classes.overlayStyle
      );
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }

    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();

      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
        disableSticky();
      }
    }

    function disableSticky() {
      document.querySelector(".header-section").style.position = "relative";
    }

    function removeOverlayClass() {
      if (config.wrapperOverlayed) {
        wrapper.classList.remove(classes.overlayStyle);
      }
    }

    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach((nav) => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });

      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < largestMegaNav + 120) {
        return false;
      }

      return true;
    }

    function stickyHeader() {
      if (window.scrollY > config.threshold) {
        stickyHeaderScroll();
      }

      window.on("scroll" + config.namespace, stickyHeaderScroll);
    }

    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }

      if (config.forceStopSticky) {
        return;
      }

      requestAnimationFrame(scrollHandler);
    }

    function scrollHandler() {
      if (window.scrollY > config.threshold) {
        if (config.stickyActive) {
          return;
        }

        if (bottomNav) {
          theme.utils.prepareTransition(bottomNav);
        }
        if (bottomSearch) {
          theme.utils.prepareTransition(bottomSearch);
        }

        config.stickyActive = true;

        wrapper.classList.add(classes.headerCompressed);

        $("body").addClass("body-scroll-content");

        if (config.wrapperOverlayed) {
          wrapper.classList.remove(classes.overlayStyle);
        }

        document.dispatchEvent(new CustomEvent("headerStickyChange"));
      } else {
        if (!config.stickyActive) {
          return;
        }

        if (bottomNav) {
          theme.utils.prepareTransition(bottomNav);
        }
        if (bottomSearch) {
          theme.utils.prepareTransition(bottomSearch);
        }

        config.stickyActive = false;

        // Update threshold in case page was loaded down the screen
        config.threshold = wrapper.getBoundingClientRect().top;

        wrapper.classList.remove(classes.headerCompressed);

        $("body").removeClass("body-scroll-content");
        $(".main-menu-new").removeClass("show-categories");
        $(".ctaegories-icon").removeClass("icon-change");

        if (config.wrapperOverlayed) {
          if (!$(".site-header__drawer.is-active").is(":visible")) {
            wrapper.classList.add(classes.overlayStyle);
          }
        }

        document.dispatchEvent(new CustomEvent("headerStickyChange"));
      }
    }

    function menuDetailsHandler() {
      /*    var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;

      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        document
          .querySelectorAll(selectors.navLinksWithDropdown)
          .forEach((el) => {
            el.on("touchend" + config.namespace, function (evt) {
              var parent = evt.currentTarget.parentNode;
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeDropdowns();
                openFirstLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute("href"));
              }
            });
          });
      }

      // Open/hide top level dropdowns
      document.querySelectorAll(selectors.navLinks).forEach((el) => {
        el.on("focusin" + config.namespace, accessibleMouseEvent);
        el.on("mouseover" + config.namespace, accessibleMouseEvent);
        el.on("mouseleave" + config.namespace, closeDropdowns);
      });

      document.querySelectorAll(selectors.navDropdownLinks).forEach((el) => {
        if (theme.config.isTouch) {
          el.on("touchend" + config.namespace, function (evt) {
            var parent = evt.currentTarget.parentNode;

            // Open third level menu or go to link based on active state
            if (parent.classList.contains(classes.hasSubDropdownClass)) {
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeThirdLevelDropdown();
                openSecondLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute("href"));
              }
            } else {
              // No third level nav, go to link
              window.location.replace(evt.currentTarget.getAttribute("href"));
            }
          });
        }

        // Open/hide sub level dropdowns
        el.on("focusin" + config.namespace, function (evt) {
          closeThirdLevelDropdown();
          openSecondLevelDropdown(evt.currentTarget, true);
        });
      });

      // Clicking outside of the megamenu should close it
      if (theme.config.isTouch) {
        document.body.on("touchend" + config.namespace, function () {
          closeDropdowns();
        });

        // Exception to above: clicking anywhere on the megamenu content will NOT close it
        siteHeader.querySelectorAll(selectors.megamenu).forEach((el) => {
          el.on("touchend" + config.namespace, function (evt) {
            evt.stopImmediatePropagation();
          });
        });
      }

      function accessibleMouseEvent(evt) {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }

        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }

        openFirstLevelDropdown(evt.currentTarget);
      }

      // Private dropdown functions
      function openFirstLevelDropdown(el) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasDropdownClass)) {
          parent.classList.add(classes.dropdownActive);
          hasActiveDropdown = true;
        }

        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? "touchend" : "click";
            closeOnClickActive = true;
            document.documentElement.on(
              eventType + config.namespace,
              function () {
                closeDropdowns();
                document.documentElement.off(eventType + config.namespace);
                closeOnClickActive = false;
              }.bind(this)
            );
          }
        }
      }

      function openSecondLevelDropdown(el, skipCheck) {
        var parent = el.parentNode;
        if (
          parent.classList.contains(classes.hasSubDropdownClass) ||
          skipCheck
        ) {
          parent.classList.add(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }

      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }

      function closeSecondLevelDropdown() {
        document.querySelectorAll(selectors.navItems).forEach((el) => {
          el.classList.remove(classes.dropdownActive);
        });
      }

      function closeThirdLevelDropdown() {
        document.querySelectorAll(selectors.navDropdownLinks).forEach((el) => {
          el.parentNode.classList.remove(classes.dropdownActive);
        });
      }
    }

    function resizeLogo(evt) {
      document.querySelectorAll(selectors.logo).forEach((logo) => {
        var logoWidthOnScreen = logo.clientWidth;
        var containerWidth = logo.closest(".header-item").clientWidth;

        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          logo.style.maxWidth = containerWidth;
        } else {
          logo.removeAttribute("style");
        }
      });
    }
    return {
      init: init,
      removeOverlayClass: removeOverlayClass,
      disableOverlayHeader: disableOverlayHeader,
    }; */

      const navDetails = document.querySelectorAll(selectors.navDetails);

      navDetails.forEach((navDetail) => {
        const summary = navDetail.querySelector("summary");

        // if the navDetail is open, then close it when the user clicks outside of it
        document.addEventListener("click", (evt) => {
          if (
            navDetail.hasAttribute("open") &&
            !navDetail.contains(evt.target)
          ) {
            navDetail.removeAttribute("open");
            summary.setAttribute("aria-expanded", "false");
          } else {
            if (navDetail.hasAttribute("open")) {
              summary.setAttribute("aria-expanded", "false");
            } else {
              summary.setAttribute("aria-expanded", "true");
            }
          }
        });
      });
    }

    return {
      init: init,
      removeOverlayClass: removeOverlayClass,
      disableOverlayHeader: disableOverlayHeader,
    };
  })();

  /*============================================================================
    MobileNav has two uses:
    - Dropdown from header on small screens
    - Duplicated into footer, initialized as separate entity in theme.HeaderSection
  ==============================================================================*/
  theme.MobileNav = (function () {
    var selectors = {
      wrapper: ".slide-nav__wrapper",
      nav: ".slide-nav",
      childList: ".slide-nav__dropdown",
      allLinks: "a.slide-nav__link",
      subNavToggleBtn: ".js-toggle-submenu",

      // Trigger to open header nav
      openBtn: ".mobile-nav-trigger",
    };

    var classes = {
      isActive: "is-active",
    };

    var defaults = {
      isOpen: false,
      menuLevel: 1,
      inHeader: false,
    };

    function MobileNav(args) {
      this.config = Object.assign({}, defaults, args);
      this.namespace = ".nav-header-" + args.id;

      this.container = document.getElementById(this.config.id);
      if (!this.container) {
        return;
      }

      this.wrapper = this.container.querySelector(selectors.wrapper);
      if (!this.wrapper) {
        return;
      }
      this.nav = this.wrapper.querySelector(selectors.nav);
      this.openTriggers = document.querySelectorAll(selectors.openBtn);

      this.init();
    }

    MobileNav.prototype = Object.assign({}, MobileNav.prototype, {
      init: function () {
        // Open/close mobile nav
        if (this.openTriggers.length) {
          this.openTriggers.forEach((btn) => {
            btn.addEventListener(
              "click",
              function () {
                if (this.config.isOpen) {
                  this.close();
                } else {
                  this.open();
                }
              }.bind(this)
            );
          });
        }

        // Toggle between menu levels
        this.nav.querySelectorAll(selectors.subNavToggleBtn).forEach((btn) => {
          btn.addEventListener("click", this.toggleSubNav.bind(this));
        });

        // Close nav when a normal link is clicked
        this.nav.querySelectorAll(selectors.allLinks).forEach((link) => {
          link.addEventListener("click", this.close.bind(this));
        });

        if (this.inHeader) {
          document.addEventListener(
            "unmatchSmall",
            function () {
              this.close(null, true);
            }.bind(this)
          );

          document.addEventListener("CartDrawer:open", this.close.bind(this));

          // Dev-friendly way to open/close mobile nav
          document.addEventListener("mobileNav:open", this.open.bind(this));
          document.addEventListener("mobileNav:close", this.close.bind(this));
        }
      },

      /*============================================================================
        Open/close mobile nav drawer in header
      ==============================================================================*/
      open: function (evt) {
      
        if (evt) {
          evt.preventDefault();
        }

        theme.sizeDrawer();

        this.openTriggers.forEach((btn) => {
          btn.classList.add("is-active");
        });

        theme.utils.prepareTransition(
          this.container,
          function () {
            this.container.classList.add("is-active");
          }.bind(this)
        );

        // Esc closes cart popup
        window.on(
          "keyup" + this.namespace,
          function (evt) {
            if (evt.keyCode === 27) {
              this.close();
            }
          }.bind(this)
        );

        theme.headerNav.removeOverlayClass();

        document.documentElement.classList.add("mobile-nav-open");
        document.dispatchEvent(new CustomEvent("MobileNav:open"));

        this.config.isOpen = true;

        // Clicking out of menu closes it. Timeout to prevent immediate bubbling
        setTimeout(
          function () {
            window.on(
              "click" + this.namespace,
              function (evt) {
                this.close(evt);
              }.bind(this)
            );
          }.bind(this),
          0
        );
      },

      close: function (evt, noAnimate) {
        var forceClose = false;
        // Do not close if click event came from inside drawer,
        // unless it is a normal link with no children
        if (
          evt &&
          evt.target.closest &&
          evt.target.closest(".site-header__drawer")
        ) {
          // If normal link, continue to close drawer
          if (evt.currentTarget && evt.currentTarget.classList) {
            if (evt.currentTarget.classList.contains("slide-nav__link")) {
              forceClose = true;
            }
          }

          if (!forceClose) {
            return;
          }
        }

        this.openTriggers.forEach((btn) => {
          btn.classList.remove("is-active");
        });

        if (noAnimate) {
          $("#MainContent").removeClass("blur-body");

          this.container.classList.remove("is-active");
        } else {
          theme.utils.prepareTransition(
            this.container,
            function () {
              $("#MainContent").removeClass("blur-body");

              this.container.classList.remove("is-active");
            }.bind(this)
          );
        }

        document.documentElement.classList.remove("mobile-nav-open");
        document.dispatchEvent(new CustomEvent("MobileNav:close"));

        window.off("keyup" + this.namespace);
        window.off("click" + this.namespace);

        this.config.isOpen = false;
      },

      /*============================================================================
        Handle switching between nav levels
      ==============================================================================*/
      toggleSubNav: function (evt) {
        var btn = evt.currentTarget;
        this.goToSubnav(btn.dataset.target);
      },

      // If a level is sent we are going up, so target list doesn't matter
      goToSubnav: function (target) {
        // Activate new list if a target is passed
        var targetMenu = this.nav.querySelector(
          selectors.childList + '[data-parent="' + target + '"]'
        );
        if (targetMenu) {
          this.config.menuLevel = targetMenu.dataset.level;

          // Hide all level 3 menus if going to level 2
          if (this.config.menuLevel == 2) {
            this.nav
              .querySelectorAll(selectors.childList + '[data-level="3"]')
              .forEach((list) => {
                list.classList.remove(classes.isActive);
              });
          }

          targetMenu.classList.add(classes.isActive);
          this.setWrapperHeight(targetMenu.offsetHeight);
        } else {
          // Going to top level, reset
          this.config.menuLevel = 1;
          this.wrapper.removeAttribute("style");
          this.nav.querySelectorAll(selectors.childList).forEach((list) => {
            list.classList.remove(classes.isActive);
          });
        }

        this.wrapper.dataset.level = this.config.menuLevel;
      },

      setWrapperHeight: function (h) {
        this.wrapper.style.height = h + "px";
      },
    });

    return MobileNav;
  })();

  theme.headerSearch = (function () {
    var currentString = "";
    var isLoading = false;
    var searchTimeout;

    var selectors = {
      form: ".site-header__search-form",
      input: 'input[type="search"]',

      searchInlineContainer: ".site-header__search-container",
      searchInlineBtn: ".js-search-header",

      searchButton: "[data-predictive-search-button]",
      closeSearch: ".site-header__search-btn--cancel",
      closeSearch1: ".btn--close-search1",

      wrapper: "#SearchResultsWrapper",
      topSearched: "#TopSearched",
      predictiveWrapper: "#PredictiveWrapper",
      resultDiv: "#PredictiveResults",
    };

    var cache = {};
    var activeForm;

    var classes = {
      isActive: "predicitive-active",
    };

    var config = {
      namespace: ".search",
      topSearched: false,
      predictiveSearch: false,
      imageSize: "square",
      predictiveImageFill: true,
    };

    var keys = {
      esc: 27,
      up_arrow: 38,
      down_arrow: 40,
      tab: 9,
    };

    function init() {
      initInlineSearch();

      cache.wrapper = document.querySelector(selectors.wrapper);
      if (!cache.wrapper) {
        return;
      }

      cache.topSearched = document.querySelector(selectors.topSearched);
      if (cache.topSearched) {
        config.topSearched = true;
      }

      if (theme.settings.predictiveSearch) {
        // Only some languages support predictive search
        if (document.getElementById("shopify-features")) {
          var supportedShopifyFeatures = JSON.parse(
            document.getElementById("shopify-features").innerHTML
          );
          if (supportedShopifyFeatures.predictiveSearch) {
            config.predictiveSearch = true;
          }
        }
      }

      if (config.predictiveSearch) {
        cache.predictiveWrapper = document.querySelector(
          selectors.predictiveWrapper
        );
        config.imageSize = cache.predictiveWrapper.dataset.imageSize;
        cache.results = document.querySelector(selectors.resultDiv);
        cache.submit = cache.predictiveWrapper.querySelector(
          selectors.searchButton
        );
        cache.submit.on("click" + config.namespace, triggerSearch);
      }

      document.querySelectorAll(selectors.form).forEach((form) => {
        initForm(form);
      });
    }

    function initForm(form) {
      form.setAttribute("autocomplete", "off");
      form.on("submit" + config.namespace, submitSearch);

      var input = form.querySelector(selectors.input);
      input.on("focus" + config.namespace, handleFocus);
      if (config.predictiveSearch) {
        input.on("keyup" + config.namespace, handleKeyup);
      }
    }

    function reset() {
      if (config.predictiveSearch) {
        cache.predictiveWrapper.classList.add("hide");
        cache.results.innerHTML = "";
        clearTimeout(searchTimeout);
      }

      if (config.topSearched) {
        cache.topSearched.classList.remove("hide");
      } else {
        cache.wrapper.classList.add("hide");
      }
    }

    function close(evt) {
      // If close button is clicked, close as expected.
      // Otherwise, ignore clicks in search results, search form, or container elements
      if (evt && evt.target.closest) {
        if (evt.target.closest(selectors.closeSearch)) {
        } else {
          if (evt.target.closest(".site-header__search-form")) {
            return;
          } else if (evt.target.closest(".site-header__element--sub")) {
            return;
          } else if (evt.target.closest("#SearchResultsWrapper")) {
            return;
          } else if (evt.target.closest(".site-header__search-container")) {
            return;
          }
        }
      }
      //emit predictive search close event
      document.dispatchEvent(
        new CustomEvent("predictive-search:close", { bubbles: true })
      );
      // deselect any focused form elements
      document.activeElement.blur();

      if (cache.wrapper) {
        cache.wrapper.classList.add("hide");
      }
      if (config.topSearched) {
        cache.topSearched.classList.remove("hide");
      }

      if (config.predictiveSearch) {
        cache.predictiveWrapper.classList.add("hide");
        clearTimeout(searchTimeout);
      }

      if (cache.inlineSearchContainer) {
        cache.inlineSearchContainer.classList.remove("is-active");
      }

      document.querySelectorAll(selectors.form).forEach((form) => {
        form.classList.remove("is-active");
      });

      window.off("click" + config.namespace);
    }

    function initInlineSearch() {
      cache.inlineSearchContainer = document.querySelector(
        selectors.searchInlineContainer
      );
      document.querySelectorAll(selectors.searchInlineBtn).forEach((btn) => {
        btn.addEventListener("click", openInlineSearch);
      });
    }

    function openInlineSearch(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var container = document.querySelector(selectors.searchInlineContainer);
      container.classList.add("is-active");
      container.focus();
      document.querySelector(selectors.closeSearch1).style.display = "block";
      //emit predictive search open event
      document.dispatchEvent(
        new CustomEvent("predictive-search:open", {
          detail: {
            context: "header",
          },
          bubbles: true,
        })
      );
      enableCloseListeners();
    }

    function triggerSearch() {
      if (activeForm) {
        activeForm.submit();
      }
    }

    // Append * wildcard to search
    function submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);

      var obj = {};
      var formData = new FormData(evt.target);
      for (var key of formData.keys()) {
        obj[key] = formData.get(key);
      }

      if (obj.q) {
        obj.q += "*";
      }

      var params = paramUrl(obj);

      window.location.href = `${theme.routes.search}?${params}`;
      return false;
    }

    function handleKeyup(evt) {
      activeForm = evt.currentTarget.closest("form");

      if (evt.keyCode === keys.up_arrow) {
        return;
      }

      if (evt.keyCode === keys.down_arrow) {
        return;
      }

      if (evt.keyCode === keys.tab) {
        return;
      }

      if (evt.keyCode === keys.esc) {
        close();
        return;
      }

      search(evt.currentTarget);
    }

    function handleFocus(evt) {
      evt.currentTarget.parentNode.classList.add("is-active");
      if (config.topSearched) {
        cache.wrapper.classList.remove("hide");
      }

      enableCloseListeners();
    }

    function enableCloseListeners() {
      // Clicking out of search area closes it. Timeout to prevent immediate bubbling
      setTimeout(function () {
        window.on("click" + config.namespace, function (evt) {
          close(evt);
        });
      }, 0);

      // Esc key also closes search
      window.on("keyup", function (evt) {
        if (evt.keyCode === 27) {
          close();
        }
      });

      //listen for predictive-search:close
      document.addEventListener(
        "predictive-search:close-all",
        function () {
          close();
        },
        { once: true }
      );
    }

    function search(input) {
      var keyword = input.value;

      if (keyword === "") {
        reset();
        return;
      }

      var q = _normalizeQuery(keyword);

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }

    function predictQuery(q) {
      if (isLoading) {
        return;
      }

      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }

      currentString = q;
      isLoading = true;

      var searchObj = {
        q: q,
        "resources[type]": window.location.href.includes("/blogs/")
          ? "article"
          : theme.settings.predictiveSearchType,
        "resources[limit]": 4,
        "resources[options][unavailable_products]": "last",
        "resources[options][fields]":
          "title,product_type,variants.title,vendor",
      };

      var params = paramUrl(searchObj);

      fetch("/search/suggest.json?" + params)
        .then((response) => response.json())
        .then((suggestions) => {
          isLoading = false;
          var data = {};
          var resultCount = 0;

          if (cache.topSearched) {
            cache.topSearched.classList.add("hide");
          }
          cache.predictiveWrapper.classList.remove("hide");
          var resultTypes = Object.entries(suggestions.resources.results);

          Object.keys(resultTypes).forEach(function (i) {
            var obj = resultTypes[i];
            var type = obj[0];
            var results = obj[1];
            resultCount += results.length;

            switch (type) {
              case "products":
                data[type] = buildProducts(results);
                break;
              case "collections":
                data[type] = buildCollections(results);
                break;
              case "pages":
                data[type] = buildPages(results);
                break;
              case "articles":
                data[type] = buildArticles(results);
                break;
            }
          });

          if (resultCount === 0) {
            reset();
            return;
          }

          // Build and append result markup
          var output = buildOutput(data);
          cache.results.innerHTML = "";
          cache.results.innerHTML = output;

          cache.wrapper.classList.remove("hide");
        });
    }

    function buildProducts(results) {
      var output = "";
      var products = [];

      results.forEach((product) => {
        if (!product.tags.includes("free gift")) {
          var new_product = {
            title: product.title,
            url: product.url,
            type: product.type,
            image_responsive_url: theme.Images.buildImagePath(product.image),
            image_aspect_ratio: product.featured_image.aspect_ratio,
          };

          products.push(new_product);
        }
      });

      if (products.length) {
        var markup = theme.buildProductGridItem(products, config.imageSize);

        output = `
          <div data-type-products>
            <div class="new-grid product-grid" data-view="small">
              ${markup}
            </div>
          </div>
        `;
      }

      return output;
    }

    function buildCollections(collections) {
      var output = "";

      if (collections.length) {
        var markup = theme.buildCollectionItem(collections);

        output = `
          <div data-type-collections>
            <p class="h6 predictive__label">${theme.strings.searchCollections}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    function buildPages(pages) {
      var output = "";

      if (pages.length) {
        var markup = theme.buildPageItem(pages);

        output = `
          <div data-type-pages>
            <p class="h6 predictive__label">${theme.strings.searchPages}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function buildArticles(articles) {
      var output = "";

      articles.forEach((article) => {
        if (article.image) {
          article.image = theme.Images.getSizedImageUrl(
            article.image,
            "200x200_crop_center"
          );
        }
      });

      if (articles.length) {
        var markup = theme.buildArticleItem(articles, config.imageSize);

        output = `
          <div data-type-articles>
            <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
            <div class="grid grid--uniform grid--no-gutters">
              ${markup}
            </div>
          </div>
        `;
      }

      return output;
    }

    // Combine all search result markup and print to page
    function buildOutput(data) {
      var output = "";

      if (data.products && data.products !== "") {
        output += data.products;
      }

      if (data.collections && data.collections !== "") {
        output += data.collections;
      }

      if (data.pages && data.pages !== "") {
        output += data.pages;
      }

      if (data.articles && data.articles !== "") {
        output += data.articles;
      }

      return output;
    }

    function _normalizeQuery(string) {
      if (typeof string !== "string") {
        return null;
      }

      return string.trim().replace(/\ /g, "-").toLowerCase();
    }

    function paramUrl(obj) {
      return Object.keys(obj)
        .map(function (key) {
          return key + "=" + encodeURIComponent(obj[key]);
        })
        .join("&");
    }

    return {
      init: init,
    };
  })();

  theme.HeaderCart = (function () {
    var selectors = {
      cartTrigger: "#HeaderCartTrigger",
      cart: "#HeaderCart",

      closeBtn: ".js-close-header-cart",
      noteBtn: ".add-note",
    };

    var classes = {
      hidden: "hide",
    };

    var config = {
      cartOpen: false,
      namespace: ".cart-header",
    };

    function HeaderCart() {
      this.wrapper = document.querySelector(selectors.cart);
      if (!this.wrapper) {
        return;
      }
      this.trigger = document.querySelector(selectors.cartTrigger);
      this.noteBtn = this.wrapper.querySelector(selectors.noteBtn);
      this.form = this.wrapper.querySelector("form");

      // Close header cart
      document.addEventListener("MobileNav:open", this.close.bind(this));
      document.addEventListener("modalOpen", this.close.bind(this));

      this.init();
    }

    HeaderCart.prototype = Object.assign({}, HeaderCart.prototype, {
      init: function () {
        this.cartForm = new theme.CartForm(this.form);
        this.quickAdd = new theme.QuickAdd(this.wrapper);
        this.quickShop = new theme.QuickShop(this.wrapper);
        this.cartForm.buildCart();

        $(".mini-cart").on("click", this.open.bind(this));

        document.querySelectorAll(selectors.closeBtn).forEach((btn) => {
          console.log("btn");

          btn.addEventListener(
            "click",
            function () {
              this.close();
            }.bind(this)
          );
          //  }
        });

        if (this.noteBtn) {
          this.noteBtn.addEventListener(
            "click",
            function () {
              this.noteBtn.classList.toggle("is-active");
              this.wrapper
                .querySelector(".cart__note")
                .classList.toggle("hide");
            }.bind(this)
          );
        }

        // Dev-friendly way to open cart
        document.addEventListener("cart:open", this.open.bind(this));
        document.addEventListener("cart:close", this.close.bind(this));
      },

      open: function (evt) {
        
        // theme.cart.OOSAlert();
        $(".box-cart-main").addClass("hide-floating");
        $("#main-class").addClass('hide-banner')
        if (theme.settings.cartType !== "dropdown") {
          return;
        }

        if ($(".site-header__drawer-animate").hasClass("is-empty")) {
          setTimeout(() => {
            $($(".listing-empty-cart a")[0]).focus();
          }, 2000);
        } else {
          setTimeout(() => {
            $("#title-price-minicart").focus();
          }, 0);
        }

        if (evt) {
          evt.preventDefault();
        }

        theme.sizeDrawer();

        theme.utils.prepareTransition(
          this.wrapper,
          function () {
            this.wrapper.classList.add("is-active");
            $("#HeaderCart").addClass("is-cart-open");
            this.wrapper.scrollTop = 0;
          }.bind(this)
        );

        document.documentElement.classList.add("cart-open");

        // Don't lock mobile scrolling if sticky header isn't present
        if (!theme.config.bpSmall && theme.settings.overlayHeader) {
          theme.a11y.lockMobileScrolling(config.namespace);
        }

        // Esc closes cart popup
        window.on(
          "keyup" + config.namespace,
          function (evt) {
            if (evt.keyCode === 27) {
              this.close();
            }
          }.bind(this)
        );

        theme.headerNav.removeOverlayClass();

        document.dispatchEvent(new CustomEvent("CartDrawer:open"));
        document.dispatchEvent(new CustomEvent("drawerOpen"));
        // Clicking out of cart closes it. Timeout to prevent immediate bubbling
        setTimeout(
          function () {
            window.on(
              "click" + config.namespace,
              function (evt) {
                let clickedElement = evt.target;
                var parentElement = clickedElement.parentElement;
                if (
                  !parentElement.classList.contains("sn-close-noty") &&
                  clickedElement.tagName !== "svg" &&
                  clickedElement.tagName !== "line" &&
                  clickedElement.tagName !== "a" &&
                  clickedElement.tagName !== "A"
                ) {
                  this.close(evt);
                }
              }.bind(this)
            );
          }.bind(this),
          0
        );
        updateCartItems(null);
        config.cartOpen = true;
      },

      close: function (evt) {
        // alert('close check');
        $("#main-class").removeClass('hide-banner')
        if (theme.settings.cartType !== "dropdown") {
          return;
        }
        if (
          evt &&
          evt.target &&
          typeof evt.target.closest === "function" &&
          evt.target.closest(".quick-add-btn") &&
          $("#HeaderCart").hasClass("is-active")
        ) {
          return;
        }

        // Do not close if click event came from inside drawer
        if (
          (evt &&
            evt.target.closest &&
            evt.target.closest(".site-header__cart")) ||
          (evt && evt.target.closest && evt.target.closest(".cart-items-new"))
        ) {
          return;
        }
        evt &&
        evt.target.closest &&
        (evt.target.closest(".js-qty__adjust--minus") ||
          evt.target.closest(".adjust js-qty__adjust--plus"))
          ? $(".box-cart-main").addClass("hide-floating")
          : $(".box-cart-main").removeClass("hide-floating hide-floating-new");
        if (!config.cartOpen) {
          return;
        }

        // If custom event, close without transition
        if (evt && evt.type === "MobileNav:open") {
          this.wrapper.classList.remove("is-active");
        } else {
          theme.utils.prepareTransition(
            this.wrapper,
            function () {
              // alert('close hora');
              this.wrapper.classList.remove("is-active");
              $("#HeaderCart").removeClass("is-cart-open");
              // $("#HeaderCart").removeClass("is-transitioning")
            }.bind(this)
          );
        }

        window.off("keyup" + config.namespace);
        window.off("click" + config.namespace);

        if (!theme.config.bpSmall && theme.settings.overlayHeader) {
          theme.a11y.unlockMobileScrolling(config.namespace);
        }

        document.documentElement.classList.remove("cart-open");

        console.log("Remove cart");
        // $("body").removeClass("no-scroll");
        // $("body").css({ overflowY: "auto" });
        config.cartOpen = false;
      },
    });

    document.addEventListener("ajaxProduct:added", function (evt) {
      var headerCartInstance = new theme.HeaderCart();
      headerCartInstance.cartForm.buildCart();

      // setTimeout(function() {
      //   if (!config.cartOpen) {
      //  headerCartInstance.open();
      //   }
      // }.bind(headerCartInstance), 500);

      if (!config.cartOpen) {
        headerCartInstance.open();
      }

      // Resets cart property so that the form submit button can work
      if (headerCartInstance.cartForm.cartItemsUpdated) {
        headerCartInstance.cartForm.cartItemsUpdated = false;
      }
    });

    return HeaderCart;
  })();

  const focusTrapDiv = document.querySelector(".customer-cart");

  if (focusTrapDiv) {
    focusTrapDiv.addEventListener("keydown", function (event) {
      console.log("cart");
      if (event.key === "Tab" && !event.shiftKey) {
        const focusableElements = focusTrapDiv.querySelectorAll(
          'button:not(:disabled), h1, h2, h3, h4, h5, h6, [href], a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        console.log("focusableElements 123", focusableElements);
        var firstFocusableElement = focusableElements[0];
        console.log(firstFocusableElement, "firstFocusableElement");
        var lastFocusableElement =
          focusableElements[focusableElements.length - 1];
        lastelementCustomersection = lastFocusableElement;

        if (document.activeElement === lastFocusableElement) {
          event.preventDefault();
          setTimeout(function () {
            $(".customer-loved-heading h3").focus();
          }, 0);
        }
      }
      if (event.shiftKey && event.keyCode == 9) {
        if (document.activeElement === firstFocusableElement) {
          event.preventDefault();

          setTimeout(function () {
            $($(".js-close-header-cart")[0]).focus();
          }, 0);
        }
      }
    });
  }
  const focusCustomerLovedSection = document.querySelector(".customer-loved");
  if (focusCustomerLovedSection) {
    focusCustomerLovedSection.addEventListener("keydown", function (event) {
      if (event.key === "Tab") {
        const focusableElements = focusCustomerLovedSection.querySelectorAll(
          'button, h1, h2, h3, h4, h5, h6, [href], a, [tabindex]:not([tabindex="-1"])'
        );

        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement =
          focusableElements[focusableElements.length - 1];
        // lastelementCustomersection = focusableElements[focusableElements.length - 1];
        if (event.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            setTimeout(function () {
              lastelementCustomersection.focus();
            }, 0);
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            setTimeout(function () {
              $("#close-cart-btn").focus();
            }, 0);
          }
        }
      }
    });
  }
  const focusQuickModal = document.querySelector(".quick-shop-modal-focus");
  if (focusQuickModal) {
    focusQuickModal.addEventListener("keydown", function (event) {
      if (event.key === "Tab") {
        const focusableElements = focusQuickModal.querySelectorAll(
          'button, h1, h2, h3, h4, h5, h6, [href], a, [tabindex]:not([tabindex="-1"])'
        );

        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement =
          focusableElements[focusableElements.length - 1];

        if (event.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            setTimeout(function () {
              lastFocusableElement.focus();
            }, 0);
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            console.log("lastFocusableElement", lastFocusableElement);
            setTimeout(function () {
              firstFocusableElement.focus();
            }, 0);
          }
        }
      }
      // else{
      //   if (document.activeElement === lastFocusableElement) {
      //     event.preventDefault();
      //     $("#title-price-minicart").focus();
      // }
      // }
    });
  }

  $("#close-cart-btn").on("keydown", function () {
    setTimeout(() => {
      $("#title-price-minicart").focus();
    }, 0);
  });

  /*============================================================================
   Handle Menu subitem Accessibility
  ==============================================================================*/
  $(".eligibal-text").on("focus", function () {
    setTimeout(() => {
      $("#buttonid").focus();
    }, 3000);
  });

  /*============================================================================
   Handle Collections Links
  ==============================================================================*/

  $(".section-header--with-link a").keydown(function (event) {
    if (event.keyCode == 32 && $(".section-header--with-link a:focus")) {
      window.location = $(".section-header--with-link a:focus").attr("href");
      event.preventDefault();
    }
  });

  $(".grid-item__link").keydown(function (event) {
    if (event.keyCode == 32 && $(".grid-item__link:focus")) {
      window.location = $(".grid-item__link:focus").attr("href");
      // event.preventDefault();
    }
  });

  $(".user-auth-icon a").keydown(function (event) {
    if (event.keyCode == 32 && $(".user-auth-icon a:focus")) {
      window.location = $(".user-auth-icon a:focus").attr("href");
      event.preventDefault();
    }
  });

  $(".section-header__title a").keydown(function (event) {
    if (event.keyCode == 32 && $(".section-header__title a:focus")) {
      window.location = $(".section-header__title a:focus").attr("href");
      event.preventDefault();
      return false;
    }
  });

  $(".grid-product__actions button").on("focus", function (event) {
    // $(event.currentTarget).parent().css("opacity", 1);
  });

  $(".grid-product__actions button").on("blur", function (event) {
    $(event.currentTarget).parent().css("opacity", 0);
  });
  $(".grid-item__content").on("mouseover", function (event) {
    $($(event.currentTarget).find(".grid-product__actions")[0]).css(
      "opacity",
      1
    );
  });
  $(".grid-item__content").on("mouseout", function (event) {
    $($(event.currentTarget).find(".grid-product__actions")[0]).css(
      "opacity",
      0
    );
  });
  let zoom = ((window.outerWidth - 10) / window.innerWidth) * 100;
  // $(".main-menu-item .new-menu-item a").on("focus", function (event) {
  //   if (!isMobile() && zoom < 175.0) {
  //     $(event.currentTarget)
  //       .parent()
  //       .next()
  //       .css({ opacity: 1, visibility: "visible" });
  //   }
  // });

  $(".main-menu-item").on("mouseover", function (event) {
    if (!isMobile() && zoom < 175.0) {
      $($(event.currentTarget).find(".listing-hovered-items")[0]).css({
        opacity: 1,
        visibility: "visible",
      });
    }
  });

  $(".main-menu-item").on("mouseout", function (event) {
    if (!isMobile() && zoom < 175.0) {
      $($(event.currentTarget).find(".listing-hovered-items")[0]).css({
        opacity: 0,
        visibility: "hidden",
      });
    }
  });

  $(".main-menu-item .listing-hovered-items ul li:last-child a").on(
    "keydown",
    function (event) {
      console.log($(event.currentTarget).parents(".listing-hovered-items"));
      if (!isMobile() && zoom < 175.0) {
        if (
          (event.keyCode == 9 && !event.shiftKey) ||
          event.key == "ArrowRight" ||
          event.key == "ArrowDown"
        ) {
          $(event.currentTarget)
            .parents(".listing-hovered-items")
            .css({ opacity: 0, visibility: "hidden" });
        }
      }
    }
  );
  console.log("zoom", zoom);
  $(".main-menu-item .new-menu-item a").on("keydown", function (event) {
    if (
      (event.keyCode == 9 && event.shiftKey) ||
      event.key == "ArrowLeft" ||
      event.key == "ArrowUp"
    ) {
      if (!isMobile() && zoom < 175.0) {
        $(event.currentTarget)
          .parent()
          .next()
          .css({ opacity: 0, visibility: "hidden" });
        setTimeout(() => {
          $(
            ".main-menu-item .listing-hovered-items ul li:last-child a"
          ).focus();
        }, 1000);
      }
    }
  });

  /*============================================================================
   Handle  Desktop Navigation Accessibility
  ==============================================================================*/
  $(".site-nav__item a").on("keydown", function (event) {
    if (event.keyCode == 32 && $(".site-nav__item a:focus")) {
      setTimeout(() => {
        window.location = $(".site-nav__item a:focus").attr("href");
        return false;
      }, 0);
      event.preventDefault();
    }
  });
  $(".site-header__logo-link").on("keydown", function (event) {
    if (event.keyCode == 32 && $(".site-header__logo-link:focus")) {
      window.location = $(".site-header__logo-link:focus").attr("href");
      //return false;
      event.preventDefault();
    }
  });

  /*============================================================================
    QuickAdd
    - Setup quick add buttons/forms on a product grid item
  ==============================================================================*/
  theme.QuickAdd = (function () {
    var selectors = {
      quickAddBtn: ".js-quick-add-btn",
      quickAddForm: ".js-quick-add-form",
      quickAddHolder: "#QuickAddHolder",
    };

    var modalInitailized = false;
    var modal;

    function QuickAdd(container) {
      if (!container) {
        return;
      }

      if (!theme.settings.quickAdd) {
        return;
      }

      this.container = container;
      this.init();
    }

    QuickAdd.prototype = Object.assign({}, QuickAdd.prototype, {
      init: function () {
        // When a single variant, auto add it to cart
        try {
          var quickAddBtns = this.container.querySelectorAll(
            selectors.quickAddBtn
          );
          if (quickAddBtns) {
            /* comment this section by kinza because when i select product from coustomer also loved section products where adding two time */
            // quickAddBtns.forEach((btn) => {
            //   btn.addEventListener("click", this.addToCart.bind(this));
            // });
          }
        } catch {
          var quickAddBtns = document.querySelectorAll(
            ".rebuy-product .js-quick-add-btn"
          );
          console.log("quick add buttons ", quickAddBtns);
          if (quickAddBtns) {
            quickAddBtns.forEach((btn) => {
              btn.addEventListener("click", this.addToCart.bind(this));
            });
            return;
          }
        }

        // Button loads form when 1+ variants
        var quickAddForms = this.container.querySelectorAll(
          selectors.quickAddForm
        );

        if (quickAddForms.length) {
          this.quickAddHolder = document.querySelector(
            selectors.quickAddHolder
          );
          if (!modalInitailized) {
            modal = new theme.Modals("QuickAddModal", "quick-add");
            modalInitailized = true;

            // Empty cart form when closed
            document.addEventListener(
              "modalClose.QuickAddModal",
              function () {
                setTimeout(
                  function () {
                    this.quickAddHolder.innerHTML = "";
                  }.bind(this),
                  350
                );
              }.bind(this)
            );
          }

          quickAddForms.forEach((btn) => {
            btn.addEventListener("click", this.loadQuickAddForm.bind(this));
          });
        }
      },

      addToCart: function (evt) {
        evt.preventDefault();
        var btn = evt.currentTarget;
        $(".quick-add-btn").addClass("cart-btn-disabled");
        var visibleBtn = btn.querySelector(".btn");
        // visibleBtn.classList.add('btn--loading');
        var id = btn.dataset.id;
        let variantId = $(btn).attr("data-variant-id");
        var data = {
          items: [
            {
              id: id,
              quantity: 1,
            },
          ],
        };

        fetch(theme.routes.cartAdd, {
          method: "POST",
          body: JSON.stringify(data),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then(
            function (data) {
              if (data.status === 422 || data.status === "bad_request") {
              } else {
                setTimeout(function () {
                  $(".quick-add-btn").removeClass("cart-btn-disabled");
                }, 1200);

                HideCALSection();
                var product = data;
                console.log("6666" + product);
                // Floating CTA
                $(".box-cart-main").addClass("hide-floating");
                // End Floating CTA
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: {
                      product: product,
                      addToCartBtn: btn,
                    },
                  })
                );
              }

              // visibleBtn.classList.remove('btn--loading');
            }.bind(this)
          );
      },

      loadQuickAddForm: function (evt) {
        this.quickAddHolder.innerHTML = "";

        var btn = evt.currentTarget;
        var gridItem = evt.currentTarget.closest(".grid-product");
        var handle = gridItem.getAttribute("data-product-handle");
        var prodId = gridItem.getAttribute("data-product-id");

        var url = theme.routes.home + "/products/" + handle + "?view=form";

        // remove double `/` in case shop might have /en or language in URL
        url = url.replace("//", "/");

        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(
            function (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, "text/html");
              var div = doc.querySelector(
                '.product-section[data-product-handle="' + handle + '"]'
              );

              this.quickAddHolder.append(div);

              // Register product template inside modal
              theme.sections.register(
                "product",
                theme.Product,
                this.quickAddHolder
              );

              if (Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }

              window.dispatchEvent(
                new CustomEvent("quickadd:loaded:" + prodId)
              );

              document.dispatchEvent(
                new CustomEvent("quickadd:loaded", {
                  detail: {
                    productId: prodId,
                    handle: handle,
                  },
                })
              );

              modal.open();
            }.bind(this)
          );
      },
    });

    return QuickAdd;
  })();

  /*============================================================================
    QuickShop
    - Setup quick shop modals anywhere a product grid item exists
    - Duplicate product modals will be condensed down to one workable one
  ==============================================================================*/
  theme.QuickShop = (function () {
    var loadedIds = [];
    var selectors = {
      product: ".grid-product",
      triggers: ".quick-product__btn",
      modalContainer: "#ProductModals",
    };

    function QuickShop(container) {
      if (!theme.settings.quickView) {
        return;
      }

      this.container = container;
      this.init();
    }

    function getData(el) {
      return {
        id: el.dataset.productId,
        handle: el.dataset.productHandle,
      };
    }

    function productMouseover(evt) {
      var el = evt.currentTarget;
      if ($(".main-loved-pro:last-child .plus-icon-loved #cart-button:focus")) {
        console.log("Focused");
      }
      // No quick view on mobile breakpoint
      if (theme.config.bpSmall) {
        return;
      }

      // No product or onboarding content, bail
      if (!el || !el.dataset.productId) {
        return;
      }

      var data = getData(el);
      el.removeEventListener("mouseover", productMouseover);
      el.removeEventListener("focusin", productMouseover);

      preloadProductModal(data);
    }

    function preloadProductModal(data) {
      var modals = document.querySelectorAll(
        '.modal--quick-shop[data-product-id="' + data.id + '"]'
      );

      if (!modals.length) {
        return;
      }

      // If already loaded, no need to refetch info
      if (loadedIds.indexOf(data.id) > -1) {
        removeDuplicateModals(modals);
        enableTriggers(data);
      } else {
        // Move modal to storage element so animations work regardless
        // of where original markup is. Will also remove duplicates.
        moveModal(modals);

        var holder = document.getElementById("QuickShopHolder-" + data.handle);
        var url =
          theme.routes.home + "/products/" + data.handle + "?view=modal";

        // remove double `/` in case shop might have /en or language in URL
        url = url.replace("//", "/");

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const div = html.querySelector(
              '.product-section[data-product-handle="' + data.handle + '"]'
            );
            if (!holder) {
              return;
            }

            holder.append(div);

            // Register product template inside quick view
            theme.sections.register("product", theme.Product, holder);

            // Register collapsible elements
            theme.collapsibles.init();

            // Register potential video modal links (when video has sound)
            theme.videoModal();

            // There may be multiple triggers for the same modal, so enable them all
            enableTriggers(data);
          })
          .catch((e) => {
            console.error(e);
          });
      }

      // Add ID to global array so we don't double-load
      loadedIds.push(data.id);
    }

    function moveModal(modals) {
      var el = modals[0];
      if (!el) {
        return;
      }

      // If we have multiple modals, keep the first and remove all the rest
      if (modals.length > 1) {
        modals.forEach(function (m, i) {
          if (i > 0) {
            m.remove();
          }
        });
      }

      var container = document.querySelector(selectors.modalContainer);
      container.appendChild(el);
    }

    // Remove any modal not already in #ProductModals
    function removeDuplicateModals(modals) {
      if (modals.length > 1) {
        modals.forEach(function (m, i) {
          if (!m.closest("#ProductModals")) {
            m.remove();
          }
        });
      }
    }

    function enableTriggers(data) {
      // Setup quick view modal
      var modalId = "QuickShopModal-" + data.id;
      var name = "quick-modal-" + data.id;
      new theme.Modals(modalId, name);

      var triggers = document.querySelectorAll(
        selectors.triggers + '[data-handle="' + data.handle + '"]'
      );
      if (!triggers.length) {
        return;
      }

      triggers.forEach((trigger) => {
        trigger.classList.remove("quick-product__btn--not-ready");
      });
    }

    QuickShop.prototype = Object.assign({}, QuickShop.prototype, {
      init: function () {
        try {
          var products = this.container.querySelectorAll(selectors.product);
          if (!products.length) {
            return;
          }
          products.forEach((product) => {
            product.addEventListener("mouseover", productMouseover);
            product.addEventListener("focusin", productMouseover);
          });
        } catch {
          var products = document.querySelectorAll(
            ".rebuy-product .grid-product"
          );
          products.forEach((product) => {
            product.addEventListener("mouseover", productMouseover);
            product.addEventListener("focusin", productMouseover);
          });
          return QuickShop;
        }
      },
    });

    return QuickShop;
  })();

  theme.buildProductGridItem = function (items, imageSize) {
    var output = "";

    let filteredArr = items.filter(
      (res) =>
        res.type != "Subscription Box" &&
        res.type != "Gift Box" &&
        res.type != "Corporate Box"
    );
    // console.log('filteredArr',filteredArr)
    if (filteredArr.length) {
      filteredArr.map((product) => {
        var image = theme.buildProductImage(product, imageSize);
        $(".text-center.predictive-results__footer").show();
        var markup = `
          <div class="grid-item grid-product">
            <div class="grid-item__content">
              <a href="${product.url}" class="grid-item__link">
                <div class="grid-product__image-wrap">
                  ${image}
                </div>
                <div class="grid-item__meta">
                  <div class="grid-product__title">${product.title}</div>
                </div>
              </a>
            </div>
          </div>
        `;

        output += markup;
      });
    } else {
      $(".text-center.predictive-results__footer").hide();
    }

    return output;
  };

  theme.buildProductImage = function (product, imageSize) {
    var size = imageSize ? imageSize : theme.settings.productImageSize;
    var output = "";

    if (size === "natural") {
      output = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${product.image_aspect_ratio}%;">
          <img class="grid-product__image lazyload"
            data-src="${product.image_responsive_url}"
            data-widths="[180, 360, 540, 720, 900]"
            data-aspectratio="${product.image_aspect_ratio}"
            data-sizes="auto"
            alt="${product.title}">
        </div>`;
    } else {
      var classes = "lazyload";
      if (!theme.settings.productImageCover) {
        classes += " grid__image-contain";
      }
      output = `
        <div class="grid__image-ratio grid__image-ratio--${size}">
          <img class="${classes}"
              data-src="${product.image_responsive_url}"
              data-widths="[360, 540, 720, 900, 1080]"
              data-aspectratio="${product.aspect_ratio}"
              data-sizes="auto"
              alt="${product.title}">
        </div>
      `;
    }

    return output;
  };

  theme.buildCollectionItem = function (items) {
    var output = "";

    items.forEach((collection) => {
      var markup = `
        <li>
          <a href="${collection.url}">
            ${collection.title}
          </a>
        </li>
      `;

      output += markup;
    });

    return output;
  };

  theme.buildPageItem = function (items) {
    var output = "";

    items.forEach((page) => {
      var markup = `
        <li>
          <a href="${page.url}">
            ${page.title}
          </a>
        </li>
      `;

      output += markup;
    });

    return output;
  };

  theme.buildArticleItem = function (items, imageSize) {
    var output = "";

    items.forEach((article) => {
      var image = theme.buildPredictiveImage(article);
      var markup = `
        <div class="grid__item small--one-half medium-up--one-quarter">
          <a href="${article.url}" class="grid-item__link grid-item__link--inline">
            <div class="grid-product__image-wrap">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${imageSize}">
                <div class="predictive__image-wrap">
                  ${image}
                </div>
              </div>
            </div>
            <div class="grid-item__meta">
              ${article.title}
            </div>
          </a>
        </div>
      `;

      output += markup;
    });

    return output;
  };

  theme.buildPredictiveImage = function (obj) {
    var imageMarkup = "";
    if (obj.image) {
      imageMarkup = `<img class="lazyload"
            data-src="${obj.image}"
            data-widths="[360, 540, 720]"
            data-sizes="auto">`;
    }
    return imageMarkup;
  };

  // Observer that adds visible class to animated elements
  theme.animationObserver = function () {
    var els = document.querySelectorAll(".animation-contents");

    els.forEach((el) => {
      var observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 1 }
      );

      observer.observe(el);
    });
  };

  theme.Photoswipe = (function () {
    var selectors = {
      trigger: ".js-photoswipe__zoom",
      images: ".photoswipe__image",
      slideshowTrack: ".flickity-viewport ",
      activeImage: ".is-selected",
    };

    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = ".photoswipe-" + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;

      if (!container || container.dataset.zoom === "false") {
        return;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function () {
        this.container
          .querySelectorAll(selectors.trigger)
          .forEach((trigger) => {
            trigger.on("click" + this.namespace, this.triggerClick.bind(this));
          });
      },

      triggerClick: function (evt) {
        // Streamline changes between a slideshow and
        // stacked images, so recheck if we are still
        // working with a slideshow when initializing zoom
        if (
          this.container.dataset &&
          this.container.dataset.hasSlideshow === "true"
        ) {
          this.inSlideshow = true;
        } else {
          this.inSlideshow = false;
        }

        this.items = this.getImageData();

        var image = this.inSlideshow
          ? this.container.querySelector(selectors.activeImage)
          : evt.currentTarget;

        var index = this.inSlideshow
          ? this.getChildIndex(image)
          : image.dataset.index;

        this.initGallery(this.items, index);
      },

      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function (el) {
        var i = 0;
        while ((el = el.previousSibling) != null) {
          i++;
        }

        // 1-based index required
        return i + 1;
      },

      getImageData: function () {
        this.images = this.inSlideshow
          ? this.container.querySelectorAll(
              selectors.slideshowTrack + selectors.images
            )
          : this.container.querySelectorAll(selectors.images);

        var items = [];
        var options = {};

        this.images.forEach((el) => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute("data-photoswipe-src"),
            w: el.getAttribute("data-photoswipe-width"),
            h: el.getAttribute("data-photoswipe-height"),
            el: el,
            initialZoomLevel: 0.5,
          };

          items.push(item);
        });

        return items;
      },

      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll(".pswp")[0];

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: "zoom",
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function (index) {
            var pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
        };

        this.gallery = new PhotoSwipe(
          pswpElement,
          PhotoSwipeUI_Default,
          items,
          options
        );
        this.gallery.listen("afterChange", this.afterChange.bind(this));
        this.gallery.init();

        this.preventiOS15Scrolling();
      },

      afterChange: function () {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(
          new CustomEvent("photoswipe:afterChange", {
            detail: {
              index: index,
            },
          })
        );
      },

      syncHeight: function () {
        document.documentElement.style.setProperty(
          "--window-inner-height",
          `${window.innerHeight}px`
        );
      },

      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function () {
        let initialScrollPos;

        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

        this.syncHeight();

        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;

        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add("pswp-open-in-ios");

        window.addEventListener("resize", this.syncHeight);

        this.gallery.listen("destroy", () => {
          document.documentElement.classList.remove("pswp-open-in-ios");
          window.scrollTo(0, initialScrollPos);
        });
      },
    });

    return Photoswipe;
  })();

  theme.StoreAvailability = (function () {
    var selectors = {
      drawerOpenBtn: ".js-drawer-open-availability",
      modalOpenBtn: ".js-modal-open-availability",
      productTitle: "[data-availability-product-title]",
    };

    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }

    StoreAvailability.prototype = Object.assign(
      {},
      StoreAvailability.prototype,
      {
        updateContent: function (variantId) {
          var variantSectionUrl =
            this.baseUrl +
            "/variants/" +
            variantId +
            "/?section_id=store-availability";

          var self = this;

          fetch(variantSectionUrl)
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              if (html.trim() === "") {
                this.container.innerHTML = "";
                return;
              }

              self.container.innerHTML = html;
              self.container.innerHTML =
                self.container.firstElementChild.innerHTML;

              // Setup drawer if have open button
              if (self.container.querySelector(selectors.drawerOpenBtn)) {
                self.drawer = new theme.Drawers(
                  "StoreAvailabilityDrawer",
                  "availability"
                );
              }

              // Setup modal if have open button
              if (self.container.querySelector(selectors.modalOpenBtn)) {
                self.modal = new theme.Modals(
                  "StoreAvailabilityModal",
                  "availability"
                );
              }

              var title = self.container.querySelector(selectors.productTitle);
              if (title) {
                title.textContent = self.productTitle;
              }
            });
        },
      }
    );

    return StoreAvailability;
  })();
  /*============================================================================
    HotSpots
  ==============================================================================*/

  class HotSpots extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.buttons = this.querySelectorAll("[data-button]");
      this.hotspotBlocks = this.querySelectorAll("[data-hotspot-block]");
      this.blockContainer = this.querySelector("[data-block-container]");
      this.colorImages = this.querySelectorAll(".grid-product__color-image");
      this.colorSwatches = this.querySelectorAll(".color-swatch--with-image");

      this._bindEvents();
      this._setupQuickShop();

      if (this.colorImages.length) {
        this._colorSwatchHovering();
      }
    }

    _colorSwatchHovering() {
      this.colorSwatches.forEach((swatch) => {
        swatch.addEventListener(
          "mouseenter",
          function () {
            this._setActiveColorImage(swatch);
          }.bind(this)
        );

        swatch.addEventListener(
          "touchstart",
          function (evt) {
            evt.preventDefault();
            this._setActiveColorImage(swatch);
          }.bind(this),
          { passive: true }
        );

        swatch.addEventListener(
          "mouseleave",
          function () {
            this._removeActiveColorImage(swatch);
          }.bind(this)
        );
      });
    }

    _setActiveColorImage(swatch) {
      var id = swatch.dataset.variantId;
      var image = swatch.dataset.variantImage;

      // Unset all active swatch images
      this.colorImages.forEach((el) => {
        el.classList.remove("is-active");
      });

      // Unset all active swatches
      this.colorSwatches.forEach((el) => {
        el.classList.remove("is-active");
      });

      // Set active image and swatch
      var imageEl = this.el.querySelector(".grid-product__color-image--" + id);
      imageEl.style.backgroundImage = "url(" + image + ")";
      imageEl.classList.add("is-active");
      swatch.classList.add("is-active");

      // Update product grid item href with variant URL
      var variantUrl = swatch.dataset.url;
      var gridItem = swatch.closest(".grid-item__link");

      if (gridItem) gridItem.setAttribute("href", variantUrl);
    }

    _removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.querySelector(`.grid-product__color-image--${id}`).classList.remove(
        "is-active"
      );
    }

    /* Setup event listeners */
    _bindEvents() {
      this.buttons.forEach((button) => {
        const id = button.dataset.button;

        button.on("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this._showContent(id);
        });
      });

      // Display active hotspot block on theme editor select
      document.addEventListener("shopify:block:select", (e) => {
        const blockId = e.detail.blockId;
        this._showContent(`${blockId}`);
      });
    }

    /* Toggle sidebar content */
    _showContent(id) {
      // Hide all hotspotBlock
      // Show the hotspotBlock with the id
      this.hotspotBlocks.forEach((block) => {
        if (block.dataset.hotspotBlock === id) {
          block.classList.add("is-active");
        } else {
          block.classList.remove("is-active");
        }
      });
    }

    _setupQuickShop() {
      if (this.querySelectorAll('[data-block-type="product"]').length > 0) {
        // Ensure we are utilizing the right version of QuickShop based off of theme
        if (typeof theme.QuickShop === "function") {
          new theme.QuickShop(this.blockContainer);
        } else if (typeof theme.initQuickShop === "function") {
          theme.initQuickShop();
        }

        if (typeof theme.QuickAdd === "function") {
          new theme.QuickAdd(this.blockContainer);
        }
      }
    }
  }

  customElements.define("hot-spots", HotSpots);

  theme.FooterSection = (function () {
    var selectors = {
      locale: "[data-disclosure-locale]",
      currency: "[data-disclosure-currency]",
    };

    var ids = {
      mobileNav: "MobileNav",
      footerNavWrap: "FooterMobileNavWrap",
      footerNav: "FooterMobileNav",
    };

    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 1000,
      });
    }

    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }

        // If on mobile, copy the mobile nav to the footer
        if (theme.config.bpSmall) {
          this.initDoubleMobileNav();
        }

        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },

      initDoubleMobileNav: function () {
        var menuPlaceholder = document.getElementById(ids.footerNavWrap);
        if (!menuPlaceholder) {
          return;
        }

        var mobileNav = document.getElementById(ids.mobileNav);
        var footerNav = document.getElementById(ids.footerNav);
        var clone = mobileNav.cloneNode(true);
        var navEl = clone.querySelector(".slide-nav__wrapper");

        // Append cloned nav to footer, initialize JS, then show it
        footerNav.appendChild(navEl);
        new theme.MobileNav({
          id: ids.footerNav,
          inHeader: false,
        });

        menuPlaceholder.classList.remove("hide");
      },

      onUnload: function () {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },
    });

    return FooterSection;
  })();

  theme.HeaderSection = (function () {
    var selectors = {
      headerFooter: "#MobileNavFooter",
      footerMenus: "#FooterMenus",
    };

    var namespace = ".header";

    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute("data-section-id");

      this.init();
    }

    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function () {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit("slideshow-section");

          // Set a timer to resize the header in case the logo changes size
          setTimeout(function () {
            window.dispatchEvent(new Event("resize"));
          }, 500);
        }

        theme.headerNav.init();
        theme.announcementBar.init();
        theme.headerSearch.init();
        this.hoverMenu();

        // Enable header cart drawer when not on cart page
        if (!document.body.classList.contains("template-cart")) {
          new theme.HeaderCart();
        }
        new theme.MobileNav({
          id: "MobileNav",
          inHeader: true,
        });

        if (theme.config.bpSmall) {
          this.cloneFooter();
        }

        window.on(
          "resize" + namespace,
          theme.utils.debounce(300, theme.sizeDrawer)
        );
      },

      hoverMenu: function () {
        const detailsEl = document.querySelectorAll(
          '[data-section-type="header"] details[data-hover="true"]'
        );

        detailsEl.forEach((detail) => {
          const summary = detail.querySelector("summary");
          const summaryLink = summary.dataset.link;

          summary.addEventListener("click", (e) => {
            e.preventDefault();
            window.location.href = summaryLink;
          });

          detail.addEventListener("mouseover", () => {
            if (!detail.hasAttribute("open")) {
              detail.setAttribute("open", "");
              detail.setAttribute("aria-expanded", "true");
            }
          });

          detail.addEventListener("mouseleave", () => {
            if (detail.hasAttribute("open")) {
              detail.removeAttribute("open");
              detail.setAttribute("aria-expanded", "false");
            }
          });
        });
      },

      cloneFooter: function () {
        var headerFooter = document.querySelector(selectors.headerFooter);
        if (!headerFooter) {
          return;
        }

        var footerMenus = document.querySelector(selectors.footerMenus);

        var clone = footerMenus.cloneNode(true);
        clone.id = "";

        // Append cloned footer menus to mobile nav
        headerFooter.appendChild(clone);

        // If localization form, update IDs so they don't match footer
        var localizationForm = headerFooter.querySelector(".multi-selectors");
        if (localizationForm) {
          // Loop disclosure buttons and update ids and aria attributes
          localizationForm
            .querySelectorAll("[data-disclosure-toggle]")
            .forEach((el) => {
              var controls = el.getAttribute("aria-controls");
              var describedby = el.getAttribute("aria-describedby");

              el.setAttribute("aria-controls", controls + "-header");
              el.setAttribute("aria-describedby", describedby + "-header");

              var list = document.getElementById(controls);
              if (list) {
                list.id = controls + "-header";
              }

              var label = document.getElementById(describedby);
              if (label) {
                label.id = describedby + "-header";
              }

              // Initialize language/currency selectors
              var parent = el.parentNode;
              if (parent) {
                new theme.Disclosure(parent);
              }
            });
        }
      },

      onUnload: function () {},
    });

    return HeaderSection;
  })();

  theme.Product = (function () {
    var videoObjects = {};

    var classes = {
      onSale: "on-sale",
      disabled: "disabled",
      isModal: "is-modal",
      loading: "loading",
      loaded: "loaded",
      hidden: "hide",
      interactable: "video-interactable",
      visuallyHide: "visually-invisible",
    };

    var selectors = {
      productVideo: ".product__video",
      videoParent: ".product__video-wrapper",
      slide: ".product-main-slide",
      currentSlide: ".is-selected",
      startingSlide: ".starting-slide",
      variantType: ".variant-wrapper",
      blocks: "[data-product-blocks]",
      blocksHolder: "[data-blocks-holder]",
      dynamicVariantsEnabled: "[data-dynamic-variants-enabled]",
    };

    function Product(container) {
      this.container = container;
      var sectionId = (this.sectionId =
        container.getAttribute("data-section-id"));
      var productId = (this.productId =
        container.getAttribute("data-product-id"));

      this.inModal = container.dataset.modal === "true";
      this.modal;

      this.settings = {
        enableHistoryState: container.dataset.history === "true" || false,
        namespace: ".product-" + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: "620x",
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping,
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = ".product-" + sectionId + "-modal";
        this.modal = document.getElementById("QuickShopModal-" + productId);
      }

      this.selectors = {
        variantsJson: "[data-variant-json]",
        currentVariantJson: "[data-current-variant-json]",
        form: ".product-single__form",

        media: "[data-product-media-type-model]",
        closeMedia: ".product-single__close-media",
        photoThumbs: "[data-product-thumb]",
        thumbSlider: "[data-product-thumbs]",
        thumbScroller: ".product__thumbs--scroller",
        mainSlider: "[data-product-photos]",
        imageContainer: "[data-product-images]",
        productImageMain: "[data-product-image-main]",

        priceWrapper: "[data-product-price-wrap]",
        price: "[data-product-price]",
        comparePrice: "[data-compare-price]",
        savePrice: "[data-save-price]",
        priceA11y: "[data-a11y-price]",
        comparePriceA11y: "[data-compare-price-a11y]",
        unitWrapper: "[data-unit-price-wrapper]",
        unitPrice: "[data-unit-price]",
        unitPriceBaseUnit: "[data-unit-base]",
        sku: "[data-sku]",
        inventory: "[data-product-inventory]",
        incomingInventory: "[data-incoming-inventory]",
        colorLabel: "[data-variant-color-label]",

        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",

        originalSelectorId: "[data-product-select]",
        singleOptionSelector: "[data-variant-input]",
        variantColorSwatch: ".variant__input--color-swatch",

        availabilityContainer: "[data-store-availability-holder]",
      };

      this.cacheElements();
      try {
        this.firstProductImage = this.cache.mainSlider.querySelector("img");
      } catch (error) {}

      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }

      try {
        var dataSetEl = this.cache.mainSlider.querySelector("[data-set-name]");
      } catch (error) {}
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }

      this.init();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      init: function () {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener(
            "modalOpen.QuickShopModal-" + this.productId,
            this.openModalProduct.bind(this)
          );
          document.addEventListener(
            "modalClose.QuickShopModal-" + this.productId,
            this.closeModalProduct.bind(this)
          );
        }

        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
        }

        // Quick add hook
        window.off("quickadd:loaded:" + this.sectionId);
        window.on(
          "quickadd:loaded:" + this.sectionId,
          this.initQuickAddForm.bind(this)
        );
      },

      cacheElements: function () {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(
            this.selectors.thumbScroller
          ),
          productImageMain: this.container.querySelector(
            this.selectors.productImageMain
          ),

          // Price-related
          priceWrapper: this.container.querySelector(
            this.selectors.priceWrapper
          ),
          comparePriceA11y: this.container.querySelector(
            this.selectors.comparePriceA11y
          ),
          comparePrice: this.container.querySelector(
            this.selectors.comparePrice
          ),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y),
        };
      },

      formSetup: function () {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();

        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },

      availabilitySetup: function () {
        var container = this.container.querySelector(
          this.selectors.availabilityContainer
        );
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },

      productSetup: function () {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();

        if (window.SPR) {
          SPR.initDomEls();
          SPR.loadBadges();
        }
      },

      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },

      addIdToRecentlyViewed: async function () {
        var id = this.container.getAttribute("data-product-id");
        let checkZipcode = localStorage.getItem("zipcode");
        if (theme.settings.localization && checkZipcode) {
          let productInventory = await vendorInventories(id);
          let checkInventory =
            productInventory.length > 0 && productInventory[0];

          if (checkInventory.isAvailable) {
            if (!id) {
              return;
            }

            // Remove current product if already in recently viewed array
            var i = theme.recentlyViewedIds.indexOf(id);

            if (i > -1) {
              theme.recentlyViewedIds.splice(i, 1);
            }

            // Add id to array
            theme.recentlyViewedIds.unshift(id);
            if (theme.config.hasLocalStorage) {
              window.localStorage.setItem(
                "recently-viewed",
                JSON.stringify(theme.recentlyViewedIds)
              );
            }
          }
        } else {
          if (!id) {
            return;
          }

          // Remove current product if already in recently viewed array
          var i = theme.recentlyViewedIds.indexOf(id);

          if (i > -1) {
            theme.recentlyViewedIds.splice(i, 1);
          }

          // Add id to array
          theme.recentlyViewedIds.unshift(id);
          if (theme.config.hasLocalStorage) {
            window.localStorage.setItem(
              "recently-viewed",
              JSON.stringify(theme.recentlyViewedIds)
            );
          }
        }
      },

      initVariants: function () {
        var variantJson = this.container.querySelector(
          this.selectors.variantsJson
        );

        if (!variantJson) {
          return;
        }

        this.variantsObject = JSON.parse(variantJson.innerHTML);
        var dynamicVariantsEnabled = !!this.container.querySelector(
          selectors.dynamicVariantsEnabled
        );
        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
          dynamicVariantsEnabled,
        };

        var swatches = this.container.querySelectorAll(
          this.selectors.variantColorSwatch
        );
        if (swatches.length) {
          swatches.forEach((swatch) => {
            swatch.addEventListener(
              "change",
              function (evt) {
                var color = swatch.dataset.colorName;
                var index = swatch.dataset.colorIndex;
                this.updateColorName(color, index);
              }.bind(this)
            );
          });
        }

        this.variants = new theme.Variants(options);

        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant
            ? this.variants.currentVariant.id
            : this.variants.variants[0].id;

          this.storeAvailability.updateContent(variant_id);
          this.container.on(
            "variantChange" + this.settings.namespace,
            this.updateAvailability.bind(this)
          );
        }

        this.container.on(
          "variantChange" + this.settings.namespace,
          this.updateCartButton.bind(this)
        );
        this.container.on(
          "variantImageChange" + this.settings.namespace,
          this.updateVariantImage.bind(this)
        );
        this.container.on(
          "variantPriceChange" + this.settings.namespace,
          this.updatePrice.bind(this)
        );
        this.container.on(
          "variantUnitPriceChange" + this.settings.namespace,
          this.updateUnitPrice.bind(this)
        );

        if (this.container.querySelectorAll(this.selectors.sku).length) {
          this.container.on(
            "variantSKUChange" + this.settings.namespace,
            this.updateSku.bind(this)
          );
        }

        var inventoryEl = this.container.querySelector(
          this.selectors.inventory
        );
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
          this.container.on(
            "variantChange" + this.settings.namespace,
            this.updateInventory.bind(this)
          );
        }

        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable) {
          var currentVariantJson = this.container.querySelector(
            this.selectors.currentVariantJson
          );

          if (currentVariantJson) {
            var variantType = this.container.querySelector(
              selectors.variantType
            );

            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML),
              });
            }
          }
        }

        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector(
            '.variant-input-wrap[data-handle="' +
              this.settings.imageSetName +
              '"]'
          );
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on(
              "variantChange" + this.settings.namespace,
              this.updateImageSet.bind(this)
            );
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      initQtySelector: function () {
        this.container.querySelectorAll(".js-qty__wrapper").forEach((el) => {
          new theme.QtySelector(el, {
            namespace: ".product",
          });
        });
      },

      initAjaxProductForm: function () {
        if (theme.settings.cartType === "dropdown") {
          new theme.AjaxProduct(this.cache.form, ".add-to-cart");
        }
      },

      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function (color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(
          this.selectors.colorLabel + `[data-index="${index}"`
        ).textContent = color;
      },

      updateCartButton: function (evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(
          this.selectors.addToCartText
        );
        if (!cartBtn) return;
        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },

      updatePrice: function (evt) {
        var variant = evt.detail.variant;

        // Add to Cart Button Update - Floating CTA Button
        if (variant && variant.inventory_quantity === 0) {
          $(".product-floating-cta .add-to-cart").text("Sold Out");
          $(".product-floating-cta .add-to-cart").css({
            pointerEvents: "none",
            opacity: "0.3",
          });
          $(".product-floating-cta .add-to-cart").prop("disabled", true);
        } else {
          $(".product-floating-cta .add-to-cart").text("Add to Cart");
          $(".product-floating-cta .add-to-cart").css({
            pointerEvents: "inherit",
            opacity: "1",
          });
          $(".product-floating-cta .add-to-cart").prop("disabled", false);
          $(".product-floating-cta .add-to-cart").removeClass("disabled");
        }

        if (variant) {
          // If no price element, form initiated later than rest of
          // product page. Update cached elements
          if (!this.cache.price) {
            this.cacheElements();
          }

          // Regular price
          this.cache.price.innerHTML = theme.Currency.formatMoney(
            variant.price,
            theme.settings.moneyFormat
          );

          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.settings.moneyFormat
            );
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute("aria-hidden", "false");
            }
            if (this.cache.priceA11y) {
              this.cache.priceA11y.setAttribute("aria-hidden", "false");
            }

            var savings = variant.compare_at_price - variant.price;

            if (theme.settings.saveType == "percent") {
              savings =
                Math.round((savings * 100) / variant.compare_at_price) + "%";
            } else {
              savings = theme.Currency.formatMoney(
                savings,
                theme.settings.moneyFormat
              );
            }

            this.cache.savePrice.classList.remove(classes.hidden);
            this.cache.savePrice.innerHTML = theme.strings.savePrice.replace(
              "[saved_amount]",
              savings
            );
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            this.cache.savePrice.classList.add(classes.hidden);
            this.cache.price.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute("aria-hidden", "true");
            }
            if (this.cache.priceA11y) {
              this.cache.priceA11y.setAttribute("aria-hidden", "true");
            }
          }
          // Price Update - Floating CTA Button
          let price = $(".product-single__meta .product-block--price").html();
          $(".product-floating-cta .product-block--price").html("");
          $(".product-floating-cta .product-block--price").html(price);

          // Update Variant ID - Floating CTA Button
          $(".product-floating-cta .add-to-cart").attr(
            "data-variant-id",
            variant.id
          );
        }
      },

      updateUnitPrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML =
            theme.Currency.formatMoney(
              variant.unit_price,
              theme.settings.moneyFormat
            );
          this.container.querySelector(
            this.selectors.unitPriceBaseUnit
          ).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.remove(classes.hidden);
        } else {
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.add(classes.hidden);
        }
      },

      imageSetArguments: function (variant) {
        var variant = variant
          ? variant
          : this.variants
          ? this.variants.currentVariant
          : null;
        if (!variant) return;

        var setValue = (this.settings.currentImageSet = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        ));
        var set = this.settings.imageSetName + "_" + setValue;

        // Always start on index 0
        this.settings.currentSlideIndex = 0;

        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="' + set + '"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex,
        };
      },

      updateImageSet: function (evt) {
        // If called directly, use current variant
        var variant = evt
          ? evt.detail.variant
          : this.variants
          ? this.variants.currentVariant
          : null;
        if (!variant) {
          return;
        }

        var setValue = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        );

        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }

        this.initProductSlider(variant);
      },

      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function (set) {
        this.cache.thumbSlider
          .querySelectorAll(".product__thumb-item")
          .forEach((thumb) => {
            thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
          });
      },

      getImageSetName: function (string) {
        return string
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, "");
      },

      updateSku: function (evt) {
        var variant = evt.detail.variant;
        var newSku = "";
        var hideSku = true;

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
            hideSku = false;
          }

          this.container.querySelectorAll(this.selectors.sku).forEach((el) => {
            el.classList.toggle(classes.hidden, hideSku);
            el.querySelector("[data-sku-id]").textContent = newSku;
          });
        }
      },

      updateInventory: function (evt) {
        var variant = evt.detail.variant;

        // Hide stock if no inventory management or policy is continue
        if (
          !variant ||
          !variant.inventory_management ||
          variant.inventory_policy === "continue"
        ) {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }

        if (
          variant.inventory_management === "shopify" &&
          window.inventories &&
          window.inventories[this.productId]
        ) {
          var variantInventoryObject =
            window.inventories[this.productId][variant.id];

          // Hide stock if policy is continue
          if (variantInventoryObject.policy === "continue") {
            this.toggleInventoryQuantity(variant, false);
            this.toggleIncomingInventory(false);
            return;
          }

          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;

          if (quantity <= 0 || quantity > this.settings.inventoryThreshold) {
            showInventory = false;
          }

          this.toggleInventoryQuantity(variant, variantInventoryObject);

          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (
            !showInventory &&
            variantInventoryObject.incoming === "true" &&
            quantity <= this.settings.inventoryThreshold
          ) {
            showIncomingInventory = true;
          }

          this.toggleIncomingInventory(
            showIncomingInventory,
            variant.available,
            variantInventoryObject.next_incoming_date
          );
        }
      },

      updateAvailability: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        this.storeAvailability.updateContent(variant.id);
      },

      toggleInventoryQuantity: function (variant, variantInventoryObject) {
        const { quantity, policy } = variantInventoryObject || {};
        if (!this.settings.inventory) {
          return;
        }

        var el = this.container.querySelector(this.selectors.inventory);
        var salesPoint = el.closest(".product-block");

        if (
          parseInt(quantity) <= parseInt(this.settings.inventoryThreshold) &&
          policy !== "continue"
        ) {
          el.parentNode.classList.add("inventory--low");
          if (quantity > 1) {
            el.textContent = theme.strings.otherStockLabel.replace(
              "[count]",
              quantity
            );
          } else {
            el.textContent = theme.strings.oneStockLabel.replace(
              "[count]",
              quantity
            );
          }
        } else {
          el.parentNode.classList.remove("inventory--low");
          el.textContent = theme.strings.inStockLabel;
        }

        if (variant && variant.available) {
          el.parentNode.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
        } else {
          el.parentNode.classList.add(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.add(classes.hidden);
          }
        }
      },

      toggleIncomingInventory: function (show, available, date) {
        var el = this.container.querySelector(this.selectors.incomingInventory);
        var salesPoint = el.closest(".product-block");

        if (!el) {
          return;
        }

        var textEl = el.querySelector(".js-incoming-text");

        if (show) {
          var string = available
            ? theme.strings.willNotShipUntil.replace("[date]", date)
            : theme.strings.willBeInStockAfter.replace("[date]", date);

          if (!date) {
            string = theme.strings.waitingForStock;
          }

          el.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
          textEl.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },

      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function () {
        var productVideos = this.cache.mainSlider.querySelectorAll(
          selectors.productVideo
        );

        if (!productVideos.length) {
          return false;
        }

        productVideos.forEach((vid) => {
          var type = vid.dataset.videoType;
          if (type === "youtube") {
            this.initYoutubeVideo(vid);
          } else if (type === "vimeo") {
            this.initVimeoVideo(vid);
          } else if (type === "mp4") {
            this.initMp4Video(vid);
          }
        });
      },

      initYoutubeVideo: function (div) {
        videoObjects[div.id] = new theme.YouTube(div.id, {
          videoId: div.dataset.youtubeId,
          videoParent: selectors.videoParent,
          autoplay: false, // will handle this in callback
          style: div.dataset.videoStyle,
          loop: div.dataset.videoLoop,
          events: {
            onReady: this.youtubePlayerReady.bind(this),
            onStateChange: this.youtubePlayerStateChange.bind(this),
          },
        });
      },

      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function (evt) {
        var iframeId = evt.target.getIframe().id;

        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }

        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;

        if (obj.options.style !== "sound") {
          player.mute();
        }

        obj.parent.classList.remove("loading");
        obj.parent.classList.add("loaded");
        obj.parent.classList.add("video-interactable"); // Previously, video was only interactable after slide change
        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== "sound") {
          player.playVideo();
        }
      },

      _isFirstSlide: function (id) {
        return this.cache.mainSlider.querySelector(
          selectors.startingSlide + " " + "#" + id
        );
      },

      youtubePlayerStateChange: function (evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];

        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add("video-interactable");
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === "true") {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },

      initMp4Video: function (div) {
        videoObjects[div.id] = {
          id: div.id,
          type: "mp4",
        };

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },

      stopVideos: function () {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === "function") {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === "mp4") {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },

      _getVideoType: function (video) {
        return video.getAttribute("data-video-type");
      },

      _getVideoDivId: function (video) {
        return video.id;
      },

      playMp4Video: function (id) {
        var player = this.container.querySelector("#" + id);
        var playPromise = player.play();

        player.setAttribute("controls", "");
        player.focus();

        // When existing focus on the element, go back to thumbnail
        player.addEventListener(
          "focusout",
          this.returnFocusToThumbnail.bind(this)
        );

        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              // Playing as expected
            })
            .catch(function (error) {
              // Likely low power mode on iOS, show controls
              player.setAttribute("controls", "");
              player
                .closest(selectors.videoParent)
                .setAttribute("data-video-style", "unmuted");
            });
        }
      },

      stopMp4Video: function (id) {
        var player = this.container.querySelector("#" + id);
        player.removeEventListener(
          "focusout",
          this.returnFocusToThumbnail.bind(this)
        );
        if (player && typeof player.pause === "function") {
          player.removeAttribute("controls");
          player.pause();
        }
      },

      returnFocusToThumbnail: function (evt) {
        // Only return focus to active thumbnail if relatedTarget
        // is a thumbnail, otherwise user may have clicked elsewhere on the page
        if (
          evt.relatedTarget &&
          evt.relatedTarget.classList.contains("product__thumb")
        ) {
          var thumb = this.container.querySelector(
            '.product__thumb-item[data-index="' +
              this.settings.currentSlideIndex +
              '"] a'
          );
          if (thumb) {
            thumb.focus();
          }
        }
      },

      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function () {
        var container = this.container.querySelector(
          this.selectors.imageContainer
        );
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener(
          "photoswipe:afterChange",
          function (evt) {
            if (this.flickity) {
              this.flickity.goToSlide(evt.detail.index);
            }
          }.bind(this)
        );
      },

      getThumbIndex: function (target) {
        return target.dataset.index;
      },

      updateVariantImage: function (evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(
          variant.featured_media.preview_image.src,
          this.settings.imageSize
        );

        var newImage = this.container.querySelector(
          '.product__thumb[data-id="' + variant.featured_media.id + '"]'
        );
        var imageIndex = this.getThumbIndex(newImage);

        // Image Update - Floating CTA Button
        $(".product-floating-cta-image").attr(
          "src",
          variant.featured_image.src
        );

        // If there is no index, slider is not initalized
        if (typeof imageIndex === "undefined") {
          return;
        }

        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },

      initProductSlider: function (variant) {
        // Stop if only a single image, but add active class to first slide
        if (
          this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1
        ) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add("is-selected");
          }
          return;
        }

        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }

        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(
            selectors.startingSlide
          );
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }

        var mainSliderArgs = {
          dragThreshold: 25,
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === "beside",
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this),
          },
        };

        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }

        this.flickity = new theme.Slideshow(
          this.cache.mainSlider,
          mainSliderArgs
        );

        // Ensure we resize the slider to avoid reflow issues
        setTimeout(() => {
          this.flickity.resize();
        }, 100);
      },

      onSliderInit: function (slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },

      onSlideChange: function (index) {
        if (!this.flickity) return;

        var prevSlide = this.cache.mainSlider.querySelector(
          '.product-main-slide[data-index="' +
            this.settings.currentSlideIndex +
            '"]'
        );

        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName
          ? this.cache.mainSlider.querySelectorAll(
              ".flickity-slider .product-main-slide"
            )[index]
          : this.cache.mainSlider.querySelector(
              '.product-main-slide[data-index="' + index + '"]'
            );

        prevSlide.setAttribute("tabindex", "-1");
        nextSlide.setAttribute("tabindex", 0);

        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);

        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);

        // Update current slider index
        this.settings.currentSlideIndex = index;
      },

      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === "youtube") {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === "mp4") {
            this.stopMp4Video(videoId);
            return;
          }
        }

        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent("mediaHidden", {
              bubbles: true,
              cancelable: true,
            })
          );
        }
      },

      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          this.flickity.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === "youtube") {
            if (
              videoObjects[videoId].videoPlayer &&
              videoObjects[videoId].options.style !== "sound"
            ) {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === "mp4") {
            this.playMp4Video(videoId);
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent("mediaVisible", {
              bubbles: true,
              cancelable: true,
            })
          );
          slide
            .querySelector(".shopify-model-viewer-ui__button")
            .setAttribute("tabindex", 0);
          slide
            .querySelector(".product-single__close-media")
            .setAttribute("tabindex", 0);
        }
      },

      _slideIndex: function (el) {
        return el.getAttribute("data-index");
      },

      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function () {
        var initialized = false;

        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(
            selectors.blocksHolder
          );
          var url = this.blocksHolder.dataset.url;

          fetch(url)
            .then(function (response) {
              return response.text();
            })
            .then(
              function (html) {
                //  window.global_popup_qty = 1;
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");
                var blocks = doc.querySelector(selectors.blocks);

                // Because the same product could be opened in quick view
                // on the page we load the form elements from, we need to
                // update any `id`, `for`, and `form` attributes
                blocks.querySelectorAll("[id]").forEach((el) => {
                  // Update input `id`
                  var val = el.getAttribute("id");
                  el.setAttribute("id", val + "-modal");

                  // Update related label if it exists
                  var label = blocks.querySelector(`[for="${val}"]`);
                  if (label) {
                    label.setAttribute("for", val + "-modal");
                  }

                  // Update any collapsible elements
                  var collapsibleTrigger = blocks.querySelector(
                    `[aria-controls="${val}"]`
                  );
                  if (collapsibleTrigger) {
                    collapsibleTrigger.setAttribute(
                      "aria-controls",
                      val + "-modal"
                    );
                  }
                });

                // Update any elements with `form` attribute.
                // Form element already has `-modal` appended
                var form = blocks.querySelector(this.selectors.form);
                if (form) {
                  var formId = form.getAttribute("id");
                  blocks.querySelectorAll("[form]").forEach((el) => {
                    el.setAttribute("form", formId);
                  });
                }

                this.blocksHolder.innerHTML = "";
                this.blocksHolder.append(blocks);
                this.blocksHolder.classList.add("product-form-holder--loaded");
                this.cacheElements();

                this.formSetup();
                this.updateModalProductInventory();

                if (Shopify && Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }
                $(".modal__centered-content .js-qty__num").on({
                  focusin: function () {
                    $(this).addClass("remove-padding-input");
                    $(".cart-text-main").hide();
                    $(this).removeClass("three-digit-space");
                    $(this).removeClass("two-digit-space");
                  },
                });
                $(".modal__centered-content .js-qty__num").on(
                  "focusout",
                  checkNumber
                );
                function checkNumber() {
                  $(this).removeClass("remove-padding-input");
                  $(".cart-text-main").show();

                  var inputValue = $(this).val();
                  console.log("this", inputValue);

                  // Define regular expressions for two and three-digit numbers
                  var twoDigitRegex = /^\d{2}$/;
                  var threeDigitRegex = /^\d{3}$/;

                  // Test if the input matches the regular expressions
                  if (twoDigitRegex.test(inputValue)) {
                    $(this).removeClass("three-digit-space");
                    $(this).addClass("two-digit-space");
                  } else if (threeDigitRegex.test(inputValue)) {
                    $(this).removeClass("two-digit-space");
                    $(this).addClass("three-digit-space");
                  } else {
                    $(this).removeClass("three-digit-space");
                    $(this).removeClass("two-digit-space");
                  }
                }
                // Re-hook up collapsible box triggers
                theme.collapsibles.init(this.container);

                document.dispatchEvent(
                  new CustomEvent("quickview:loaded", {
                    detail: {
                      productId: this.productId,
                    },
                  })
                );
              }.bind(this)
            );

          this.productSetup();
          this.videoSetup();

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener(
                "quickview:loaded",
                function (evt) {
                  if (evt.detail.productId === this.productId) {
                    this.initProductSlider();
                  }
                }.bind(this)
              );
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        AOS.refreshHard();

        document.dispatchEvent(
          new CustomEvent("quickview:open", {
            detail: {
              initialized: initialized,
              productId: this.productId,
            },
          })
        );
      },
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function () {
        window.inventories = window.inventories || {};
        this.container
          .querySelectorAll(".js-product-inventory-data")
          .forEach((el) => {
            var productId = el.dataset.productId;
            window.inventories[productId] = {};

            el.querySelectorAll(".js-variant-inventory-data").forEach((el) => {
              window.inventories[productId][el.dataset.id] = {
                quantity: el.dataset.quantity,
                policy: el.dataset.policy,
                incoming: el.dataset.incoming,
                next_incoming_date: el.dataset.date,
              };
            });
          });
      },

      closeModalProduct: function () {
        this.stopVideos();
      },

      initQuickAddForm: function () {
        this.updateModalProductInventory();

        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      },

      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function () {
        var modelViewerElements = this.container.querySelectorAll(
          this.selectors.media
        );
        if (modelViewerElements.length < 1) return;

        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },

      initShopifyXrLaunch: function () {
        document.addEventListener(
          "shopify_xr_launch",
          function () {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
                ":not(." +
                self.classes.hidden +
                ")"
            );
            currentMedia.dispatchEvent(
              new CustomEvent("xrLaunch", {
                bubbles: true,
                cancelable: true,
              })
            );
          }.bind(this)
        );
      },

      customMediaListners: function () {
        document.querySelectorAll(this.selectors.closeMedia).forEach((el) => {
          el.addEventListener(
            "click",
            function () {
              var slide = this.cache.mainSlider.querySelector(
                selectors.currentSlide
              );
              var media = slide.querySelector(this.selectors.media);
              if (media) {
                media.dispatchEvent(
                  new CustomEvent("mediaHidden", {
                    bubbles: true,
                    cancelable: true,
                  })
                );
              }
            }.bind(this)
          );
        });

        var modelViewers = this.container.querySelectorAll("model-viewer");
        if (modelViewers.length) {
          modelViewers.forEach((el) => {
            el.addEventListener(
              "shopify_model_viewer_ui_toggle_play",
              function (evt) {
                this.mediaLoaded(evt);
              }.bind(this)
            );

            el.addEventListener(
              "shopify_model_viewer_ui_toggle_pause",
              function (evt) {
                this.mediaUnloaded(evt);
              }.bind(this)
            );
          });
        }
      },

      mediaLoaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.remove(classes.hidden);
          });

        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },

      mediaUnloaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.add(classes.hidden);
          });

        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },

      onUnload: function () {
        theme.ProductMedia.removeSectionModels(this.sectionId);

        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }
      },
    });

    return Product;
  })();

  theme.VendorProducts = (function () {
    var maxProducts = 4;

    function VendorProducts(container) {
      if (!container) {
        return;
      }

      this.container = container;
      this.sectionId = this.container.getAttribute("data-section-id");
      this.currentProduct = this.container.getAttribute("data-product-id");

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600,
      });
    }

    VendorProducts.prototype = Object.assign({}, VendorProducts.prototype, {
      init: function () {
        this.outputContainer = document.getElementById(
          "VendorProducts-" + this.sectionId
        );
        this.vendor = this.container.getAttribute("data-vendor");
        if (this.vendor == "Bokksu") {
          var url = theme.routes.collections + "/vendors?q=" + this.vendor;
        } else {
          var url =
            theme.routes.collections +
            "/vendors?view=vendor-ajax&q=" +
            this.vendor;
        }

        // remove double `/` in case shop might have /en or language in URL
        url = url.replace("//", "/");

        fetch(url)
          .then(async function (response) {
            return response.text();
          })
          .then(async (html) => {
            var count = 0;
            var products = [];
            var modals = [];
            var parser = new DOMParser();
            let prodInventory;
            var doc = parser.parseFromString(html, "text/html");

            var allProds = doc.querySelectorAll(".grid-product");
            if (this.vendor == "Bokksu") {
              var Prods = [...allProds];
              allProds = Prods.reverse();
            }
            let checkZipcode = localStorage.getItem("zipcode");
            let filterProducts = [];
            if (theme.settings.localization) {
              let productIds = [];
              allProds.forEach((el) => {
                productIds.push(el.dataset.productId);
              });
              prodInventory = await vendorInventory(productIds);
            }
            // Do not add current product to output

            allProds.forEach((el) => {
              if (theme.settings.localization) {
                let product = prodInventory.find((item) => {
                  return item.variantId == el.dataset.variantId;
                });
                if (
                  product.variantId == el.dataset.variantId &&
                  product.isAvailable == true
                ) {
                  filterProducts.push(el);
                }
              } else {
                var id = el.dataset.productId;
                if (count === maxProducts) {
                  return;
                }

                if (id === this.currentProduct) {
                  return;
                }
                var modal = doc.querySelector(
                  '.modal[data-product-id="' + id + '"]'
                );
                if (modal) {
                  modals.push(modal);
                }

                count++;
                products.push(el);
              }
            });
            if (theme.settings.localization) {
              let vendorProducts = checkZipcode ? filterProducts : allProds;
              vendorProducts.forEach((el) => {
                var id = el.dataset.productId;
                if (count === maxProducts) {
                  return;
                }

                if (id === this.currentProduct) {
                  return;
                }
                var modal = doc.querySelector(
                  '.modal[data-product-id="' + id + '"]'
                );
                if (modal) {
                  modals.push(modal);
                }

                count++;
                products.push(el);
              });
            }
            this.outputContainer.innerHTML = "";

            if (products.length === 0) {
              this.container.classList.add("hide");
            } else {
              this.outputContainer.classList.remove("hide");
              this.outputContainer.append(...products);

              if (modals.length) {
                this.outputContainer.append(...modals);
                new theme.QuickShop(this.outputContainer);
              }
              setTimeout(() => {
                addChangeCartItem();
              }, 1500);

              new theme.QuickAdd(this.outputContainer);
              yotpoWidgetsContainer.initWidgets();
            }
          });
      },
    });

    return VendorProducts;
  })();

  // theme.CollectionProducts = (function () {
  //   var maxProducts = 4;

  //   function CollectionProducts(container) {
  //     if (!container) {
  //       return;
  //     }

  //     this.container = container;
  //     this.sectionId = this.container.getAttribute("data-section-id");
  //     this.currentProduct = this.container.getAttribute("data-product-id");

  //     theme.initWhenVisible({
  //       element: this.container,
  //       callback: this.init.bind(this),
  //       threshold: 600,
  //     });
  //   }

  //   CollectionProducts.prototype = Object.assign({}, CollectionProducts.prototype, {
  //     init: function () {
  //       this.outputContainer = document.getElementById(
  //         "CollectionProducts-" + this.sectionId
  //       );
  //       console.log("collections")
  //       this.collection = this.container.getAttribute("data-collection");

  //         var url =
  //           theme.routes.collections +
  //           "/" +
  //           this.collection + "?view-ajax";
  //               console.log("url collection",url)
  //       // remove double `/` in case shop might have /en or language in URL
  //       url = url.replace("//", "/");

  //       fetch(url)
  //         .then( async function (response) {
  //           return response.text();
  //         })
  //         .then(async (html) => {
  //           var count = 0;
  //           var products = [];
  //           var modals = [];
  //           var parser = new DOMParser();
  //           var doc = parser.parseFromString(html, "text/html");
  //           console.log("doc",doc)
  //           var allProds = doc.querySelectorAll(".product-grid");
  //           console.log("All",allProds)
  //           // Do not add current product to output
  //           let productIds =[]
  //           allProds.forEach((el) => {
  //              productIds.push(el.dataset.productId);
  //           });
  //           let prodInventory = await vendorInventory(productIds);
  //           let filterProducts = [];
  //           console.log("allProds",allProds,prodInventory)
  //           allProds.forEach((el) => {
  //              let product = prodInventory.find((item) => { return (item.variantId == el.dataset.variantId)});
  //              if(product.variantId == el.dataset.variantId && product.isAvailable == true){
  //                  filterProducts.push(el);
  //              }
  //           });
  //           console.log("filterProducts",filterProducts);
  //           filterProducts.forEach((el) => {
  //             console.log("el",el)
  //             var id = el.dataset.productId;
  //             if (count === maxProducts) {
  //               return;
  //             }

  //             if (id === this.currentProduct) {
  //               return;
  //             }
  //             var modal = doc.querySelector(
  //               '.modal[data-product-id="' + id + '"]'
  //             );
  //             if (modal) {
  //               modals.push(modal);
  //             }

  //             count++;
  //             products.push(el);
  //           });
  //           console.log()
  //           this.outputContainer.innerHTML = "";

  //           if (products.length === 0) {
  //             this.container.classList.add("hide");
  //           } else {
  //             console.log("products.length",products.length)
  //             this.outputContainer.classList.remove("hide");
  //             this.outputContainer.append(...products);

  //             if (modals.length) {
  //               this.outputContainer.append(...modals);
  //               new theme.QuickShop(this.outputContainer);
  //             }

  //             new theme.QuickAdd(this.outputContainer);
  //             yotpoWidgetsContainer.initWidgets();
  //           }
  //         });
  //     },
  //   });

  //   return CollectionProducts;
  // })();
  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = "test";
    var storage;
    if (type === "session") {
      storage = window.sessionStorage;
    }
    if (type === "local") {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, "1");
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function (scope) {
    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls();
      SPR.loadBadges();
    }

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  // Set a max-height on drawers when they're opened via CSS variable
  // to account for changing mobile window heights
  theme.sizeDrawer = function () {
    var header = document.getElementById("HeaderWrapper").offsetHeight;
    var max = window.innerHeight - header;
    document.documentElement.style.setProperty("--maxDrawerHeight", `${max}px`);
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported("session");
  theme.config.hasLocalStorage = theme.isStorageSupported("local");
  AOS.init({
    easing: "ease-out-quad",
    once: true,
    offset: 60,
    disableMutationObserver: true,
  });
  if (theme.config.hasLocalStorage) {
    var recentIds = window.localStorage.getItem("recently-viewed");
    if (recentIds && typeof recentIds !== undefined) {
      theme.recentlyViewedIds = JSON.parse(recentIds);
    }
  }

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function (mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent("matchSmall"));
    } else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent("unmatchSmall"));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function () {
    theme.collapsibles.init();
    theme.videoModal();
    theme.animationObserver();
  };

  DOMready(function () {
    theme.sections = new theme.Sections();
    theme.sections.register("slideshow-section", theme.SlideshowSection);
    theme.sections.register("header", theme.HeaderSection);
    theme.sections.register("toolbar", theme.Toolbar);
    theme.sections.register("product", theme.Product);
    theme.sections.register("password-header", theme.PasswordHeader);
    theme.sections.register("photoswipe", theme.Photoswipe);
    theme.sections.register("background-image", theme.BackgroundImage);
    theme.sections.register("testimonials", theme.Testimonials);
    theme.sections.register("video-section", theme.VideoSection);
    theme.sections.register("map", theme.Maps);
    theme.sections.register("footer-section", theme.FooterSection);
    theme.sections.register("store-availability", theme.StoreAvailability);
    theme.sections.register("recently-viewed", theme.RecentlyViewed);
    theme.sections.register("vendor-products", theme.VendorProducts);
    //theme.sections.register("collection-template", theme.CollectionProducts);
    theme.sections.register("newsletter-popup", theme.NewsletterPopup);
    theme.sections.register("collection-header", theme.CollectionHeader);
    theme.sections.register("collection-template", theme.Collection);

    theme.initGlobals();
    theme.rteInit();

    window.addEventListener("pageshow", () => {
      let form = $(".pdp_form_id").val();
      if (form) {
        $("#" + form)
          .get(0)
          .reset();
      }
    });

    if (document.body.classList.contains("template-cart")) {
      var cartPageForm = document.getElementById("CartPageForm");
      if (cartPageForm) {
        var cartForm = new theme.CartForm(cartPageForm);

        var recommendations = document.querySelector(
          '.cart-recommendations[data-location="page"]'
        );
        if (recommendations) {
          new theme.QuickAdd(recommendations);
          new theme.QuickShop(recommendations);
        }

        var noteBtn = cartPageForm.querySelector(".add-note");
        if (noteBtn) {
          noteBtn.addEventListener("click", function () {
            noteBtn.classList.toggle("is-active");
            cartPageForm.querySelector(".cart__note").classList.toggle("hide");
          });
        }

        document.addEventListener(
          "ajaxProduct:added",
          function (evt) {
            cartForm.buildCart();
          }.bind(this)
        );
      }
    }

    // Enable quick view/quick shop on search page
    if (document.body.classList.contains("template-search")) {
      var searchGrid = document.querySelector(".search-grid");
      if (searchGrid) {
        var searchProducts = searchGrid.querySelectorAll(".grid-product");
        if (searchProducts.length) {
          new theme.QuickAdd(searchGrid);
          new theme.QuickShop(searchGrid);
        } else {
        }
      }
    }

    if (document.body.classList.contains("template-article")) {
      var prodGrid = document.querySelectorAll(".product-grid");
      if (prodGrid.length) {
        for (let i = 0; i < prodGrid.length; i++) {
          var gridProducts = prodGrid[i].querySelectorAll(".grid-product");
          if (gridProducts.length) {
            new theme.QuickAdd(prodGrid[i]);
            new theme.QuickShop(prodGrid[i]);
          }
        }
      }
    }

    document.addEventListener("recommendations:loaded", function (evt) {
      if (evt && evt.detail && evt.detail.section) {
        new theme.QuickAdd(evt.detail.section);
        new theme.QuickShop(evt.detail.section);
      }
    });

    theme.pageTransitions();

    document.dispatchEvent(new CustomEvent("page:loaded"));

    // Product Detail Page - Set Product Quantity for Mini Cart (+ Button)
    $(".js-qty__adjust--plus").click(function () {
      $(".pdp-quantity-validation").text("");
      let productQty = parseInt($(".product_quantity").val());
      if (productQty > 0) {
        productQty = productQty;
        $(".product_quantity").val(productQty);
        $("#quantity-notification").html(`${productQty} quantity added`);
        console.log("plus :", $(".product_quantity").val());
      }
    });

    // Product Detail Page - Set Product Quantity for Mini Cart  (- Button)
    $(".js-qty__adjust--minus").click(function () {
      $(".pdp-quantity-validation").text("");
      $("#quantity-notification").html("1 quantity decrease");
      let productQty = parseInt($(".product_quantity").val());
      if (productQty > 1) {
        productQty = productQty;
        $(".product_quantity").val(productQty);
        console.log("minus :", $(".product_quantity").val());
      }
    });

    // Product Detail Page - Set Product Quantity for Mini Cart (Input)
    $(".js-qty__num").on("input", function () {
      $(".pdp-quantity-validation").text("");
      let productQty = parseInt($(this).val());
      if (productQty > 0) {
        $(".product_quantity").val(parseInt(productQty));
        console.log("input :", $(".product_quantity").val());

        window.global_popup_qty = productQty;
      } else if (isNaN(productQty)) {
        $(".product_quantity").val(1);
        window.global_popup_qty = 1;
      }
    });

    // Write a Review - Textarea Rows Set to 3
    window.onload = function () {
      $("#yotpo-main-widget-btn").click(function () {
        setTimeout(function () {
          if ($(".yotpo-new-review-content")[0]) {
            if ($(window).width() < 767) {
              $(".yotpo-new-review-content textarea").attr("rows", 2);
            }
          }
        }, 500);
      });
    };
  });
})();
$(".mobile-nav-trigger").on("click", function () {
  if ($(".site-header__mobile-nav").hasClass("is-active")) {
    $("#MainContent, .footer__section").addClass("blur-body");
  } else {
    $("#MainContent, .footer__section").removeClass("blur-body");
  }
});
$(".social-links").on("keydown", function (event) {
  if (event.keyCode == 32) {
    window.location = $(".social-links:focus").attr("href");
    return false;
  }
  if (
    $(".footer__base-links .social-links:first-child").is(":focus") &&
    event.keyCode == 9 &&
    event.shiftKey
  ) {
    $("#payment-icon").focus();
  }
});

$(".footer-menu-links").on("keydown", function (event) {
  if (event.keyCode == 32) {
    window.location = $(".footer-menu-links:focus").attr("href");
    return false;
  }
});

$(".policies-link").on("keydown", function (event) {
  if (event.keyCode == 32) {
    window.location = $(".policies-link:focus").attr("href");
    return false;
  }
});

let childFalg = false;
var childId;
var parentId;
$(".navbar-parent").each(function (i, element) {
  $(this).on("click", function (event) {
    let parent = $(this).attr("data-parent");
    parentId = $(this).attr("data-parent");
    if ($('.child[data-parent="' + parent + '"]').is(":visible")) {
      $('.child[data-parent="' + parent + '"]').hide();
      $('.navbar-parent[data-parent="' + parent + '"] .icon').css(
        "rotate",
        "0deg"
      );
      $(".child .child-dropdown-items").css("color", "black");
      $('.navbar-parent[data-parent="' + parent + '"] .link-title span').css(
        "color",
        "black"
      );

      childFalg = false;
    } else {
      // $('.child').hide()
      $(".grand-child").hide();
      $(".child .icon").css("rotate", "0deg");
      $(".navbar-parent .icon").css("rotate", "0deg");
      $(".child .child-dropdown-items").css("color", "black");
      $(".navbar-parent .link-title span").css("color", "black");
      $('.child[data-parent="' + parent + '"]').show();
      $('.child[data-parent="' + parent + '"]').addClass("brands-child");
      // $('.child[data-parent="' + parent + '"]').css({"margin-left":"25px","letter-spacing":".5px","font-family":"Lato"})
      $('.navbar-parent[data-parent="' + parent + '"] .link-title span').css(
        "color",
        "#294F2E"
      );
      $('.navbar-parent[data-parent="' + parent + '"] .icon').css(
        "rotate",
        "-180deg"
      );
    }
    if (
      $('.child[data-parent="' + parent + '"]').not(":visible") &&
      !childFalg
    ) {
      $('.grand-child[data-child="' + childId + '"]').hide();
      $('.icon[data-child="' + childId + '"]').css("rotate", "0deg");
    }
  });
});

$(".child").each(function (e) {
  $(this).on("click", function () {
    let child = $(this).attr("data-child");
    childId = $(this).attr("data-child");
    childFalg = true;
    console.log("child", child);
    if ($('.grand-child[data-child="' + child + '"]').is(":visible")) {
      $('.grand-child[data-child="' + child + '"]').hide();
      $('.icon[data-child="' + child + '"]').css("rotate", "0deg");
      $('.child[data-child="' + child + '"] .child-dropdown-items').css(
        "color",
        "black"
      );
    } else {
      $(".grand-child").hide();
      $('.child[data-parent="teir-2-brand4"]').hide();
      $(".child .icon").css("rotate", "0deg");
      $('.child[data-parent="' + parentId + '"]').hide();
      $('.navbar-parent[data-parent="' + parentId + '"] .icon').css(
        "rotate",
        "0deg"
      );
      $(".child .child-dropdown-items").css("color", "black");
      $('.grand-child[data-child="' + child + '"]').show();
      $('.icon[data-child="' + child + '"]').css("rotate", "-180deg");
      $('.child[data-child="' + child + '"] .child-dropdown-items').css(
        "color",
        "#294F2E"
      );
      $('.navbar-parent[data-parent="' + parentId + '"] .link-title span').css(
        "color",
        "black"
      );
    }
  });
});

setTimeout(function () {
  console.log("triggered!");
  if ($(".rebuy-product").length) {
    var rebuyGrid = $(".rebuy-product");
    var products = $(".rebuy-product .grid-product");
    if (products.length) {
      new theme.QuickAdd(rebuyGrid);
      new theme.QuickShop(rebuyGrid);
    }
  }
}, 2000);

function checkWindowScroll() {
  if ($("#HeaderWrapper").hasClass("header-wrapper--compressed")) {
    $("#HeaderWrapper").removeClass("is-light");
  }
  var scrollTop = $(window).scrollTop();
  if (scrollTop > 40) {
    $(".site-header__cart").css({ top: "64px" });
    $(".site-header__cart").addClass("scrolled-body");
  } else {
    $(".site-header__cart").css({ top: "107px" });
    $(".site-header__cart").removeClass("scrolled-body");
  }
}

$(window).scroll(function () {
  checkWindowScroll();
});
var scrollTop = $(window).scrollTop();
if (scrollTop > 40) {
  $(".site-header__cart").css({ paddingTop: "65px" });
} else {
  $(".site-header__cart").css({ paddingTop: "95px" });
}

//----CUSTOMER ALSO LOVE SCRIPT START-------//

var clicked;
var removedProducts = [];
$(".close-loved-pro").click(function () {
  $(".customer-loved").toggleClass("orient-add");
  $(".align-main-cart-customer").toggleClass("background-transparency");
});

let lastProductId = "";
function checkMarketCart() {
  if ($(".cart-items-new p .cart-link__bubble-num").text() == 0) {
    lastProductId = localStorage.removeItem("last-prod-id");
  }
}
checkMarketCart();
let output = "";
let filteredProducts;
let backupData;
let defaultProducts;

let defaultRequestParameters = new URLSearchParams({
  key: REBUY_API_KEY,
  shopify_product_ids: null,
  limit: 15,
});

async function defaultRebuyProducts() {
  let response = await fetch(
    `https://rebuyengine.com/api/v1/products/similar_products?${defaultRequestParameters}`
  );
  let products = await response.json();
  let filteredProducts = products.data.filter(
    (obj) =>
      obj.variants[0].inventory_quantity > 0 &&
      (obj.variants[0].price > 0 || !obj.tags.includes("free gift"))
  );

  return filteredProducts;
}

fetchCustomerLovedProductsSection2(null, null, null, null);

//----Cart Reccommendation SCRIPT Version 2 Start-------//
async function fetchCustomerLovedProductsSection2(
  productId,
  variantId,
  isFirstProdRefreh,
  index
) {
  let state = await theme.cart.getCart();
  let productsId = state.items.map((items) => {
    return items.product_id;
  });

  productsId.unshift(productId);
  let productCount = 20;
  let requestParameters;
  let count = productCount + productsId.length;
  requestParameters = new URLSearchParams({
    key: REBUY_API_KEY,
    shopify_product_ids: productsId,
    limit: count,
  });

  console.log("here in");

  if (variantId) {
    let data = {
      id: variantId,
      quantity: 1,
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (product) {
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
            },
          })
        );
        setTimeout(function () {
          $(".quick-add-btn").removeClass("cart-btn-disabled");
        }, 1200);
      },
      error: function (response) {
        console.log(response);
      },
    });
  }
  fetch(
    `https://rebuyengine.com/api/v1/products/similar_products?${requestParameters}`
  )
    .then((response) => response.json())
    .then(async (res) => {
      setTimeout(function () {
        $(".quick-add-btn").removeClass("cart-btn-disabled");
      }, 1200);
      let state = await theme.cart.getCart();

      filteredProducts = res.data.filter(
        (obj) =>
          obj.variants[0].inventory_quantity > 0 &&
          (obj.variants[0].price > 0 || !obj.tags.includes("free gift")) &&
          !obj.tags.includes("location-exclusive")
      );
      let arr = filteredProducts.filter(
        (item1) => !state.items.some((item2) => item1.id === item2.product_id)
      );
      localStorage.setItem("last-prod-id", state.items[0]?.product_id);
      defaultProducts = arr.length <= 0 && (await defaultRebuyProducts());
      filteredProducts = arr.length > 0 ? arr : defaultProducts;
      let output = " ";

      if (!isFirstProdRefreh) {
        backupData = filteredProducts;
      } else {
        for (j = 0; j < backupData.length; j++) {
          if (j == index) {
            let checkId = filteredProducts.filter(
              (items) => !backupData.some((item2) => items.id === item2.id)
            );
            backupData[j] = checkId[0];
            break;
          }
        }
      }
      for (let i = 0; i < backupData.length; i++) {
        let product = backupData[i];
        let isFirstProductRefresh;
        output += `<div class="main-loved-pro grid-product2" data-index=${i} product-data-id=${
          product.id
        }>
          <div class="loved-pro-img"><img src="${
            product.images[0].src
          }" /></div>
          <div class="about-loved-pro">
            <div class="title-loved-pro"><p>${product.title}</p></div>
            <div class="price-loved-pro"><p>$${
              product.variants[0].price
            } <span>${
          product.variants[0].compare_at_price
            ? product.variants[0].compare_at_price
            : ""
        }</span></p></div>
          </div>
          <div class="plus-icon-loved" id="rebuy-product">
            <button type="button" class="text-link quick-add-btn js-quick-add-btn" title="Add to cart" tabindex="-1" 
              data-product-name="${product.title}" data-product-handle="${
          product.handle
        }"                   
              data-id="${product.variants[0].id}"
              data-variant-id="${product.variants[0].id}"
              data-frequency="" data-unit-type=""
              onclick="addToCartSection2(this,${product.id},${
          product.variants[0].id
        },${(isFirstProductRefresh = true)},${i})"
            >
              <span class="btn btn--circle btn--icon">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 64 64"><path class="cls-1" d="M32 9v46m23-23H9"></path></svg>
                <span class="icon__fallback-text">Add to cart</span>
              </span>
            </button>
          </div>
        </div>`;
      }
      $(".section-2").html(output);
    });
}

async function addToCartSection2(
  evt,
  productId,
  variantId,
  isFirstProdRefresh,
  index
) {
  if (theme.settings.localization) {
    let checkZipCode = localStorage.getItem("zipcode");
    if (checkZipCode) {
      $(".quick-add-btn").addClass("cart-btn-disabled");
      $('.js-quick-add-btn[data-id="' + variantId + '"]').hide();
      let prodTitle = $(evt).attr("data-product-name");
      let state = await theme.cart.getCart();
      let item = state.items.filter((items) => {
        return items.variant_id == variantId;
      });
      let itemInventory = item.length > 0 && item[0].quantity;
      let productInventory = await availableInventory(variantId);
      if (
        itemInventory < productInventory.availableQuantity &&
        productInventory.isInStock
      ) {
        fetchCustomerLovedProductsSection2(
          productId,
          variantId,
          isFirstProdRefresh,
          index
        );
      } else {
        $(".quick-add-btn").removeClass("cart-btn-disabled");
        $('.js-quick-add-btn[data-id="' + variantId + '"]').show();
        alert(
          productInventory.availableQuantity
            ? `We can ship a maximum of ${productInventory.availableQuantity} ${prodTitle} to your zip code.`
            : `Item is out of stock at your location`
        );
      }
    } else {
      $(".zip-code-button").click();
    }
  } else {
    $(".quick-add-btn").addClass("cart-btn-disabled");
    $('.js-quick-add-btn[data-id="' + variantId + '"]').hide();
    fetchCustomerLovedProductsSection2(
      productId,
      variantId,
      isFirstProdRefresh,
      index
    );
  }
}
//----Cart Reccommendation SCRIPT Version 2 End-------//

function HideCALSection() {
  if ($(".listing-loved-products .main-loved-pro").length == 0) {
    $(".customer-loved").hide();
  }
  // if ($(".section-2 .main-loved-pro").length == 0) {
  //   $(".customer-loved").hide();
  // }
}

//----CUSTOMER ALSO LOVE SCRIPT END-------//

// rainforestQA starts

// $(function () {
//   function setCookie(cname, cvalue, exdays) {
//     const d = new Date();
//     d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
//     let expires = "expires=" + d.toUTCString();
//     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
//   }

//   var rainForestIPs = [
//     "178.63.22.133",
//     "176.9.32.6",
//     "188.40.127.2",
//     "188.40.89.135",
//     "46.4.94.240",
//     "46.4.66.90",
//     "5.9.93.73",
//     "54.193.132.139",
//     "78.46.38.150",
//     "78.46.36.58",
//     "88.198.26.199",
//     "107.170.58.26",
//     "54.193.132.139",
//     "159.203.36.96",
//     "167.71.210.36",
//     "52.65.93.197",
//   ];

//   try {
//     $.getJSON(
//       `https://api.ipgeolocation.io/ipgeo?apiKey=904d25d0cf8a422082056083aacfdf79`,
//       function (response) {
//         localStorage.setItem(
//           "rainForestQA",
//           rainForestIPs.includes(response.ip)
//         );
//         setCookie("rainForestQA", rainForestIPs.includes(response.ip), 30);
//         localStorage.setItem("user_ip", response.ip);
//       }
//     );
//   } catch (err) {
//     console.log("geolocation error : ", err);
//   }
// });

// rainforestQA ends
// cart__checkout
// btn-orange-bg
// btn-disabled
// function add_remove_free_gift() {
//   $(".cart__checkout").attr("disabled", true);
//   $(".cart__checkout").addClass("btn-disabled");
//   $(".cart__checkout").removeClass("btn-orange-bg");
//   theme.cart.getCart().then(function (cart) {
//     let items = cart.items;
//     let item_count = cart.item_count;
//     let free_gift_0 = false;
//     let free_gift_100 = false;
//     let free_gift_1000 = false;
//     console.log(items);
//     let marketSubTotal = 0;
//     items.forEach(function (item) {
//       if (item.product_type == "Market") {
//         marketSubTotal += item.final_line_price;
//       }

//       if (item.sku == "SML10334") {
//         free_gift_0 = true;
//       }
//       if (item.sku == "SMU30019") {
//         free_gift_100 = true;
//       }
//       if (item.sku == "SML10333") {
//         free_gift_1000 = true;
//       }
//     });

//     if (marketSubTotal > 10000 && marketSubTotal <= 100000) {
//       if (!free_gift_0) {
//         // add 0 free gift
//         add_free_gift("42637888291014");
//       }
//       if (!free_gift_100) {
//         // add 100 free gift
//         add_free_gift("42604621496518");
//       }
//       if (free_gift_1000) {
//         remove_free_gift("42637885046982");
//         // remove 1000 free gift
//       }
//     } else if (marketSubTotal > 100000) {
//       if (!free_gift_0) {
//         // add 0 free gift
//         add_free_gift("42637888291014");
//       }
//       if (!free_gift_100) {
//         // add 100 free gift
//         add_free_gift("42604621496518");
//       }
//       if (!free_gift_1000) {
//         add_free_gift("42637885046982");
//         // add 1000 free gift
//       }
//     } else if (marketSubTotal > 0) {
//       if (!free_gift_0) {
//         add_free_gift("42637888291014");
//         // add 0 free gift
//       }
//       if (free_gift_100) {
//         remove_free_gift("42604621496518");
//         // remove 100 free gift
//       }
//       if (free_gift_1000) {
//         remove_free_gift("42637885046982");
//         // remove 1000 free gift
//       }
//     } else {
//       if (free_gift_0) {
//         remove_free_gift("42637888291014");
//         // add 0 free gift
//       }
//       if (free_gift_100) {
//         remove_free_gift("42604621496518");
//         // remove 100 free gift
//       }
//       if (free_gift_1000) {
//         remove_free_gift("42637885046982");
//         // remove 1000 free gift
//       }
//       if (!free_gift_0 && !free_gift_100 && !free_gift_1000) {
//         $(".cart__checkout").removeAttr("disabled");
//         $(".cart__checkout").removeClass("btn-disabled");
//         $(".cart__checkout").addClass("btn-orange-bg");
//       }
//     }
//   });
// }

// function add_free_gift(variantId) {
//   theme.cart
//     ._updateCart({
//       url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
//       data: JSON.stringify({
//         id: variantId,
//         quantity: 0,
//       }),
//     })
//     .then(function (cart) {
//       data = {
//         id: variantId,
//         quantity: 1,
//       };

//       console.log("data: ", data);
//       fetch(theme.routes.cartAdd, {
//         method: "POST",
//         body: JSON.stringify(data),
//         credentials: "same-origin",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       })
//         .then((response) => response.json())
//         .then(
//           function (data) {
//             if (data.status === 422) {
//               this.error(data);
//             } else {
//               var product = data;
//               document.dispatchEvent(
//                 new CustomEvent("ajaxProduct:added", {
//                   detail: {
//                     product: {},
//                     //addToCartBtn: addToCart
//                   },
//                 })
//               );
//               $(".cart__checkout").removeAttr("disabled");
//               $(".cart__checkout").removeClass("btn-disabled");
//               $(".cart__checkout").addClass("btn-orange-bg");
//             }
//           }.bind(this)
//         );
//     });
// }

// function remove_free_gift(variantId) {
//   theme.cart
//     ._updateCart({
//       url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
//       data: JSON.stringify({
//         id: variantId,
//         quantity: 0,
//       }),
//     })
//     .then(function (cart) {
//       document.dispatchEvent(
//         new CustomEvent("ajaxProduct:added", {
//           detail: {
//             product: {},
//             //addToCartBtn: addToCart
//           },
//         })
//       );
//       $(".cart__checkout").removeAttr("disabled");
//       $(".cart__checkout").removeClass("btn-disabled");
//       $(".cart__checkout").addClass("btn-orange-bg");
//     });
// }

// Free Gift Customization
function addFreeGiftOne() {
  let gift1Handle = $("#selected-gift-1-product").text();

  if (gift1Handle) {
    let url = `https://${hostname}/products/${gift1Handle}.js`;
    url = url.replace(/%20/g, "");
    url = url.split(" ").join("");

    fetch(url)
      .then((response) => response.json())
      .then(async (res) => {
        let state;
        let filteredProduct = [];
        let product = "";
        let output = "";

        // console.log(res, 'res');

        if (res && res.variants[0].available === true) {
          output = "";

          state = await theme.cart.getCart();

          let giftItemIds = [];
          state.items.forEach(function (item) {
            if (
              item.properties &&
              item.properties._free_gift &&
              item.properties._free_gift == 1
            ) {
              giftItemIds.push(item.product_id);
            }
          });

          if (!giftItemIds.includes(res.id)) {
            filteredProduct.push(res);
          }

          // console.log(filteredProduct, 'filteredProduct');

          if (filteredProduct && filteredProduct[0]) {
            product = filteredProduct[0];
            freeGiftOneVariantId = product.variants[0].id;
            localStorage.setItem(
              "freeGiftOneVariantId",
              product.variants[0].id
            );
            output = `<div class="main-free-gift section-minicart-products main-dualcart">
           <div class="align-free-gift">
             <div class="align-title-minicart title-section-minicart">
               <h3> Grab Your Free Gift(s) </h3>
             </div>
             
             <div class="free-gifts-listings">
               <div class="align-free-gift">
                 <div class="main-slider-gift">
                     <div class="swiper giftSlider">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide">
                          <div class="gift-products">
                              <div class="align-gift-prod">
                                <div class="free-gift-img">
                                  <img src="${product.images[0]}" />
                                </div>
                                <div class="align-name-free-gift">
                                  <div class="free-gift-titles">
                                    ${product.title}
                                  </div>
                                  <div class="ajax-cart__price price">
                                    <span class="money">$0.00</span>
                                  </div>
                                </div>
                              </div>
                              
                              <div class="gift-free-add-btn">
                                 <button type="button" class="text-link quick-add-btn js-quick-add-btn" title="Add to Cart" tabindex="-1" onclick="addToCartFreeGift(this, ${product.variants[0].id})" data-id="${product.variants[0].id}" data-frequency="" data-unit-type="">Add</button>
                              </div>
                          </div>
                        </div>
                      </div>
                      <div class="swiper-button-next"></div>
                      <div class="swiper-button-prev"></div>
                    </div>
                 </div>
               </div>
             </div>
           </div>
        </div>`;

            // console.log(output, 'output');

            $(".free-gift-1-products").html(output);
            $(".swiper-button-next").hide();
            $(".swiper-button-prev").hide();
          } else {
            $(".main-free-gift").hide();
            $(".free-gift-1-products").html("");
          }
        }
        swiper();
      });
  }
}

function addFreeGiftTwo() {
  $(".free-gift-1-products").html("");

  let gift1Handle = $("#selected-gift-1-product").text();

  if (gift1Handle) {
    let urlGift1Product = `https://${hostname}/products/${gift1Handle}.js`;
    urlGift1Product = urlGift1Product.replace(/%20/g, "");
    urlGift1Product = urlGift1Product.split(" ").join("");

    fetch(urlGift1Product)
      .then((response) => response.json())
      .then(async (resProductOne) => {
        // console.log(resProductOne, "Res Gift One");

        let productOne = resProductOne;

        if (productOne) {
          freeGiftOneVariantId = productOne.variants[0].id;
          localStorage.setItem("freeGiftOneVariantId", freeGiftOneVariantId);
        }

        let gift2Handle = $("#selected-gift-2-product").text();

        if (gift2Handle) {
          let urlGift2Product = `https://${hostname}/products/${gift2Handle}.js`;
          urlGift2Product = urlGift2Product.replace(/%20/g, "");
          urlGift2Product = urlGift2Product.split(" ").join("");

          fetch(urlGift2Product)
            .then((response) => response.json())
            .then(async (res) => {
              // console.log(resProductTwo, "Res Gift Two");

              if (res) {
                let productTwo = res;

                if (productTwo) {
                  freeGiftTwoVariantId = productTwo.variants[0].id;
                  localStorage.setItem(
                    "freeGiftTwoVariantId",
                    freeGiftTwoVariantId
                  );
                }
              }

              let state;
              let filteredProducts = [];
              let product = "";
              let output = "";

              state = await theme.cart.getCart();

              let giftItemIds = [];
              state.items.forEach(function (item) {
                if (
                  item.properties &&
                  item.properties._free_gift &&
                  item.properties._free_gift == 1
                ) {
                  giftItemIds.push(item.product_id);
                }
              });

              // console.log(giftItemIds, 'giftItemIds');

              if (!giftItemIds.includes(productOne.id)) {
                filteredProducts.push(productOne);
              }

              if (!giftItemIds.includes(res.id)) {
                filteredProducts.push(res);
              }

              // console.log(filteredProducts, 'filteredProducts');

              if (filteredProducts.length > 0) {
                output += `<div class="product-grid main-free-gift section-minicart-products main-dualcart">
                     <div class="align-free-gift">
                       <div class="align-title-minicart title-section-minicart">
                         <h3> Grab Your Free Gift(s) </h3>
                       </div>
                       
                       <div class="free-gifts-listings">
                         <div class="align-free-gift">
                           <div class="main-slider-gift">
                               <div class="swiper giftSlider">
                                <div class="swiper-wrapper">`;

                for (let i = 0; i < filteredProducts.length; i++) {
                  product = filteredProducts[i];

                  output += `<div class="swiper-slide">
                                                  <div class="gift-products">
                                                      <div class="align-gift-prod">
                                                        <div class="free-gift-img">
                                                          <img src="${product.images[0]}" />
                                                        </div>
                                                        <div class="align-name-free-gift">
                                                          <div class="free-gift-titles">
                                                            ${product.title}
                                                          </div>
                                                          <div class="ajax-cart__price price">
                                                            <span class="money">$0.00</span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      
                                                      <div class="gift-free-add-btn">
                                                         <button type="button" class="text-link quick-add-btn js-quick-add-btn" title="Add to Cart" tabindex="-1" onclick="addToCartFreeGift(this, ${product.variants[0].id})" data-id="${product.variants[0].id}" data-frequency="" data-unit-type="">Add</button>
                                                      </div>
                                                  </div>
                                                </div>`;
                }

                output += ` </div>
                              <div class="swiper-button-next"></div>
                              <div class="swiper-button-prev"></div>
                            </div>
                         </div>
                       </div>
                     </div>
                   </div>
                </div>`;

                // console.log(output, 'output');

                $(".free-gift-2-products").html(output);

                if (filteredProducts.length === 1) {
                  $(".swiper-button-next").hide();
                  $(".swiper-button-prev").hide();
                } else if (filteredProducts.length > 1) {
                  $(".swiper-button-next").show();
                  $(".swiper-button-prev").show();
                }
              } else {
                $(".main-free-gift").hide();
                $(".free-gift-2-products").html("");
              }

              swiper();
            });
        }
      });
  }
}
function removeFreeGiftOne(freeGiftOneExistInCart) {
  // console.log(freeGiftOneExistInCart, 'freeGiftOneExistInCart');
  $(".free-gift-1-products").html("");
  if (freeGiftOneExistInCart === true) {
    if (freeGiftOneVariantId) {
      removeFreeGiftOneGiftTwo(freeGiftOneVariantId);
    }
  }
}

function removeFreeGiftTwo(freeGiftTwoExistInCart, removeGiftOne) {
  // console.log(freeGiftTwoExistInCart, 'freeGiftTwoExistInCart');
  $(".free-gift-2-products").html("");
  if (freeGiftTwoExistInCart === true) {
    if (removeGiftOne === true) {
      if (freeGiftOneVariantId) {
        removeFreeGiftOneGiftTwo(freeGiftOneVariantId);
      }
    }

    if (freeGiftTwoVariantId) {
      // console.log('In Remove Free Gift Two');
      if (removeGiftOne === true) {
        setTimeout(function () {
          removeFreeGiftOneGiftTwo(freeGiftTwoVariantId);
        }, 2000);
      } else {
        removeFreeGiftOneGiftTwo(freeGiftTwoVariantId);
      }
    }
  }
}

function removeFreeGiftOneGiftTwo(variantId) {
  const items = {
    id: variantId,
    quantity: 0,
    properties: {
      _free_gift: 1,
    },
  };

  $.ajax({
    url: "/cart/change.js",
    dataType: "json",
    data: items,
    success: function (result) {
      // console.log(result, 'result');
      freeGiftOneExistInCart = false;
      freeGiftTwoExistInCart = false;
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          detail: {
            product: result,
          },
        })
      );
      atcAndQtyButtonSwitch(variantId, "remove");
    },
    error: function (error) {
      console.log("error: ", error.responseJSON.description);
    },
  });
}
async function addToCartFreeGift(button, variantId) {
  button.disabled = true;
  console.log(variantId, "variantId");

  let data = {
    id: variantId,
    quantity: 1,
    properties: {
      _free_gift: 1,
    },
  };

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (product) {
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          detail: {
            product: product,
          },
        })
      );
      atcAndQtyButtonSwitch(product, "add");
    },
    error: function (response) {
      console.log(response);
    },
  });
}
function swiper() {
  let swiper = new Swiper(".giftSlider", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

// // Bokksu Digital Gift Card Set Variant
// setTimeout(function() {
//   $(".swatch-selector").click(function () {

//     let value = $(this).attr("data-value");

//     if(value == "$30") {
//       $(".product-single__form .add-to-cart").attr('data-variant-id', '42232998396099');
//     } else if(value === "$60") {
//       $(".product-single__form .add-to-cart").attr('data-variant-id', '42232998428867');
//     } else if(value === "$100") {
//       $(".product-single__form .add-to-cart").attr('data-variant-id', '42232998461635');
//     } else if(value === "$200") {
//       $(".product-single__form .add-to-cart").attr('data-variant-id', '42232998494403');
//     }

//   });
// }, 2000);

async function addItem(el, ItemId, quantity = 1) {
  const items = {
    id: ItemId,
    quantity: quantity,
  };

  let productName = $(el).attr("data-product-name");
  let productHandle = $(el).attr("data-product-handle");
  fetch(theme.routes.cartAdd, {
    method: "POST",
    body: JSON.stringify(items),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(
      function (data) {
        theme.cart.getCart().then((state) => {
          let frozenItems = state.items.filter((res) => res.sku.includes("FZ"));
          let marketItems = state.items.filter(
            (res) => !res.sku.includes("FZ")
          );
          let frozenTotal = 0;
          let marketTotal = 0;
          frozenTotal = calculateTotal(frozenItems) / 100;
          marketTotal = calculateTotal(marketItems) / 100;

          if (marketTotal < 15) {
            localStorage.removeItem("popupShown");
          } else if (marketTotal > 15 && marketTotal < 30) {
            localStorage.removeItem("popupShown30");
          } else if (marketTotal > 30 && marketTotal < 40) {
            localStorage.removeItem("popupShown40");
          } else if (marketTotal > 40 && marketTotal < 49) {
            localStorage.removeItem("popupShown49");
          } else if (marketTotal > 49 && marketTotal < 75) {
            localStorage.removeItem("popupShown75");
          } else if (marketTotal > 75 && marketTotal < 100) {
            localStorage.removeItem("popupShown100");
          }

          if (frozenTotal < 15) {
            localStorage.removeItem("popupShownfz");
          } else if (frozenTotal > 30 && frozenTotal < 40) {
            localStorage.removeItem("popupShownfz30");
          } else if (frozenTotal > 40 && frozenTotal < 70) {
            localStorage.removeItem("popupShownfz40");
          } else if (frozenTotal > 70 && frozenTotal < 100) {
            localStorage.removeItem("popupShownfz49");
          }

          if (data.sku.includes("FZ")) {
            if (frozenItems.length == 1) {
              openCart();
              showHideFrozenCheckout(frozenTotal, state.item_count);
            } else if (frozenTotal >= 15 && frozenTotal < 30) {
              console.log(localStorage.getItem("popupShownfz"), "popupShownfz");
              if (localStorage.getItem("popupShownfz")) {
                // $("#shopify-section-floating-frozen-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShownfz")) {
                openCart();
                showHideFrozenCheckout(frozenTotal, state.item_count);
                localStorage.setItem("popupShownfz", "true");
                // $("#shopify-section-floating-frozen-checkout-button").show();
              }
            } else if (frozenTotal >= 30 && frozenTotal < 70) {
              console.log(
                localStorage.getItem("popupShownfz30"),
                "popupShownfz30"
              );
              if (localStorage.getItem("popupShownfz30")) {
                // $("#shopify-section-floating-frozen-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShownfz30")) {
                openCart();
                showHideFrozenCheckout(frozenTotal, state.item_count);
                localStorage.setItem("popupShownfz30", "true");
                // $("#shopify-section-floating-frozen-checkout-button").show();
              }
            } else if (frozenTotal >= 70 && frozenTotal < 100) {
              console.log(
                localStorage.getItem("popupShownfz40"),
                "popupShownfz40"
              );
              if (localStorage.getItem("popupShownfz40")) {
                // $("#shopify-section-floating-frozen-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShownfz40")) {
                openCart();
                showHideFrozenCheckout(frozenTotal, state.item_count);
                localStorage.setItem("popupShownfz40", "true");
                // $("#shopify-section-floating-frozen-checkout-button").show();
              }
            } else if (frozenTotal >= 100 && frozenTotal < 125) {
              console.log(
                localStorage.getItem("popupShownfz49"),
                "popupShownfz49"
              );
              if (localStorage.getItem("popupShownfz49")) {
                $("#shopify-section-floating-frozen-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShownfz49")) {
                showHideFrozenCheckout(frozenTotal, state.item_count);
                openCart();
                localStorage.setItem("popupShownfz49", "true");
                $("#shopify-section-floating-frozen-checkout-button").show();
              }
            }
            // frozenChangeUpdateCart(frozenTotal, marketTotal);
          } else {
            if (marketItems.length == 1) {
              showHideCheckout(marketTotal, state.item_count);
              openCart();
              console.log("1 item added");
            } else if (marketTotal >= 15 && marketTotal < 30) {
              console.log(localStorage.getItem("popupShown"), "popupShown");
              if (localStorage.getItem("popupShown")) {
                // $("#shopify-section-floating-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShown")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown", "true");
                // $("#shopify-section-floating-checkout-button").show();
              }
            } else if (marketTotal >= 30 && marketTotal < 40) {
              console.log(localStorage.getItem("popupShown30"), "popupShown30");
              if (localStorage.getItem("popupShown30")) {
                // $("#shopify-section-floating-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShown30")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown30", "true");
                // $("#shopify-section-floating-checkout-button").show();
              }
            } else if (marketTotal >= 40 && marketTotal < 49) {
              console.log(localStorage.getItem("popupShown40"), "popupShown40");
              if (localStorage.getItem("popupShown40")) {
                // $("#shopify-section-floating-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShown40")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown40", "true");
                // $("#shopify-section-floating-checkout-button").show();
              }
            } else if (marketTotal >= 49 && marketTotal < 75) {
              console.log(localStorage.getItem("popupShown40"), "popupShown49");
              if (localStorage.getItem("popupShown49")) {
                // $("#shopify-section-floating-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShown49")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown49", "true");
                // $("#shopify-section-floating-checkout-button").show();
              }
            } else if (marketTotal >= 75 && marketTotal < 100) {
              console.log(localStorage.getItem("popupShown40"), "popupShown49");
              if (localStorage.getItem("popupShown75")) {
                // $("#shopify-section-floating-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShown75")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown75", "true");
                // $("#shopify-section-floating-checkout-button").show();
              }
            } else if (marketTotal >= 100 && marketTotal < 125) {
              console.log(localStorage.getItem("popupShown40"), "popupShown49");
              if (localStorage.getItem("popupShown100")) {
                // $("#shopify-section-floating-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShown100")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown100", "true");
                // $("#shopify-section-floating-checkout-button").show();
              }
            }
            // frozenTotal = frozenTotal / 100;
            // marketTotal = marketTotal / 100;

            if (marketTotal < 15) {
              localStorage.removeItem("popupShown");
            } else if (marketTotal > 15 && marketTotal < 30) {
              localStorage.removeItem("popupShown30");
            } else if (marketTotal > 30 && marketTotal < 40) {
              localStorage.removeItem("popupShown40");
            } else if (marketTotal > 40 && marketTotal < 49) {
              localStorage.removeItem("popupShown49");
            } else if (marketTotal > 49 && marketTotal < 75) {
              localStorage.removeItem("popupShown75");
            } else if (marketTotal > 75 && marketTotal < 100) {
              localStorage.removeItem("popupShown100");
            }

            if (frozenTotal < 20) {
              localStorage.removeItem("popupShownfz");
            } else if (frozenTotal > 20 && frozenTotal < 40) {
              localStorage.removeItem("popupShownfz30");
            } else if (frozenTotal > 40 && frozenTotal < 70) {
              localStorage.removeItem("popupShownfz40");
            } else if (frozenTotal > 70 && frozenTotal < 100) {
              localStorage.removeItem("popupShownfz49");
            }

            if (data.sku.includes("FZ")) {
              if (state.item_count == 1) {
                showHideFrozenCheckout(frozenTotal, state.item_count);
              } else if (frozenTotal >= 20 && frozenTotal < 40) {
                console.log(
                  localStorage.getItem("popupShownfz"),
                  "popupShownfz"
                );
                if (localStorage.getItem("popupShownfz")) {
                  $("#shopify-section-floating-frozen-checkout-button").hide();
                }
                if (!localStorage.getItem("popupShownfz")) {
                  showHideFrozenCheckout(frozenTotal, state.item_count);
                  localStorage.setItem("popupShownfz", "true");
                  $("#shopify-section-floating-frozen-checkout-button").show();
                }
              } else if (frozenTotal >= 40 && frozenTotal < 70) {
                console.log(
                  localStorage.getItem("popupShownfz30"),
                  "popupShownfz30"
                );
                if (localStorage.getItem("popupShownfz30")) {
                  $("#shopify-section-floating-frozen-checkout-button").hide();
                }
                if (!localStorage.getItem("popupShownfz30")) {
                  showHideFrozenCheckout(frozenTotal, state.item_count);
                  localStorage.setItem("popupShownfz30", "true");
                  $("#shopify-section-floating-frozen-checkout-button").show();
                }
              } else if (frozenTotal >= 70 && frozenTotal < 100) {
                console.log(
                  localStorage.getItem("popupShownfz40"),
                  "popupShownfz40"
                );
                if (localStorage.getItem("popupShownfz40")) {
                  $("#shopify-section-floating-frozen-checkout-button").hide();
                }
                if (!localStorage.getItem("popupShownfz40")) {
                  showHideFrozenCheckout(frozenTotal, state.item_count);
                  localStorage.setItem("popupShownfz40", "true");
                  $("#shopify-section-floating-frozen-checkout-button").show();
                }
              } else if (frozenTotal >= 100 && frozenTotal < 125) {
                console.log(
                  localStorage.getItem("popupShownfz49"),
                  "popupShownfz49"
                );
                if (localStorage.getItem("popupShownfz49")) {
                  $("#shopify-section-floating-frozen-checkout-button").hide();
                }
                if (!localStorage.getItem("popupShownfz49")) {
                  showHideFrozenCheckout(frozenTotal, state.item_count);
                  localStorage.setItem("popupShownfz49", "true");
                  $("#shopify-section-floating-frozen-checkout-button").show();
                }
              }
              // frozenChangeUpdateCart(frozenTotal, marketTotal);
            } else {
              if (state.item_count == 1) {
                showHideCheckout(marketTotal, state.item_count);
                console.log("1 item added");
              } else if (marketTotal >= 15 && marketTotal < 30) {
                console.log(localStorage.getItem("popupShown"), "popupShown");
                if (localStorage.getItem("popupShown")) {
                  // $("#shopify-section-floating-checkout-button").hide();
                }
                if (!localStorage.getItem("popupShown")) {
                  showHideCheckout(marketTotal, state.item_count);
                  localStorage.setItem("popupShown", "true");
                  // $("#shopify-section-floating-checkout-button").show();
                }
              } else if (marketTotal >= 30 && marketTotal < 40) {
                console.log(
                  localStorage.getItem("popupShown30"),
                  "popupShown30"
                );
                if (localStorage.getItem("popupShown30")) {
                  // $("#shopify-section-floating-checkout-button").hide();
                }
                if (!localStorage.getItem("popupShown30")) {
                  showHideCheckout(marketTotal, state.item_count);
                  localStorage.setItem("popupShown30", "true");
                  // $("#shopify-section-floating-checkout-button").show();
                }
              } else if (marketTotal >= 40 && marketTotal < 49) {
                console.log(
                  localStorage.getItem("popupShown40"),
                  "popupShown40"
                );
                if (localStorage.getItem("popupShown40")) {
                  // $("#shopify-section-floating-checkout-button").hide();
                }
                if (!localStorage.getItem("popupShown40")) {
                  showHideCheckout(marketTotal, state.item_count);
                  localStorage.setItem("popupShown40", "true");
                  // $("#shopify-section-floating-checkout-button").show();
                }
              } else if (marketTotal >= 49 && marketTotal < 75) {
                console.log(
                  localStorage.getItem("popupShown40"),
                  "popupShown49"
                );
                if (localStorage.getItem("popupShown49")) {
                  // $("#shopify-section-floating-checkout-button").hide();
                }
                if (!localStorage.getItem("popupShown49")) {
                  showHideCheckout(marketTotal, state.item_count);
                  localStorage.setItem("popupShown49", "true");
                  // $("#shopify-section-floating-checkout-button").show();
                }
              } else if (marketTotal >= 75 && marketTotal < 100) {
                console.log(
                  localStorage.getItem("popupShown40"),
                  "popupShown49"
                );
                if (localStorage.getItem("popupShown75")) {
                  // $("#shopify-section-floating-checkout-button").hide();
                }
                if (!localStorage.getItem("popupShown75")) {
                  showHideCheckout(marketTotal, state.item_count);
                  localStorage.setItem("popupShown75", "true");
                  // $("#shopify-section-floating-checkout-button").show();
                }
              } else if (marketTotal >= 100 && marketTotal < 125) {
                console.log(
                  localStorage.getItem("popupShown40"),
                  "popupShown49"
                );
                if (localStorage.getItem("popupShown100")) {
                  // $("#shopify-section-floating-checkout-button").hide();
                }
                if (!localStorage.getItem("popupShown100")) {
                  showHideCheckout(marketTotal, state.item_count);
                  localStorage.setItem("popupShown100", "true");
                  // $("#shopify-section-floating-checkout-button").show();
                }
              }
              // changeUpdateCart(marketTotal,frozenTotal);
            }
          }
        });
        if (data.status === 422 || data.status === "bad_request") {
        } else {
          if (quantity > 0) {
            $(el)
              .parent()
              .html(
                `<button class="qty-custom-minus test2" aria-label=" reduce quantity by 1 for ${productName}" tabindex="0" data-prod-id="${ItemId}" data-prod-qty="${quantity}"><div class="expanded-qty-btn">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.33337 8H12.6667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                </div></button>
                <span class="custom-qty">${quantity}</span>
                <div aria-live="polite" role="status" id="quantity-notification" class="visually-hidden"></div>
                <button class="qty-custom-plus" data-product-handle="${productHandle}" aria-label="increase quantity by 1 for ${productName}" data-product-name="${productName}" tabindex="0"  data-prod-id="${ItemId}" data-prod-qty="${quantity}"><div class="expanded-qty-btn">
               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 3.33301V12.6663" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.33331 8H12.6666" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                </div></button>`
              );
          } else {
            $(el)
              .parent()
              .html(
                `<button aria-label="Add to cart" data-product-handle="${productHandle}" data-product-name="${productName}" class="qty-custom-add test2" data-prod-id="${ItemId}"> <img  src="https://cdn.shopify.com/s/files/1/0557/4269/3571/files/plus1.svg?v=1696942105" width="24" /></button>`
              );
          }

          let product = data;

          document.dispatchEvent(
            new CustomEvent("cart:build", {
              detail: {
                product: product,
              },
            })
          );
        }
      }.bind(this)
    );
}

async function changeItem(el, ItemId, quantity = 1) {
  let prevState = await theme.cart.getCart();
  let idx1;
  let prevSku;
  prevState.items.filter((res, index) => {
    if (res.id == ItemId) {
      idx1 = index;
      prevSku = res.sku;
    }
  });

  const items = {
    id: ItemId.toString(),
    quantity: quantity,
  };

  let productName = $(el).attr("data-product-name");
  let productHandle = $(el).attr("data-product-handle");
  fetch(theme.routes.cartChange, {
    method: "POST",
    body: JSON.stringify(items),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(
      function (data) {
        theme.cart.getCart().then((state) => {
          let idx;
          state.items.filter((res, index) => {
            if (res.id == ItemId) {
              idx = index;
            }
          });

          let productIndex = data.items[idx];

          let frozenItems = state.items.filter((res) => res.sku.includes("FZ"));
          let marketItems = state.items.filter(
            (res) => !res.sku.includes("FZ")
          );

          let frozenTotal = 0;
          let marketTotal = 0;
          frozenTotal = calculateTotal(frozenItems) / 100;
          marketTotal = calculateTotal(marketItems) / 100;

          if (marketTotal < 15) {
            localStorage.removeItem("popupShown");
          } else if (marketTotal > 15 && marketTotal < 30) {
            localStorage.removeItem("popupShown30");
          } else if (marketTotal > 30 && marketTotal < 40) {
            localStorage.removeItem("popupShown40");
          } else if (marketTotal > 40 && marketTotal < 49) {
            localStorage.removeItem("popupShown49");
          } else if (marketTotal > 49 && marketTotal < 75) {
            localStorage.removeItem("popupShown75");
          } else if (marketTotal > 75 && marketTotal < 100) {
            localStorage.removeItem("popupShown100");
          }

          if (frozenTotal < 20) {
            localStorage.removeItem("popupShownfz");
          } else if (frozenTotal > 20 && frozenTotal < 40) {
            localStorage.removeItem("popupShownfz30");
          } else if (frozenTotal > 40 && frozenTotal < 70) {
            localStorage.removeItem("popupShownfz40");
          } else if (frozenTotal > 70 && frozenTotal < 100) {
            localStorage.removeItem("popupShownfz49");
          }

          if (productIndex?.sku.includes("FZ") || prevSku.includes("FZ")) {
            if (frozenItems.length == 1) {
              openCart();
              showHideFrozenCheckout(frozenTotal, state.item_count);
            } else if (frozenTotal >= 20 && frozenTotal < 40) {
              console.log(localStorage.getItem("popupShownfz"), "popupShownfz");
              // if (localStorage.getItem("popupShownfz")) {
              //   $("#shopify-section-floating-frozen-checkout-button").hide();
              // }
              if (!localStorage.getItem("popupShownfz")) {
                openCart();
                showHideFrozenCheckout(frozenTotal, state.item_count);
                localStorage.setItem("popupShownfz", "true");
                // $("#shopify-section-floating-frozen-checkout-button").show();
              } else {
                setTimeout(() => {
                  $("#floating-frozen-checkout-btn").css({
                    bottom: "-300px",
                  });
                }, 3000);
              }
            } else if (frozenTotal >= 40 && frozenTotal < 70) {
              console.log(
                localStorage.getItem("popupShownfz30"),
                "popupShownfz30"
              );
              // if (localStorage.getItem("popupShownfz30")) {
              //   $("#shopify-section-floating-frozen-checkout-button").hide();
              // }
              if (!localStorage.getItem("popupShownfz30")) {
                openCart();
                showHideFrozenCheckout(frozenTotal, state.item_count);
                localStorage.setItem("popupShownfz30", "true");
                // $("#shopify-section-floating-frozen-checkout-button").show();
              } else {
                setTimeout(() => {
                  $("#floating-frozen-checkout-btn").css({
                    bottom: "-300px",
                  });
                }, 3000);
              }
            } else if (frozenTotal >= 70 && frozenTotal < 100) {
              console.log(
                localStorage.getItem("popupShownfz40"),
                "popupShownfz40"
              );
              // if (localStorage.getItem("popupShownfz40")) {
              //   $("#shopify-section-floating-frozen-checkout-button").hide();
              // }
              if (!localStorage.getItem("popupShownfz40")) {
                openCart();
                showHideFrozenCheckout(frozenTotal, state.item_count);
                localStorage.setItem("popupShownfz40", "true");
                // $("#shopify-section-floating-frozen-checkout-button").show();
              } else {
                setTimeout(() => {
                  $("#floating-frozen-checkout-btn").css({
                    bottom: "-300px",
                  });
                }, 3000);
              }
            } else if (frozenTotal >= 100 && frozenTotal < 125) {
              console.log(
                localStorage.getItem("popupShownfz49"),
                "popupShownfz49"
              );
              // if (localStorage.getItem("popupShownfz49")) {
              //   $("#shopify-section-floating-frozen-checkout-button").hide();
              // }
              if (!localStorage.getItem("popupShownfz49")) {
                openCart();
                showHideFrozenCheckout(frozenTotal, state.item_count);
                localStorage.setItem("popupShownfz49", "true");
                // $("#shopify-section-floating-frozen-checkout-button").show();
              } else {
                setTimeout(() => {
                  $("#floating-frozen-checkout-btn").css({
                    bottom: "-300px",
                  });
                }, 3000);
              }
            }
            // frozenChangeUpdateCart(frozenTotal, marketTotal);
          } else {
            if (state.item_count == 1) {
              openCart();
              showHideCheckout(marketTotal, state.item_count);
              console.log("1 item added");
            } else if (marketTotal >= 15 && marketTotal < 30) {
              console.log(localStorage.getItem("popupShown"), "popupShown");
              // if (localStorage.getItem("popupShown")) {
              //   // $("#shopify-section-floating-checkout-button").hide();
              // }
              if (!localStorage.getItem("popupShown")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown", "true");
                // $("#shopify-section-floating-checkout-button").show();
              } else {
                setTimeout(() => {
                  $("#floating-checkout-btn").css({
                    bottom: "-300px",
                  });
                }, 3000);
              }
            } else if (marketTotal >= 30 && marketTotal < 40) {
              console.log(localStorage.getItem("popupShown30"), "popupShown30");
              // if (localStorage.getItem("popupShown30")) {
              //   // $("#shopify-section-floating-checkout-button").hide();
              // }
              if (!localStorage.getItem("popupShown30")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown30", "true");
                // $("#shopify-section-floating-checkout-button").show();
              } else {
                setTimeout(() => {
                  $("#floating-checkout-btn").css({
                    bottom: "-300px",
                  });
                }, 3000);
              }
            } else if (marketTotal >= 40 && marketTotal < 49) {
              console.log(localStorage.getItem("popupShown40"), "popupShown40");
              if (localStorage.getItem("popupShown40")) {
                // $("#shopify-section-floating-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShown40")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown40", "true");
                // $("#shopify-section-floating-checkout-button").show();
              } else {
                setTimeout(() => {
                  $("#floating-checkout-btn").css({
                    bottom: "-300px",
                  });
                }, 3000);
              }
            } else if (marketTotal >= 49 && marketTotal < 75) {
              console.log(localStorage.getItem("popupShown40"), "popupShown49");
              if (localStorage.getItem("popupShown49")) {
                // $("#shopify-section-floating-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShown49")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown49", "true");
                // $("#shopify-section-floating-checkout-button").show();
              }
            } else if (marketTotal >= 75 && marketTotal < 100) {
              console.log(localStorage.getItem("popupShown40"), "popupShown49");
              if (localStorage.getItem("popupShown75")) {
                // $("#shopify-section-floating-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShown75")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown75", "true");
                // $("#shopify-section-floating-checkout-button").show();
              }
            } else if (marketTotal >= 100 && marketTotal < 125) {
              console.log(localStorage.getItem("popupShown40"), "popupShown49");
              if (localStorage.getItem("popupShown100")) {
                // $("#shopify-section-floating-checkout-button").hide();
              }
              if (!localStorage.getItem("popupShown100")) {
                openCart();
                showHideCheckout(marketTotal, state.item_count);
                localStorage.setItem("popupShown100", "true");
                // $("#shopify-section-floating-checkout-button").show();
              }
            } else {
              setTimeout(() => {
                $("#floating-checkout-btn").css({
                  // display: "none",
                  bottom: "-300px",
                });
              }, 3000);

              if (state.item_count < 1) {
                setTimeout(() => {
                  $("#floating-checkout-btn").css({
                    // display: "none",
                    bottom: "-300px",
                  });
                }, 3000);
              } else {
                setTimeout(() => {
                  $("#floating-checkout-btn").css({
                    // display: "none",
                    bottom: "-300px",
                  });
                }, 3000);
              }
            }
            // changeUpdateCart(marketTotal,frozenTotal);
          }
        });
        if (data.status === 422 || data.status === "bad_request") {
        } else {
          if (quantity > 0) {
            // unavailable products in zip code of user

            var unavailableProducts =
              JSON.parse(localStorage.getItem("unavailableProducts")) || [];
            function isVariantUnavailable(variantId) {
              return unavailableProducts.includes(variantId);
            }

            $("#quantity-notification").html(`${quantity} quantity added`);
            let qtyCustomMinusSVG =
              "https://cdn.shopify.com/s/files/1/0557/4269/3571/files/minus.svg?v=1689682578";

            if (quantity == 1) {
              const qtyCustomTrashSVG =
                "https://cdn.shopify.com/s/files/1/0557/4269/3571/files/minus.svg?v=1689682578";
              qtyCustomMinusSVG = qtyCustomTrashSVG;
            }

            $(el)
              .parent()
              .html(
                `<button class="qty-custom-minus test" aria-label=" reduce quantity by 1 for ${productName}" tabindex="0" data-prod-id="${ItemId}" data-prod-qty="${quantity}"><div class="expanded-qty-btn">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.33337 8H12.6667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                </div></button>
                <span class="custom-qty">${quantity}</span>
                <div aria-live="polite" role="status" id="quantity-notification" class="visually-hidden"></div>
                <button data-product-handle="${productHandle}" class="qty-custom-plus" aria-label="increase quantity by 1 for ${productName}" tabindex="0"  data-prod-id="${ItemId}" data-prod-qty="${quantity}"><div class="expanded-qty-btn">
               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 3.33301V12.6663" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.33331 8H12.6666" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                </div></button>`
              );
          } else {
            // FS vNext code starts
            let elParent = $(el).parent();
            let parentElement = $(el).closest(".add-item-to-cart");
            $(parentElement).html(
              `
                <div class="qty-custom-add new-add-cart-button redndered-btn-cart long-plus-btn" data-prod-id="${ItemId}">
                <button data-product-handle="${productHandle}" class="qty-custom-add" data-prod-id="${ItemId}" data-product-name="${productName}" type="button" aria-label="add to cart for ${productName}" tabindex="0">  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                  <path d="M12.4004 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M5.40039 12H19.4004" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>  <span>Add to cart</span> </button>
                  <div aria-live="polite" role="status" id="quantity-notification" class="visually-hidden"></div>
                </div>`
            );
            $(elParent)
              .find("button.qty-custom-add")
              .on("click", function () {
                let prodId = $(this).attr("data-prod-id");
                let prodQty = 1;
                $(this).addClass("disable-div");
                if ((collectionPage && !productPage) || isSearch) {
                  addItem(this, prodId, prodQty);
                }
              });
            // FS vNext code ends
          }

          let product = data;

          document.dispatchEvent(
            new CustomEvent("cart:build", {
              detail: {
                product: product,
              },
            })
          );
        }
      }.bind(this)
    );
}

let checkInterval = setInterval(checkForElement, 500);
let checkIntervalISP = setInterval(checkForElementISP, 500);

function checkForElement() {
  if (
    $(".recently-viewed__section .grid-item").length > 0 ||
    $(".vendor-products__section .grid-item").length > 0
  ) {
    addChangeCartItem();

    clearInterval(checkInterval);

    $(".quick-product__btn").on("click", function () {
      console.log("quick add");
      $("body").removeClass("modal-frozen-product");
      $("body").addClass("modal-market-product");
      if ($(this).attr("data-is-frozen")) {
        var isFrozenValue = $(this).attr("data-is-frozen");
        console.log("Frozen: " + isFrozenValue);
        if (isFrozenValue === "true") {
          $("body").addClass("modal-frozen-product");
          $("body").removeClass("modal-market-product");
        }
      }
    });
  }
}

function checkForElementISP() {
  if ($(".isp_center_container .isp_grid_product").length > 0) {
    addChangeCartItem();

    clearInterval(checkIntervalISP);
  }
}

addChangeCartItem();
function addChangeCartItem() {
  $(".add-item-to-cart").on(
    "click",
    "button.qty-custom-add:first",
    async function () {
      let prodId = $(this).attr("data-prod-id");
      let prodHandle = $(this).attr("data-product-handle");

      let prodQty = 1;
      if (theme.settings.localization) {
        let checkZipCode = localStorage.getItem("zipcode");
        if (checkZipCode) {
          let productInventory = await availableInventory(prodId);
          if (
            (prodQty <= productInventory.availableQuantity &&
              productInventory.isInStock) ||
            prodHandle === "bokksu-digital-gift-card"
          ) {
            $(this).addClass("disable-div");
            addItem(this, prodId, prodQty);
          } else {
            alert(
              productInventory.availableQuantity
                ? `We can ship a maximum of ${productInventory.availableQuantity} ${prodTitle} to your zip code.`
                : `Item is out of stock at your location`
            );
          }
        } else {
          $(".zip-code-button").click();
        }
      } else {
        $(this).addClass("disable-div");
        addItem(this, prodId, prodQty);
      }

      $(".box-cart-main").addClass("hide-floating");
    }
  );
  //   function zipcodeOpen(e){
  //       console.log(e,"field")
  //      console.log(e,"field")
  //     $(".zip-code-modal").removeClass("is-hidden");
  //     $(".zip-code-modal").addClass("click-zip-code");
  //     $(".shop-frozen-popup-button1").addClass("is-hidden");
  //     $(".zip-code-form__submit-btn").removeClass("is-hidden");
  //     $(".zip-code__country-dropdown").removeClass("is-hidden");
  //     $(".zip-code-popup__error-message").addClass("is-hidden");
  //     $(".zip-code-form__input").css("border-color", "#444444");
  //     showUnitedStatesForm();
  // }
  $(".add-item-to-cart").on("click", ".qty-custom-minus", function () {
    let self = this;
    let prodId = $(this).attr("data-prod-id");
    let prodTitle = $(this).attr("data-product-name");
    let prodQty = parseInt($(this).attr("data-prod-qty"));
    let flag = true;
    if (theme.settings.localization) {
      let checkZipCode = localStorage.getItem("zipcode");
      if (checkZipCode) {
        $(".add-item-to-cart").addClass("disabled-span");
        $(".qty-custom-add").addClass("disabled-span");
        theme.cart.getCart().then(function (cart) {
          let items = cart.items;
          items.forEach(function (item) {
            if (item.variant_id == prodId) {
              flag = false;
              changeItem(self, prodId, item.quantity - 1);
            }
          });
          $("#quantity-notification").html("decrease quantity 1");
          if (flag) {
            changeItem(self, prodId, prodQty - 1);
          }
        });
      } else {
        $(".zip-code-button").click();
      }
    } else {
      $(".add-item-to-cart").addClass("disabled-span");
      $(".qty-custom-add").addClass("disabled-span");
      theme.cart.getCart().then(function (cart) {
        let items = cart.items;
        items.forEach(function (item) {
          if (item.variant_id == prodId) {
            flag = false;
            changeItem(self, prodId, item.quantity - 1);
          }
        });
        $("#quantity-notification").html("decrease quantity 1");
        if (flag) {
          changeItem(self, prodId, prodQty - 1);
        }
      });
    }

    $(".box-cart-main").addClass("hide-floating");
    setTimeout(() => {
      $(".add-item-to-cart").removeClass("disabled-span");
      $(".qty-custom-add").removeClass("disabled-span");
    }, 3000);
  });

  $(".add-item-to-cart").on("click", ".qty-custom-plus", async function () {
    let self = this;
    let prodId = $(this).attr("data-prod-id");
    let prodTitle = $(this).attr("data-product-name");

    let prodQty = parseInt($(this).attr("data-prod-qty"));
    let flag = true;

    if (theme.settings.localization) {
      let checkZipCode = localStorage.getItem("zipcode");
      if (checkZipCode) {
        let productInventory = await availableInventory(prodId);
        let quantity = prodQty + 1;
        if (
          quantity <= productInventory.availableQuantity &&
          productInventory.isInStock
        ) {
          $(".add-item-to-cart").addClass("disabled-span");
          $(".qty-custom-add").addClass("disabled-span");
          theme.cart.getCart().then(function (cart) {
            let items = cart.items;
            items.forEach(function (item) {
              if (item.variant_id == prodId) {
                flag = false;
                changeItem(self, prodId, item.quantity + 1);
              }
            });

            flag && changeItem(self, prodId, prodQty + 1);
          });
        } else {
          flag = false;
          alert(
            productInventory.availableQuantity
              ? `We can ship a maximum of ${productInventory.availableQuantity} ${prodTitle} to your zip code.`
              : `Item is out of stock at your location`
          );
        }
      } else {
        $(".zip-code-button").click();
      }
    } else {
      $(".add-item-to-cart").addClass("disabled-span");
      $(".qty-custom-add").addClass("disabled-span");
      theme.cart.getCart().then(function (cart) {
        let items = cart.items;
        items.forEach(function (item) {
          if (item.variant_id == prodId) {
            flag = false;
            changeItem(self, prodId, item.quantity + 1);
          }
        });

        flag && changeItem(self, prodId, prodQty + 1);
      });
    }

    $(".box-cart-main").addClass("hide-floating");

    setTimeout(() => {
      $(".add-item-to-cart").removeClass("disabled-span");
      $(".qty-custom-add").removeClass("disabled-span");
    }, 3000);
  });
}
function showHideCheckout(marketTotal, itemCount) {
  // document.getElementById("floating-progressbar").max = 49;
  // document.getElementById("floating-progressbar").value =
  //   marketTotal.toFixed(2);

  theme.cart.getCart().then(function (cart) {
    let items = cart.items;
    let giftCardsAmount = 0;

    items.forEach(function (item) {
      // Gift Cards Not count for GWP or Free Shipping (Gift Card Ids for Bokksu Market, Sugoi Mart & Bokksu Boutique)
      let giftCardVariantIds = [
        42232998396099, 42232998428867, 42232998461635, 42232998494403,
        41089417379939, 41089417412707, 41257333489862, 31963795554409,
        37660558459078, 37660558524614,
      ];

      if (giftCardVariantIds.includes(item.variant_id)) {
        giftCardsAmount += item.final_line_price;
      }
    });

    if (giftCardsAmount > 0) {
      giftCardsAmount = (giftCardsAmount / 100).toFixed(2);
    }

    let marketFreeShipping = 0;
    const marketShippingValue = $("body").attr("data-min-shipping");
    var amountCheckout = 30 - marketTotal;

    if (giftCardsAmount > 0) {
      marketFreeShipping =
        parseFloat(marketShippingValue) -
        parseFloat(marketTotal) +
        parseFloat(giftCardsAmount);
    } else {
      marketFreeShipping = marketShippingValue - marketTotal;
    }

    amountCheckout = amountCheckout.toFixed(2);
    marketFreeShipping = marketFreeShipping.toFixed(2);

    // $("#floating-shipping-text").html(
    //   `Add $${marketFreeShipping} for market free shipping`
    // );
    const checkOutContainer = $("#floating-checkout-btn");
    if (window.innerWidth < 768) {
      $("#subtotal-text-market").html("$" + marketTotal);
      if (marketTotal >= 30 && marketTotal < marketShippingValue) {
        $(".market-open-cart").hide();
        $(".market-goto-checkout").show();
        $(".floating-market-checkout-btn").html(
          `CHECKOUT | ${itemCount} ITEMS <br> <span id="market-shipping-font"> $${marketFreeShipping} TO FREE SHIPPING </span>`
        );
        $(".floating-market-checkout-btn").css({
          "letter-spacing": "4px",
          "line-height": "24px",
          "padding-top": "3px",
        });
      } else if (marketTotal >= marketShippingValue) {
        $(".market-open-cart").hide();
        $(".market-goto-checkout").show();
        // $("#floating-shipping-text").html(
        //   `Your Market Items Qualify For Free Shipping`
        // );
        $(".floating-market-checkout-btn").html(`CHECKOUT | FREE SHIPPPING `);
        $(".floating-market-checkout-btn").css("padding-top", "0");
      } else {
        $(".market-open-cart").show();
        $(".market-goto-checkout").hide();
        $(".floating-market-checkout-btn").html(`OPEN CART`);
        $(".floating-market-checkout-btn").css("padding-top", "0");
      }
      $(checkOutContainer).css({
        display: "block",
        bottom: "0",
      });
      let t = resetCheckout(checkOutContainer);
      $(".add-item-to-cart").click(function () {
        clearTimeout(t);
      });
    }
  });
}
function showHideFrozenCheckout(frozenTotal, itemCount) {
  const frozenShippingValue = $("body").attr("data-frozen-min-shipping");
  var frozenAmountCheckout = 30 - frozenTotal;
  var frozenFreeShipping = frozenShippingValue - frozenTotal;
  frozenAmountCheckout = frozenAmountCheckout.toFixed(2);
  frozenFreeShipping = frozenFreeShipping.toFixed(2);

  $("#cal-floating-frozen-shipping-text").html(
    `Add $${frozenFreeShipping} to frozen free shipping`
  );
  const checkOutContainer = $("#floating-frozen-checkout-btn");
  if (window.innerWidth < 768) {
    $("#subtotal-text-frozen").html("$" + frozenTotal);
    if (frozenTotal >= 30 && frozenTotal < frozenShippingValue) {
      $(".frozen-open-cart").hide();
      $(".frozen-goto-checkout").show();

      $(".floating-checkout-btn").html(
        `CHECKOUT | ${itemCount} ITEMS <br> <span>$${frozenFreeShipping} TO FREE SHIPPING</span> `
      );
      $(".floating-checkout-btn").css({
        "letter-spacing": "4px",
        "line-height": "24px",
        "padding-top": "3px",
      });
      // $('.collection-checkout-btn').prop('disabled',false)
    } else if (frozenTotal >= frozenShippingValue) {
      $(".frozen-open-cart").hide();
      $(".frozen-goto-checkout").show();
      $("#cal-floating-frozen-shipping-text").html(
        `Your Frozen Items Qualify For Free Shipping`
      );
      $(".floating-checkout-btn").html(`CHECKOUT | FREE SHIPPPING `);
      $(".floating-checkout-btn").css("padding-top", "0");
    } else {
      $(".frozen-open-cart").show();
      $(".frozen-goto-checkout").hide();

      $(".floating-checkout-btn").html(`OPEN CART`);
      $(".floatingcheckout-btn").css("padding-top", "0");
    }
    $(checkOutContainer).css({
      display: "block",
      bottom: "0",
    });
    let t = resetCheckout(checkOutContainer);
    $(".add-item-to-cart").click(function () {
      clearTimeout(t);
    });
  }
}

$(".market-open-cart,.cro-header-navigations #HeaderCartTrigger").on(
  "click",
  function () {
    theme.sizeDrawer();
    const headerCart = document.getElementById("HeaderCart");
    theme.utils.prepareTransition(headerCart, function () {
      headerCart.classList.add("is-active");
      headerCart.scrollTop = 0;
    });
    document.documentElement.classList.add("cart-open");
    // $("body").addClass("no-scroll");
    if (window.screen.width < 900) {
      // $("body").css({ overflowY: "hidden" });
    }
  }
);
$(".market-goto-checkout").on("click", function () {
  window.location.href = "/cart/checkout";
});
$(".frozen-open-cart").on("click", function () {
  theme.sizeDrawer();
  const headerCart = document.getElementById("HeaderCart");
  theme.utils.prepareTransition(headerCart, function () {
    headerCart.classList.add("is-active");
    headerCart.scrollTop = 0;
  });
  document.documentElement.classList.add("cart-open");
  // $("body").addClass("no-scroll");
  if (window.screen.width < 900) {
    // $("body").css({ overflowY: "hidden" });
  }
});
$(".frozen-goto-checkout").on("click", function () {
  window.location.href = "/cart/checkout";
});

function resetCheckout(element) {
  let t = setTimeout(() => {
    $(element).css("bottom", "-300px");
  }, 3000);
  return t;
}

$(".js-close-header-cart").click(function () {
  const config = {
    namespace: ".cart-header",
  };
  const headerCart = document.getElementById("HeaderCart");
  theme.utils.prepareTransition(headerCart, function () {
    headerCart.classList.remove("is-active");
  });

  window.off("keyup" + config.namespace);
  window.off("click" + config.namespace);
  document.documentElement.classList.remove("cart-open");
  // $("body").removeClass("no-scroll");
  // $("body").css({ overflowY: "auto" });
  config.cartOpen = false;
});
$(".listing-empty-cart a").click(function () {
  // $('.js-close-header-cart').trigger('click')
  $("#HeaderCart").hide();
  $(".empty-cart-design-main").hide();
  $(".customer-loved.customer-loved-v1").hide();
});
$(document).ready(function () {
  checkWindowScroll();
  setTimeout(() => {
    $("#show-credit-balance").click(function () {
      $(".section__content .Rise-page").toggle();
      //  $('.section__content .Rise-page').css('top','18em')
    });
  }, 1900);

  $(".cart__item-title > div:not([class])").remove();

  $(".quick-product__btn").on("click", function () {
    $("body").removeClass("modal-frozen-product");
    $("body").addClass("modal-market-product");
    if ($(this).attr("data-is-frozen")) {
      var isFrozenValue = $(this).attr("data-is-frozen");
      if (isFrozenValue === "true") {
        $("body").addClass("modal-frozen-product");
        $("body").removeClass("modal-market-product");
      }
    }
  });
});

function openCart() {
  if (window.screen.width > 767) {
    theme.sizeDrawer();
    const headerCart = document.getElementById("HeaderCart");
    theme.utils.prepareTransition(headerCart, function () {
      headerCart.classList.add("is-active");
      headerCart.scrollTop = 0;
    });
    document.documentElement.classList.add("cart-open");
    updateCartItems(null);
  }
}

const calculateTotal = (items) =>
  items.reduce((total, item) => total + item.price * item.quantity, 0);

function atcAndQtyButtonSwitch(data, action) {
  theme.cart.getCart().then(function (cart) {
    let items = cart.items;
    let matched = false;

    items.find(function (item) {
      if (item.discounts && item.discounts.length > 0) {
        let hasFreeGiftDiscount = item.discounts.some(function (discount) {
          return (
            discount.title === "Free Gift" &&
            discount.amount === item.original_price
          );
        });

        if (hasFreeGiftDiscount && item.variant_id == data.id) {
          matched = true;
          $(".cro-qty-wrapper").hide();
          $(".pdp-atc").show();
          $(".product_quantity").val(1);
        }
      }

      if (action === "remove") {
        if (item.variant_id == data) {
          $(".pdp-product-quantity").each(function (index) {
            if ($(this).attr("data-id") == item.variant_id) {
              $(this).val(item.quantity);
            }
          });
          console.log(item, "item");
        }
      }

      if (!matched) {
        $(".cro-qty-wrapper").show();
        $(".pdp-atc").hide();
      }
    });
  });
}

async function vendorInventories(prodIds) {
  let productIds = prodIds;
  let locationId = localStorage.getItem("locationId");
  if (locationId !== "undefined" && locationId !== "" && locationId !== null) {
    const inventoryLevels = await fetch(
      `https://inventory-location-1d178e8bce00.herokuapp.com/api/gridInventoryLevels?productId=${prodIds}&locationId=${locationId}&store=${storeUrl}`
    );
    const availableInventory = await inventoryLevels.json();
    return availableInventory;
  } else {
    return "Undefined Location Id";
  }
}

// Footer starts

// $(document).ready(function () {
//   if (window.innerWidth < 768) {
//     setTimeout(() => {
//       var button = $(".SGM .newsletter-subscription-btn  button");
//       var svgElement = $(
//         '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 5L19 12L12 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
//       );
//       button.html(svgElement);
//     }, 3000);
//   }
// });

// Footer ends

const addItemToCart = (variant_id, quantity) => {
  const addToCartUrl = "/cart/add.js";
  const data = {
    items: [
      {
        id: variant_id,
        quantity: quantity,
      },
    ],
  };

  fetch(addToCartUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok.");
      }
      return response.json();
    })
    .then((data) => {
      //console.log('Item added to cart:', data);
    })
    .catch((error) => {
      console.error("Error adding item to cart:", error);
    });
};

const checkMinBundleInCart = () => {
  checkCartAndUpdate();
};

function checkCartAndUpdate() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then(async (cart) => {
      let rebuyCount = 0;
      let itemsToProcess = [];

      cart.items.forEach((item) => {
        if (
          item.properties &&
          item.properties["_attribution"] === "Rebuy Dynamic Product Bundle"
        ) {
          rebuyCount++;
          itemsToProcess.push(item);
        }
      });

      if (rebuyCount > 0 && rebuyCount < 3) {
        await removeCartItemProperties(itemsToProcess);
        window.location.reload();
      }
    })
    .catch((error) => console.error("Error fetching cart:", error));
}

async function removeCartItemProperties(items) {
  try {
    const promises = items.map((item) => {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: item.key,
          properties: {
            _attribution: null,
          },
        }),
      })
        .then((response) => response.json())
        .catch((error) => console.error("Error updating cart:", error));
    });

    await Promise.all(promises);
  } catch (error) {
    console.error("Error removing cart item properties:", error);
  }
}

$(document).ready(function () {
  setTimeout(() => {
    if ($(".footer__section").hasClass("SGM")) {
      $("#HeaderWrapper").addClass("SGM");
    }
  }, 1000);
});

$(document).ready(function () {
  $("body").on("click", ".swatch-button,.swatch-view-item", async function () {
    let currentUrl = window.location.href;
    let value = $(this).data("value");
    currUrlArr = currentUrl.split("variant=");
    let selectedVariant = parseInt(currUrlArr[1]);
    let url = new URL(currentUrl);
    let params = new URLSearchParams(url.search);

    if (!params.has("variant") && value == "$30") {
      $(".add-to-cart").attr("data-variant-id", "43651109421209");
    } else {
      $(".add-to-cart").attr("data-variant-id", selectedVariant);
      $(".cro-pdp-updates button.pdp-qty").attr(
        "data-variant-id",
        selectedVariant
      );
      $(".js-qty__num").attr("data-id", selectedVariant);
      $(".js-qty__adjust").attr("data-variant-id", selectedVariant);
      const cart = await theme.cart.getCart();
      const isInCart = cart.items.some(
        (item) => item.variant_id === selectedVariant
      );
      const getItemCount = cart.items.find(
        (item) => item.variant_id === selectedVariant
      );

      $(".cro-pdp-updates input").val(getItemCount?.quantity || 1);
      $(".product_quantity").val(getItemCount?.quantity || 1);
      $(".pdp-product-quantity").val(getItemCount?.quantity || 1);
      $(".cro-pdp-updates button.add-to-cart").toggle(!isInCart);
      $(".cro-pdp-updates .js-qty__wrapper.qty-wrapper.cro-qty-wrapper").toggle(
        isInCart
      );
    }



  });

  const productSku = $("#product-sku").html();

  if (productSku && productSku.startsWith("FZ")) {
    $("#marketShipping").hide();
    $("#frozenShipping").show();
  } else {
    $("#marketShipping").show();
    $("#frozenShipping").hide();
  }

  // },2000)
  $(".sn-common.sn-style-big.sn-bottom-left.sn-bottom-to-top.sn-activated").css(
    "z-index",
    1
  );
});

document.addEventListener("DOMContentLoaded", function () {
  var scrollableGrids = document.querySelectorAll(".scrollable-grid--small");
  scrollableGrids.forEach(function (grid) {
    var productCount = grid.querySelectorAll(".grid-item").length;
    if (productCount === 5) {
      grid.classList.add("scrollable-grid--small-main");
      var gridItems = grid.querySelectorAll(".grid-item");
      gridItems.forEach(function (item) {
        item.style.setProperty("max-width", "unset", "important");
      });
    }

    if (productCount <= 4) {
      var gridItems = grid.querySelectorAll(".grid-item");
      gridItems.forEach(function (item) {
        item.classList.add("grid-item-main");
      });
    }
  });
});

// Function to cart savings

function processCart() {
  let total_saving = 0;
  document.querySelectorAll(".cart__item").forEach((item) => {
    const compareAtPrice =
      parseFloat(item.getAttribute("data-compare-at-price")) / 100;
    const price = parseFloat(item.getAttribute("data-price")) / 100;
    const quantity = parseInt(item.getAttribute("data-quantity")); // Adjusted to get quantity from data attribute

    if (compareAtPrice > price) {
      let saving = (compareAtPrice - price) * quantity;
      total_saving += saving;
    }
  });

  if (total_saving > 0) {
    document.querySelector(".cart_savings").classList.remove("d-none");
    document.querySelector(".cart_savings_amount").classList.remove("d-none");

    document.querySelector(".cart_savings_amount").textContent =
      theme.Currency.formatMoney(
        total_saving * 100,
        theme.settings.moneyFormat
      ); // Convert dollars to cents for formatting
  } else {
    document.querySelector(".cart_savings").classList.add("d-none");
  }
}

// Function to update cart item attributes
function updateCartItems(cart) {
  if (cart == null) {
    setTimeout(function () {
      theme.cart.getCart().then(function (cart) {
        cart.items.forEach((item) => {
          const cartItemElement = document.querySelector(
            `.cart__item[data-key="${item.key}"]`
          );
          if (cartItemElement) {
            cartItemElement.setAttribute("data-quantity", item.quantity); // Update the quantity in the HTML
          }
        });
      });
      processCart();
    }, 1000);
  } else {
    cart.items.forEach((item) => {
      const cartItemElement = document.querySelector(
        `.cart__item[data-key="${item.key}"]`
      );
      if (cartItemElement) {
        cartItemElement.setAttribute("data-quantity", item.quantity); // Update the quantity in the HTML
      }
    });
    processCart();
  }
}


// Shogun workaround to make cart update work
document.querySelectorAll('.rca-add-to-cart-submit a').forEach(anchor => {
  anchor.addEventListener('click', function(event) {    
    setTimeout(function() {
      document.dispatchEvent(new CustomEvent("cart:build"));      
    }, 1300);    
  });
})